import { SvgIcon } from "@mui/material";

export const ToMa = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 46 54"}>
      <g id="Layer">
        <g id="Layer_1">
          <path
            id="Layer"
            d="m44.58 4.3l-5.14 2.88l-5.15-2.88l5.15-2.87l5.14 2.87v0z"
          />
          <path id="Layer" d="m34.29 4.3l5.14 2.88v5.93l-5.14-2.88v-5.93v0z" />
          <path id="Layer" d="m44.58 4.3v5.93l-5.15 2.88v-5.93l5.15-2.88v0z" />
          <path
            id="Layer"
            d="m20 26.53c0.05-0.15 0.19-0.3 0.62-0.52c0.86-0.43 2.11-0.64 2.25-1.12c0.14-0.48 1.1-1.43 1.27-2.17c0.17-0.74 0.47-2 0.47-2c0.59 0.11 1.19-0.48 1.54-0.2c0.35 0.28-0.07 0.7 0.53 1.15c0.6 0.45 1.21 0.54 1.56 0.24c0.35-0.3 1 0 1.3 0.17c0.3 0.17 0.39-0.82 0.71-0.65c0.32 0.17 0.11 0.54 0.48 0.68c0.37 0.14 0.44-0.4 0.74 0c0.3 0.4 1.27 0.89 1.41 1.67c0.14 0.78 0 2.9 0.48 3.28c0.48 0.38 0.91 0.54 0.88 1c-0.03 0.46-0.15 0.34-0.1 0.7c0.05 0.36 0.37 0.52-0.19 0.59c-0.56 0.07-1.43-0.46-1.65-0.12c-0.22 0.34-0.77 0.05-1 0.12c-0.23 0.07-0.57 0-0.5 0.4c0.07 0.4-1.93 1.1-1.65 1.35c0.28 0.25 0.32 0.26 0.34 0.48c-0.03 0.11-0.07 0.21-0.12 0.31c-0.05 0.1-0.1 0.2-0.15 0.29c-0.06 0.09-0.12 0.19-0.19 0.27c-0.07 0.09-0.14 0.17-0.22 0.25c-0.2 0.17-0.44-0.11-0.75 0.17c-0.31 0.28-2.45 1.51-2.61 2.47c-0.07-0.03-0.14-0.06-0.21-0.08c-0.07-0.02-0.15-0.04-0.22-0.05c-0.08-0.01-0.15-0.02-0.23-0.01c-0.08 0-0.15 0.01-0.23 0.02c-0.38 0.1-0.66-0.41-1-0.2c-0.34 0.21-1 0-1.24 0.14c-0.24 0.14-2.73 1.72-2.73 1.72l-0.25 6h-6.43v5.12c0 0-2.52 0.45-2.73 1.5c-0.03 0.27-0.05 0.54-0.07 0.8c-0.01 0.27-0.02 0.54-0.02 0.81c0 0.27 0.01 0.54 0.02 0.81c0.01 0.27 0.04 0.54 0.07 0.8l-8.1-0.56v1c0 0-0.75 0.65-1 0c-0.25-0.65 0.53-3.24 1.55-3.48c1.02-0.24 1-2.63 1.47-3.13c0.47-0.5 2.36-1.48 2.36-2c0-0.52-0.13-1.1 0.14-1.34c0.11-0.12 0.21-0.25 0.31-0.39c0.1-0.13 0.19-0.27 0.27-0.41c0.08-0.14 0.16-0.29 0.23-0.44c0.07-0.15 0.13-0.3 0.19-0.45c0-0.38 0.24-0.27 0.91-0.62c0.21-0.19 0.42-0.4 0.61-0.61c0.19-0.21 0.38-0.43 0.55-0.66c0.17-0.23 0.34-0.47 0.49-0.71c0.15-0.24 0.29-0.49 0.42-0.75c0.32-0.59 0.07-0.59 0.83-0.54c0.29-0.02 0.57-0.06 0.85-0.11c0.28-0.05 0.56-0.12 0.83-0.21c0.27-0.08 0.54-0.18 0.81-0.3c0.26-0.11 0.52-0.24 0.77-0.38"
          />
          <path
            fill="#20AAE2"
            id="Layer"
            d="m20.65 31.23h1.7l-5.82 8l-5.82-8h1.9c-0.53-21.39 19.09-20.52 19.09-20.52c-15.76 9.11-11.05 20.52-11.05 20.52z"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export const AddChat = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 24 24"}>
      <path
        d="M15 11H13V9C13 8.73478 12.8946 8.48043 12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289C11.1054 8.48043 11 8.73478 11 9V11H9C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12C8 12.2652 8.10536 12.5196 8.29289 12.7071C8.48043 12.8946 8.73478 13 9 13H11V15C11 15.2652 11.1054 15.5196 11.2929 15.7071C11.4804 15.8946 11.7348 16 12 16C12.2652 16 12.5196 15.8946 12.7071 15.7071C12.8946 15.5196 13 15.2652 13 15V13H15C15.2652 13 15.5196 12.8946 15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929C15.5196 11.1054 15.2652 11 15 11Z"
        fill="#FF5656"
      />
      <path
        d="M12 2C10.1074 2.00016 8.25372 2.53734 6.6543 3.54913C5.05488 4.56092 3.77539 6.00578 2.96449 7.71584C2.15358 9.42591 1.84456 11.331 2.07333 13.2097C2.3021 15.0884 3.05926 16.8636 4.25684 18.3291L2.293 20.293C2.15315 20.4328 2.0579 20.611 2.01931 20.805C1.98072 20.9989 2.00051 21.2 2.07619 21.3827C2.15186 21.5654 2.28003 21.7216 2.44446 21.8315C2.6089 21.9414 2.80223 22 3 22H12C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2V2ZM15 13H13V15C13 15.2652 12.8946 15.5196 12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071C11.1054 15.5196 11 15.2652 11 15V13H9C8.73478 13 8.48043 12.8946 8.29289 12.7071C8.10536 12.5196 8 12.2652 8 12C8 11.7348 8.10536 11.4804 8.29289 11.2929C8.48043 11.1054 8.73478 11 9 11H11V9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9V11H15C15.2652 11 15.5196 11.1054 15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12C16 12.2652 15.8946 12.5196 15.7071 12.7071C15.5196 12.8946 15.2652 13 15 13Z"
        fill="#ff5656ad"
      />
    </SvgIcon>
  );
};

export const AutoWight = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 1690 1414"}>
      <g clipPath="url(#clip0_2_2)">
        <path
          d="M11.7 901.8C28.3 879.067 55.4667 867.233 93.2 866.3L722.1 460.4C802.3 395.267 877.5 395.267 947.7 460.4L1629.2 811.2C1656.5 839.9 1660.2 806.6 1670.4 823.7C1706.47 883.567 1692.73 927 1629.2 954L1005.3 1380C915.1 1425.13 824.9 1425.13 734.7 1380L68.1 1049.2C17.0334 1023.87 -1.76664 974.733 11.7 901.8V901.8Z"
          fill="#FF5656"
        />
        <path
          d="M93.2 808.7L722.1 402.8C802.3 337.6 877.5 337.6 947.7 402.8L1629.2 753.6C1691.07 818.733 1691.07 866.333 1629.2 896.4L1005.3 1322.4C915.1 1367.47 824.9 1367.47 734.7 1322.4L68.1 991.6C-29.5 943.133 -21.1333 882.167 93.2 808.7V808.7Z"
          fill="#EDF3F6"
        />
        <path d="M1112.5 679.8H1104.8V162.8H1112.5V679.8Z" fill="#CCD1DC" />
        <path d="M1127.4 679.8H1112.5V162.8H1127.4V679.8Z" fill="#A6B9CC" />
        <path d="M1138.6 679.8H1127.4V162.8H1138.6V679.8Z" fill="#70838D" />
        <path
          d="M1286.1 150.5C1286.1 157.2 1280.6 162.8 1273.8 162.8H1003.4C996.6 162.8 991.1 157.2 991.1 150.5V12.9C991.1 6.09997 996.6 0.599976 1003.4 0.599976H1273.8C1280.6 0.599976 1286.1 6.09997 1286.1 12.9V150.5Z"
          fill="#495052"
        />
        <path
          d="M1260 150.5C1260 157.2 1254.5 162.8 1247.7 162.8H977.3C970.5 162.8 965 157.2 965 150.5V12.9C965 6.09997 970.5 0.599976 977.3 0.599976H1247.7C1254.5 0.599976 1260 6.09997 1260 12.9V150.5Z"
          fill="#5E6B6C"
        />
        <path d="M1003.4 148.9H979.6V126.6H1003.4V148.9Z" fill="#D0E1E5" />
        <path d="M1040.3 148.9H1016.5V126.6H1040.3V148.9Z" fill="#D0E1E5" />
        <path d="M1077.1 148.9H1053.3V126.6H1077.1V148.9Z" fill="#D0E1E5" />
        <path d="M1114 148.9H1090.2V126.6H1114V148.9Z" fill="#D0E1E5" />
        <path d="M1150.9 148.9H1127.1V126.6H1150.9V148.9Z" fill="#79B315" />
        <path d="M1187.8 148.9H1164V126.6H1187.8V148.9Z" fill="#EA7F25" />
        <path d="M1245.4 148.9H1200.8V126.6H1245.4V148.9Z" fill="#F45940" />
        <path d="M1240 102.1H984.2V19.1H1240V102.1Z" fill="#1D2326" />
        <g>
          <path id="price" d="M1240 102.1H992V26H1240V102.1Z" fill="#333C3D" />
          <text
            textAnchor="middle"
            fill="white"
            fontSize="50px"
            fontFamily="Arial"
            dy="75px"
            dx="1120px"
          >
            {props.price}€/Kg
          </text>
        </g>
        <path d="M1210.3 737.6H449.2V715.2H1210.3V737.6Z" fill="#697E89" />
        <path d="M501.4 861.1V808.9H559.8L535.2 861.1H501.4Z" fill="#2D3134" />
        <path d="M1134 861.1L1109.4 808.9H1167.8V861.1H1134Z" fill="#2D3134" />
        <path d="M1254.4 716.7H379.5V679.8H1254.4V716.7Z" fill="#B6C9D7" />
        <path d="M1254.4 824.3H379.5V733.1H1254.4V824.3Z" fill="#A5B3BE" />
        <path d="M1314.8 824.3H1254.4V733.1H1314.8V824.3Z" fill="#818C93" />
        <path d="M1314.8 716.7H1254.4V679.8H1314.8V716.7Z" fill="#818C93" />
        <path d="M610 1049.5H337.6V777.5H610V1049.5Z" fill="#B88B4F" />
        <path d="M496.8 1049.5H224.4V777.5H496.8V1049.5Z" fill="#E1B785" />
        <path d="M564.5 882.2H541.5V777.5H564.5V882.2Z" fill="#AF7D42" />
        <path d="M291.5 1032.6H244.1V996H291.5V1032.6Z" fill="#FAFDFA" />
        <path d="M296.1 829.9H238.8V793.9H296.1V829.9Z" fill="#FDF4E7" />
        <path d="M291.5 822.1H244.1V801.4H291.5V822.1Z" fill="#3A3735" />
        <g opacity="0.3">
          <path
            opacity="0.3"
            d="M923.7 677C923.7 681.1 920.3 684.5 916.1 684.5H591.4C587.2 684.5 583.8 681.1 583.8 677C583.8 672.8 587.2 669.4 591.4 669.4H916.1C920.3 669.4 923.7 672.8 923.7 677V677Z"
            fill="#282538"
          />
        </g>
        <path
          d="M808.8 47.6V58.2H782.7C771.7 58.2 763 50.5 749.6 50.5C736.1 50.5 727.8 58.2 716.5 58.2H690.3V47.6H808.8Z"
          fill="#D8D8DA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M811.3 50.1V483.7C811.3 491.4 805.1 497.7 797.3 497.7H702.9C695.2 497.7 689 491.4 689 483.7V50.1C689 42.4 695.2 36.1 702.9 36.1H797.3C805.1 36.1 811.3 42.4 811.3 50.1V50.1ZM800.8 50.1C800.8 48.2 799.3 46.6 797.3 46.6H702.9C701 46.6 699.4 48.2 699.4 50.1V483.7C699.4 485.6 701 487.2 702.9 487.2H797.3C799.3 487.2 800.8 485.6 800.8 483.7V50.1Z"
          fill="#BDAAA6"
        />
        <path
          d="M908.4 373.7H911.6C920.6 373.7 927.9 381 927.9 390V466.1C927.9 475.1 920.6 482.4 911.6 482.4H908.4V373.7Z"
          fill="#282538"
        />
        <path
          d="M696.2 163.4V160.1C696.2 151.1 703.5 143.8 712.5 143.8H788.6C797.6 143.8 804.9 151.1 804.9 160.1V163.4H696.2Z"
          fill="#282538"
        />
        <path
          d="M687.6 52V47.6C687.6 35.7 696.1 26 706.5 26H794.6C805 26 813.5 35.7 813.5 47.6V52H687.6Z"
          fill="#282538"
        />
        <path
          d="M649.6 673.9C649.6 676.6 647.5 678.7 644.8 678.7H625.2C622.5 678.7 620.4 676.6 620.4 673.9V617.5C620.4 614.8 622.5 612.6 625.2 612.6H644.8C647.5 612.6 649.6 614.8 649.6 617.5V673.9Z"
          fill="#282538"
        />
        <path
          d="M881.2 673.9C881.2 676.6 879 678.7 876.4 678.7H856.8C854.1 678.7 851.9 676.6 851.9 673.9V617.5C851.9 614.8 854.1 612.6 856.8 612.6H876.4C879 612.6 881.2 614.8 881.2 617.5V673.9Z"
          fill="#282538"
        />
        <path
          d="M901.4 659.7H600.2C591.2 659.7 583.9 652.4 583.9 643.4V275.1C583.9 212.1 635 161 698 161H803.6C866.6 161 917.7 212.1 917.7 275.1V643.4C917.7 652.4 910.4 659.7 901.4 659.7V659.7Z"
          fill="#5A9AA4"
        />
        <path
          d="M602.4 364.7V282.9C602.4 232.1 644 190.8 695.2 190.8H806.4C857.5 190.8 899.1 232.1 899.1 282.9V364.7H602.4Z"
          fill="#418C96"
        />
        <path
          d="M610 353.3V275.1C610 226.6 649.5 187.1 698 187.1H803.6C852.1 187.1 891.6 226.6 891.6 275.1V353.3H610Z"
          fill="#6EBEC5"
        />
        <path
          d="M623.1 272.4C624.5 232.3 657.6 200.1 698 200.1H803.6C844 200.1 877 232.3 878.5 272.4H875.2C873.8 234.1 842.2 203.4 803.6 203.4H698C659.4 203.4 627.8 234.1 626.4 272.4H623.1Z"
          fill="#D8D8DA"
        />
        <path
          d="M891.6 373.6L897.2 645.4H604.3L610 373.6H891.6Z"
          fill="#418C96"
        />
        <path d="M891.6 373.6V633.6H610V373.6H891.6Z" fill="#6EBEC5" />
        <path
          d="M625.9 661.5H598.1C588.9 661.5 581.5 654.1 581.5 644.9V617.1L625.9 661.5Z"
          fill="#3A4151"
        />
        <path
          d="M920 617.1V644.9C920 654.1 912.6 661.5 903.5 661.5H875.6L920 617.1Z"
          fill="#3A4151"
        />
        <path d="M878.2 425.1H625V420.6H878.2V425.1Z" fill="#D8D8DA" />
        <path
          d="M623.1 438.1L624.7 426.2H623.4V419.1H629.9V426.2H628.5L630.1 438.1H623.1Z"
          fill="#545460"
        />
        <path d="M623.8 425.6V419.8H629.5L623.8 425.6Z" fill="#D8D8DA" />
        <path
          d="M621.5 286.8L623.1 275H621.7V267.9H628.2V275H626.9L628.5 286.8H621.5Z"
          fill="#545460"
        />
        <path d="M622.1 274.3V268.5H627.8L622.1 274.3Z" fill="#D8D8DA" />
        <g opacity="0.2">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M669.3 314.8C663.5 315.5 658.2 311.5 657.5 305.7L651.2 256.7C650.5 251 654.5 245.7 660.3 245L709.3 238.7C715 238 720.3 242 721 247.8L727.3 296.7C728 302.5 724 307.8 718.2 308.5L669.3 314.8ZM716.6 297.8L710.4 249.5L662.1 255.7L668.3 304L716.6 297.8Z"
            fill="#132942"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M667.8 313.1C662 313.8 656.7 309.7 656 304L649.7 255C649 249.3 653.1 244 658.8 243.3L707.8 237C713.5 236.2 718.8 240.3 719.5 246.1L725.8 295C726.5 300.8 722.5 306 716.7 306.8L667.8 313.1ZM715.1 296.1L708.9 247.8L660.6 254L666.8 302.3L715.1 296.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M716 301.4L667.1 307.7C664.3 308.1 661.7 306.1 661.4 303.3L655.1 254.3C654.7 251.6 656.7 249 659.5 248.7L708.5 242.4C711.2 242 713.8 244 714.1 246.8L720.4 295.7C720.8 298.5 718.8 301 716 301.4Z"
          fill="#75AFCC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M716.2 302.4L667.2 308.7C663.9 309.1 660.8 306.8 660.4 303.4L654.1 254.5C653.7 251.1 656 248.1 659.4 247.6L708.3 241.4C711.7 240.9 714.7 243.3 715.2 246.6L721.4 295.6C721.9 298.9 719.5 302 716.2 302.4ZM659.6 249.7C657.4 249.9 655.8 252 656.1 254.2L662.4 303.2C662.7 305.4 664.7 307 666.9 306.7L715.9 300.4C718.1 300.1 719.7 298.1 719.4 295.8L713.1 246.9C712.8 244.7 710.8 243.1 708.6 243.4L659.6 249.7Z"
          fill="#132942"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M672.8 298.4L672.4 297L671.1 297.2V298.6L670.3 298.7L670.4 289.9L671.4 289.8L673.6 298.3L672.8 298.4ZM672.2 296.3C672.067 295.567 671.9 294.833 671.7 294.1C671.5 293.367 671.3 292.633 671.1 291.9C671.1 292.633 671.1 293.4 671.1 294.2C671.1 294.933 671.1 295.667 671.1 296.4L672.2 296.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M675.4 298.1L674.3 289.4L675.1 289.3L676.2 298L675.4 298.1Z"
          fill="#F7F5E8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M680.3 297.4C680.167 296.733 680 296.1 679.8 295.5C679.6 294.9 679.4 294.267 679.2 293.6C679.2 293.6 679.167 293.6 679.1 293.6C679.1 293.6 679.067 293.6 679 293.6L678.6 293.7L679.1 297.6L678.3 297.7L677.2 289L678.5 288.9C679.033 288.833 679.433 288.9 679.7 289.1C679.967 289.3 680.133 289.667 680.2 290.2L680.4 292C680.533 292.6 680.4 293.033 680 293.3C680.2 293.967 680.4 294.633 680.6 295.3C680.8 295.967 681 296.633 681.2 297.3L680.3 297.4ZM679.4 290.4C679.333 290.133 679.267 289.933 679.2 289.8C679.067 289.667 678.867 289.633 678.6 289.7H678.1L678.5 292.9H679C679.267 292.833 679.433 292.733 679.5 292.6C679.567 292.467 679.6 292.3 679.6 292.1L679.4 290.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M686.5 296.7L685.4 288.8L684.5 288.9L684.4 288.1L687.1 287.8L687.2 288.6L686.2 288.7L687.2 296.6L686.5 296.7Z"
          fill="#F7F5E8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M692 295.9C691.867 295.233 691.7 294.6 691.5 294C691.3 293.4 691.1 292.767 690.9 292.1C690.9 292.1 690.867 292.1 690.8 292.1C690.8 292.1 690.767 292.1 690.7 292.1L690.3 292.2L690.8 296.1L690 296.2L688.9 287.5L690.2 287.4C690.733 287.333 691.133 287.4 691.4 287.6C691.667 287.8 691.833 288.167 691.9 288.7L692.1 290.5C692.167 291.1 692 291.533 691.6 291.8C691.867 292.467 692.1 293.133 692.3 293.8C692.5 294.467 692.7 295.133 692.9 295.8L692 295.9ZM691.1 288.9C691.033 288.633 690.967 288.433 690.9 288.3C690.767 288.167 690.567 288.133 690.3 288.2H689.8L690.2 291.4H690.7C690.967 291.333 691.133 291.233 691.2 291.1C691.267 290.967 691.3 290.8 691.3 290.6L691.1 288.9Z"
          fill="#F7F5E8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M696.9 295.3L696.6 293.9L695.3 294.1V295.5L694.5 295.6L694.6 286.8L695.5 286.7L697.8 295.2L696.9 295.3ZM696.3 293.2C696.1 292.467 695.9 291.733 695.7 291C695.5 290.267 695.333 289.533 695.2 288.8C695.2 289.533 695.2 290.3 695.2 291.1C695.2 291.833 695.2 292.567 695.2 293.3L696.3 293.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M700.1 294.9L697.9 286.4L698.8 286.3C698.867 286.633 698.967 287.033 699.1 287.5C699.167 287.967 699.267 288.433 699.4 288.9C699.533 289.367 699.667 289.833 699.8 290.3C699.867 290.833 699.967 291.3 700.1 291.7C700.167 292.1 700.233 292.467 700.3 292.8C700.367 293.133 700.433 293.367 700.5 293.5C700.5 293.3 700.5 293.067 700.5 292.8C700.5 292.467 700.5 292.067 700.5 291.6C700.433 291.2 700.4 290.767 700.4 290.3C700.4 289.767 700.4 289.267 700.4 288.8C700.4 288.267 700.4 287.767 700.4 287.3C700.4 286.833 700.4 286.4 700.4 286L701.2 285.9V294.8L700.1 294.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M704.1 294.4L703 285.7L705.3 285.4L705.4 286.2L703.9 286.4L704.3 289.5L705.4 289.3L705.5 290.1L704.4 290.3L704.8 293.5L706.4 293.3L706.5 294.1L704.1 294.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M708.4 293.9L707.2 285.2L708 285.1L709.1 293L710.6 292.8L710.7 293.5L708.4 293.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M713.7 297.9L709.8 298.4V297.7L713.6 297.2C713.667 297.2 713.7 297.2 713.7 297.2L713.9 297.9C713.833 297.9 713.767 297.9 713.7 297.9ZM708.2 298.6L704.2 299.1L704.1 298.4L708.1 297.9L708.2 298.6ZM702.5 299.3L698.5 299.9L698.4 299.2L702.4 298.7L702.5 299.3ZM696.9 300L692.9 300.5L692.8 299.8L696.8 299.3L696.9 300ZM691.2 300.8L687.2 301.3L687.1 300.6L691.1 300.1L691.2 300.8ZM685.5 301.5L681.5 302L681.4 301.4L685.5 300.8V301.5ZM679.8 302.3L675.8 302.8L675.7 302.1L679.7 301.6L679.8 302.3ZM674.1 303L670.1 303.5L670 302.9L674 302.4L674.1 303ZM668.5 303.7H668.4C666.9 303.9 665.4 302.9 665 301.4L665.7 301.2C666 302.4 667.1 303.2 668.4 303L668.5 303.7ZM715.5 297L715 296.5C715.6 296 715.8 295.2 715.7 294.5L715.6 293L716.2 292.9L716.4 294.4C716.5 295.4 716.2 296.3 715.5 297V297ZM665.4 299.6L664.7 299.7L664.2 295.7L664.9 295.6L665.4 299.6ZM716 291.3L715.3 291.4L714.8 287.4L715.5 287.3L716 291.3ZM664.7 293.9L664 294L663.5 290L664.1 289.9L664.7 293.9ZM715.4 285.6L714.7 285.7L714.2 281.7L714.8 281.6L715.4 285.6ZM664.1 288.3H663.4L662.9 284.3H663.6L664.1 288.3ZM714.7 279.9L714 280L713.5 276L714.2 275.9L714.7 279.9ZM663.3 282.6L662.7 282.7L662.2 278.7L662.8 278.6L663.3 282.6ZM713.9 274.2L713.3 274.3L712.8 270.3L713.4 270.2L713.9 274.2ZM662.6 276.9L661.9 277L661.4 273L662.1 272.9L662.6 276.9ZM713.2 268.5L712.5 268.6L712 264.6L712.7 264.5L713.2 268.5ZM661.8 271.2L661.2 271.3L660.6 267.3L661.3 267.2L661.8 271.2ZM712.4 262.9L711.8 263L711.2 258.9H711.9L712.4 262.9ZM661.1 265.5L660.4 265.6L659.9 261.6L660.6 261.5L661.1 265.5ZM711.7 257.2L711 257.3L710.5 253.3L711.2 253.2L711.7 257.2ZM660.3 259.9H659.6L659.1 255.9H659.8L660.3 259.9ZM710.9 251.5L710.2 251.6L709.9 249.2C709.833 248.667 709.667 248.233 709.4 247.9L709.9 247.5C710.3 247.9 710.5 248.5 710.6 249.1L710.9 251.5ZM659.9 254.3L659.3 254.1C659.7 253 660.7 252.3 661.8 252.1L662.8 252L662.9 252.6L661.9 252.8C661 252.9 660.2 253.5 659.9 254.3ZM708.2 247C707.867 246.933 707.5 246.933 707.1 247L704.3 247.3L704.2 246.7L707 246.3C707.467 246.233 707.9 246.267 708.3 246.4L708.2 247ZM702.7 247.5L698.7 248L698.6 247.3L702.6 246.8L702.7 247.5ZM697.1 248.3L693.1 248.8L693 248.1L697 247.6L697.1 248.3ZM691.4 249L687.4 249.5L687.3 248.9L691.3 248.3L691.4 249ZM685.7 249.8L681.7 250.3L681.6 249.6L685.7 249.1V249.8ZM680 250.5L676 251L675.9 250.4L679.9 249.9L680 250.5ZM674.3 251.2L670.3 251.7L670.2 251L674.2 250.5L674.3 251.2ZM668.7 251.9L664.7 252.4L664.6 251.8L668.6 251.3L668.7 251.9Z"
          fill="#F7F5E8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M683.5 284C682 284.2 680.5 283.5 679.7 282.2L678.4 280.1L676.1 279.4C674.9 279 673.9 278.1 673.5 276.8C673.1 275.6 673.3 274.3 674.1 273.2C674.8 272.4 675.7 271.9 676.7 271.8C677.033 271.733 677.333 271.7 677.6 271.7L679.2 271.9L681.7 268.1L677.6 266.9C676.4 266.5 675.4 265.5 675 264.3C674.6 263.1 674.8 261.7 675.6 260.7L676.3 259.8C677 259 677.9 258.4 678.9 258.3C679.233 258.3 679.533 258.3 679.8 258.3L687.7 259L689.7 256C690.2 255.2 691 254.6 691.8 254.4L695 253.4C695.2 253.4 695.4 253.367 695.6 253.3C696.7 253.2 697.9 253.5 698.7 254.3C699.6 255.1 700 256.2 700 257.3L699.9 260.6C699.9 261.5 699.5 262.4 698.9 263.1L696.5 265.8L699.1 273.2C699.6 274.5 699.4 275.9 698.6 277L697.8 277.9C697.2 278.7 696.3 279.2 695.3 279.4C693.7 279.6 692.2 278.8 691.4 277.5L689.2 273.9L686.2 277.3L686.7 278.8C687.2 280.1 686.9 281.4 686.1 282.5C685.5 283.3 684.6 283.9 683.5 284V284ZM677 273.8C676.5 273.8 676 274.1 675.7 274.5C675.4 275 675.2 275.6 675.4 276.2C675.6 276.8 676.1 277.3 676.7 277.4L679.7 278.4L681.4 281.1C681.8 281.7 682.5 282.1 683.3 282C683.8 281.9 684.2 281.7 684.5 281.3C684.9 280.8 685 280.1 684.8 279.5L683.8 276.8L689.5 270.5L693.2 276.5C693.5 277.1 694.3 277.4 695 277.4C695.5 277.3 695.9 277 696.2 276.6L697 275.7C697.3 275.2 697.5 274.5 697.2 273.9L694.1 265.3L697.4 261.7C697.7 261.4 697.9 261 697.9 260.5L698 257.2C698 256.7 697.8 256.2 697.4 255.8C696.9 255.4 696.2 255.2 695.6 255.4L692.4 256.3C692 256.4 691.6 256.7 691.4 257.1L688.7 261.2L679.6 260.3C679 260.3 678.3 260.5 678 261L677.2 262C676.9 262.5 676.8 263.1 676.9 263.7C677.1 264.3 677.6 264.7 678.2 264.9L684.9 266.9L680.2 274L677.4 273.8C677.267 273.8 677.133 273.8 677 273.8V273.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M697 257.2L696.9 260.5C696.833 260.7 696.733 260.867 696.6 261L693 265.1L696.3 274.3C696.4 274.6 696.3 274.9 696.1 275.1L695.4 276C695.1 276.5 694.3 276.5 694 275.9L689.7 268.8L682.7 276.6L683.8 279.8C683.9 280.1 683.9 280.4 683.7 280.6C683.3 281.1 682.6 281.1 682.3 280.6L680.7 278C680.633 277.867 680.6 277.733 680.6 277.6L680.2 277.4C680.133 277.4 680.033 277.367 679.9 277.3L677 276.5C676.4 276.3 676.2 275.6 676.5 275.1C676.7 274.9 677 274.8 677.3 274.8L680.7 275.1L686.5 266.4L678.5 263.9C677.9 263.8 677.7 263.1 678 262.6L678.8 261.7C678.9 261.4 679.2 261.3 679.5 261.3L689.2 262.2L692.2 257.6C692.333 257.467 692.5 257.367 692.7 257.3L695.9 256.4C696.4 256.2 697 256.6 697 257.2Z"
          fill="#F7F5E8"
        />
        <g opacity="0.2">
          <path
            d="M750.8 292.4C743.3 291.2 738.1 284.1 739.2 276.6L746.3 230.6C747.5 223.1 754.6 217.9 762.1 219L837 230.6C844.6 231.8 849.8 238.9 848.6 246.4L841.5 292.4C840.4 299.9 833.3 305.1 825.7 303.9L750.8 292.4Z"
            fill="#132942"
          />
        </g>
        <path
          d="M749.8 290.2C742.3 289 737.1 281.9 738.2 274.4L745.3 228.4C746.5 220.9 753.6 215.7 761.1 216.9L836 228.4C843.6 229.6 848.8 236.7 847.6 244.2L840.5 290.2C839.3 297.7 832.2 302.9 824.7 301.7L749.8 290.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M823.9 296.9L752 285.8C746.2 284.9 742.2 279.4 743.1 273.6L749.7 230.6C750.6 224.8 756.1 220.8 761.9 221.7L833.8 232.8C839.6 233.7 843.6 239.2 842.7 245L836.1 287.9C835.2 293.8 829.7 297.8 823.9 296.9V296.9Z"
          fill="#F7F5E8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M842.9 243.5L835.9 289.4C835.1 294.4 830.4 297.9 825.4 297.1L750.5 285.5C745.5 284.8 742.1 280.1 742.9 275.1L750 229.1C750.7 224.1 755.4 220.7 760.4 221.5L835.3 233.1C840.3 233.8 843.7 238.5 842.9 243.5V243.5ZM841.6 243.3C842.2 239.1 839.3 235.1 835.1 234.5L760.2 222.9C756 222.2 752 225.1 751.4 229.4L744.3 275.3C743.6 279.5 746.5 283.5 750.7 284.1L825.6 295.7C829.8 296.3 833.8 293.4 834.5 289.2L841.6 243.3Z"
          fill="#132942"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M839.9 244.4L833.2 287.7C832.6 291.8 828.7 294.6 824.6 294L752.2 282.8C748.1 282.2 745.3 278.3 745.9 274.2L752.6 230.9C753.3 226.8 757.1 224 761.2 224.6L833.6 235.8C837.7 236.4 840.5 240.3 839.9 244.4V244.4ZM839.4 244.3C840 240.5 837.4 236.8 833.5 236.2L761.2 225.1C757.3 224.5 753.7 227.1 753.1 231L753 231.6L746.4 274.3C745.8 278.1 748.5 281.8 752.3 282.3L824.7 293.5C828.5 294.1 832.1 291.5 832.7 287.6L839.4 244.3Z"
          fill="#132942"
        />
        <path
          d="M831.6 277.2L782 269.6L785.6 246.6L835.2 254.3L831.6 277.2Z"
          fill="#132942"
        />
        <path
          d="M835.5 241.1L834.7 241V240.7L835.5 240.8V241.1Z"
          fill="#132942"
        />
        <path
          d="M826.4 239.7L824.7 239.4L824.8 239.2L826.4 239.4V239.7Z"
          fill="#132942"
        />
        <path
          d="M823.1 239.2L821.4 238.9L821.5 238.7L823.1 238.9V239.2Z"
          fill="#132942"
        />
        <path
          d="M796.6 235.1L795 234.8V234.6L796.6 234.8V235.1Z"
          fill="#132942"
        />
        <path
          d="M793.3 234.6L791.6 234.3L791.7 234.1L793.3 234.3V234.6Z"
          fill="#132942"
        />
        <path
          d="M829.7 240.2L828 239.9L828.1 239.7L829.7 240V240.2Z"
          fill="#132942"
        />
        <path
          d="M833 240.7L831.4 240.4V240.2L833 240.5V240.7Z"
          fill="#132942"
        />
        <path
          d="M799.9 235.6L798.3 235.3V235.1L800 235.4L799.9 235.6Z"
          fill="#132942"
        />
        <path
          d="M809.8 237.1L808.2 236.9V236.6L809.9 236.9L809.8 237.1Z"
          fill="#132942"
        />
        <path
          d="M819.8 238.7L818.1 238.4L818.2 238.2L819.8 238.4V238.7Z"
          fill="#132942"
        />
        <path
          d="M816.5 238.1L814.8 237.9V237.7L816.5 237.9V238.1Z"
          fill="#132942"
        />
        <path
          d="M803.2 236.1L801.6 235.8V235.6L803.3 235.9L803.2 236.1Z"
          fill="#132942"
        />
        <path
          d="M806.5 236.6L804.9 236.4V236.1L806.6 236.4L806.5 236.6Z"
          fill="#132942"
        />
        <path
          d="M813.2 237.6L811.5 237.4V237.1L813.2 237.4V237.6Z"
          fill="#132942"
        />
        <path
          d="M790 234.1L789.2 233.9V233.7L790 233.8V234.1Z"
          fill="#132942"
        />
        <path
          d="M827.2 289.4L828 289.5V289.7L827.1 289.6L827.2 289.4Z"
          fill="#132942"
        />
        <path
          d="M794.1 284.3L795.8 284.5L795.7 284.8L794.1 284.5V284.3Z"
          fill="#132942"
        />
        <path
          d="M790.8 283.8L792.4 284V284.2L790.8 284V283.8Z"
          fill="#132942"
        />
        <path
          d="M797.4 284.8L799.1 285L799 285.3L797.4 285V284.8Z"
          fill="#132942"
        />
        <path
          d="M787.5 283.2L789.1 283.5V283.7L787.4 283.5L787.5 283.2Z"
          fill="#132942"
        />
        <path
          d="M820.6 288.3L822.2 288.6V288.8L820.5 288.6L820.6 288.3Z"
          fill="#132942"
        />
        <path
          d="M814 287.3L815.6 287.6V287.8L813.9 287.6L814 287.3Z"
          fill="#132942"
        />
        <path
          d="M810.6 286.8L812.3 287.1V287.3L810.6 287V286.8Z"
          fill="#132942"
        />
        <path
          d="M817.3 287.8L818.9 288.1V288.3L817.2 288.1L817.3 287.8Z"
          fill="#132942"
        />
        <path
          d="M800.7 285.3L802.4 285.5L802.3 285.8L800.7 285.5V285.3Z"
          fill="#132942"
        />
        <path
          d="M825.5 289.3L823.8 289.1L823.9 288.9L825.5 289.1V289.3Z"
          fill="#132942"
        />
        <path
          d="M784.2 282.7L785.8 283V283.2L784.1 283L784.2 282.7Z"
          fill="#132942"
        />
        <path
          d="M807.3 286.3L809 286.6V286.8L807.3 286.5V286.3Z"
          fill="#132942"
        />
        <path
          d="M804 285.8L805.7 286L805.6 286.3L804 286V285.8Z"
          fill="#132942"
        />
        <path
          d="M782.5 282.7L781.7 282.6V282.3L782.5 282.5V282.7Z"
          fill="#132942"
        />
        <path
          d="M768.3 252.2C768.3 252.267 768.3 252.3 768.3 252.3C768.167 252.5 768.033 252.667 767.9 252.8C767.8 252.7 767.8 252.6 767.8 252.5C767.8 252.4 767.8 252.4 767.7 252.3C767.633 252.233 767.633 252.167 767.7 252.1C767.767 252.033 767.8 251.933 767.8 251.8C767.8 251.733 767.833 251.633 767.9 251.5C767.9 251.4 768 251.4 768.1 251.4C768.167 251.467 768.167 251.533 768.1 251.6C768.1 251.733 768.1 251.833 768.1 251.9C768 252.1 768.1 252.1 768.2 252.1C768.333 252.1 768.367 252.133 768.3 252.2V252.2Z"
          fill="#132942"
        />
        <path
          d="M762.9 262.6C762.833 262.667 762.8 262.767 762.8 262.9C762.8 263.033 762.767 263.1 762.7 263.1C762.6 263.1 762.4 263.1 762.4 262.9C762.333 262.767 762.367 262.667 762.5 262.6C762.567 262.467 762.633 262.333 762.7 262.2C762.767 262.133 762.833 262.133 762.9 262.2C762.967 262.2 763 262.233 763 262.3C763 262.433 762.967 262.533 762.9 262.6V262.6Z"
          fill="#132942"
        />
        <path
          d="M786.2 243.2C786.267 243.2 786.3 243.2 786.3 243.2C786.3 243.2 786.3 243.233 786.3 243.3C786.3 243.233 786.267 243.2 786.2 243.2Z"
          fill="#132942"
        />
        <path
          d="M786.1 243.8C786.1 243.6 786.2 243.4 786.3 243.3C786.367 243.367 786.433 243.467 786.5 243.6C786.567 243.733 786.667 243.767 786.8 243.7C787.1 243.7 787.1 243.7 787.2 244C787.2 244 787.3 244.1 787.2 244.1L787.1 244.2C786.833 244.133 786.533 244.1 786.2 244.1C786.2 244.1 786 243.9 786.1 243.8Z"
          fill="#132942"
        />
        <path
          d="M773 282.4V282.5H772.9C772.6 282.3 772.3 282 772.1 281.9C771.9 281.7 771.9 281.7 771.8 281.6C771.733 281.533 771.7 281.5 771.7 281.5C771.767 281.5 771.8 281.5 771.8 281.5C771.867 281.5 771.933 281.533 772 281.6C772.2 281.7 772.4 281.8 772.6 281.9C772.8 282.1 772.9 282.3 773 282.4V282.4Z"
          fill="#132942"
        />
        <path
          d="M773.4 270.2C773.4 270.3 773.3 270.4 773.3 270.4C773.233 270.467 773.2 270.5 773.2 270.5C773.1 270.5 773.1 270.4 773.1 270.4C773.1 270.1 772.9 269.7 772.9 269.4C772.9 269.333 772.9 269.3 772.9 269.3C772.9 269.3 772.933 269.3 773 269.3C773.1 269.3 773.1 269.4 773.2 269.4C773.267 269.667 773.333 269.933 773.4 270.2Z"
          fill="#132942"
        />
        <path
          d="M772.5 230.5C772.5 230.433 772.467 230.4 772.4 230.4L772.5 230.3C772.7 230.3 772.933 230.333 773.2 230.4C773.2 230.4 773.3 230.4 773.3 230.5C773.4 230.5 773.4 230.6 773.3 230.7C773.2 230.8 772.6 230.6 772.5 230.5V230.5Z"
          fill="#132942"
        />
        <path
          d="M771.5 229.3C771.5 229.1 771.6 228.9 771.5 228.7C771.4 228.7 771.5 228.7 771.5 228.7C771.7 228.8 771.8 229 771.9 229.1C771.9 229.2 771.9 229.4 771.9 229.5C771.8 229.6 771.7 229.6 771.6 229.5C771.6 229.5 771.5 229.4 771.5 229.3V229.3Z"
          fill="#132942"
        />
        <path
          d="M756.7 236.6C756.6 236.5 756.6 236.3 756.7 236.2C756.7 236.1 756.8 236.1 756.9 236.1C756.967 236.1 757 236.1 757 236.1C757.2 236.2 757.1 236.6 756.9 236.7C756.8 236.7 756.7 236.7 756.7 236.6Z"
          fill="#132942"
        />
        <path
          d="M775.3 273.8C775.3 273.867 775.3 273.9 775.3 273.9C775.233 273.9 775.2 273.933 775.2 274C775 274 774.867 273.933 774.8 273.8C774.733 273.6 774.667 273.433 774.6 273.3C774.6 273.233 774.567 273.2 774.5 273.2C774.567 273.2 774.633 273.2 774.7 273.2C774.767 273.333 774.867 273.467 775 273.6C775.067 273.667 775.167 273.733 775.3 273.8V273.8Z"
          fill="#132942"
        />
        <path
          d="M757.4 233.7C757.333 233.633 757.3 233.533 757.3 233.4C757.3 233.4 757.4 233.4 757.5 233.3C757.567 233.3 757.633 233.3 757.7 233.3C757.8 233.3 757.8 233.4 757.9 233.5C757.9 233.5 757.9 233.5 757.8 233.6C757.733 233.667 757.667 233.733 757.6 233.8C757.5 233.8 757.4 233.8 757.4 233.7V233.7Z"
          fill="#132942"
        />
        <path
          d="M775.3 238C775.6 238.2 775.7 238.4 775.6 238.7C775.6 238.7 775.567 238.7 775.5 238.7C775.367 238.5 775.267 238.3 775.2 238.1C775.2 238.033 775.233 238 775.3 238Z"
          fill="#132942"
        />
        <path
          d="M755.9 237.8C755.9 237.867 755.9 237.9 755.9 237.9H755.8C755.733 237.9 755.667 237.867 755.6 237.8C755.5 237.7 755.4 237.6 755.5 237.4V237.3C755.6 237.3 755.7 237.3 755.7 237.4C755.767 237.533 755.833 237.667 755.9 237.8Z"
          fill="#132942"
        />
        <path
          d="M755.3 251C755.3 251 755.3 250.9 755.3 250.8C755.367 250.8 755.433 250.833 755.5 250.9C755.567 250.967 755.633 251.067 755.7 251.2C755.8 251.2 755.7 251.2 755.7 251.3C755.4 251.3 755.3 251.2 755.3 251V251Z"
          fill="#132942"
        />
        <path
          d="M798.9 256.1C798.7 256 798.6 255.8 798.6 255.6C798.6 255.6 798.7 255.5 798.8 255.5L798.9 255.6C798.9 255.733 798.9 255.9 798.9 256.1V256.1Z"
          fill="#132942"
        />
        <path
          d="M754.8 237.2C754.667 237 754.533 236.833 754.4 236.7C754.4 236.6 754.4 236.6 754.4 236.6C754.467 236.533 754.533 236.533 754.6 236.6C754.8 236.7 754.8 236.9 754.9 237.1C754.9 237.167 754.867 237.2 754.8 237.2Z"
          fill="#132942"
        />
        <path
          d="M769.4 231.5C769.467 231.433 769.5 231.4 769.5 231.4C769.5 231.4 769.567 231.433 769.7 231.5C769.7 231.6 769.8 231.7 769.8 231.8C769.8 231.8 769.7 231.9 769.6 231.9C769.5 232 769.4 231.9 769.4 231.8C769.467 231.667 769.467 231.567 769.4 231.5Z"
          fill="#132942"
        />
        <path
          d="M756.4 230C756.133 229.867 755.9 229.7 755.7 229.5C755.8 229.5 756 229.5 756 229.6C756.133 229.8 756.3 229.867 756.5 229.8C756.5 229.8 756.5 229.9 756.6 230C756.5 230 756.4 230 756.4 230V230Z"
          fill="#132942"
        />
        <path
          d="M755.5 255.7C755.5 255.7 755.533 255.7 755.6 255.7C755.6 255.7 755.7 255.7 755.8 255.8C755.9 255.9 756 256.1 756.1 256.3C756.1 256.3 756.1 256.333 756.1 256.4C756.033 256.4 755.967 256.367 755.9 256.3C755.8 256.2 755.8 255.9 755.5 255.8V255.7V255.7Z"
          fill="#132942"
        />
        <path
          d="M755.7 236.4C755.6 236.4 755.4 236.3 755.4 236.2C755.4 236.1 755.4 236 755.5 236C755.6 236 755.8 236.2 755.8 236.4C755.8 236.4 755.767 236.4 755.7 236.4V236.4Z"
          fill="#132942"
        />
        <path
          d="M771.6 231.6C771.6 231.5 771.6 231.4 771.6 231.4C771.7 231.3 771.9 231.4 772 231.5L771.9 231.6C771.8 231.7 771.6 231.7 771.6 231.6Z"
          fill="#132942"
        />
        <path
          d="M749.1 261.2V261.3L749 261.4C748.8 261.3 748.7 261.1 748.8 261C748.8 260.9 748.9 260.9 748.9 260.9C748.967 261.033 749.033 261.133 749.1 261.2V261.2Z"
          fill="#132942"
        />
        <path
          d="M773.7 240.4C773.7 240.4 773.8 240.5 773.7 240.5C773.7 240.6 773.6 240.7 773.6 240.6C773.467 240.6 773.367 240.567 773.3 240.5C773.233 240.5 773.2 240.467 773.2 240.4H773.3C773.433 240.4 773.567 240.4 773.7 240.4Z"
          fill="#132942"
        />
        <path
          d="M786 243C786 242.9 785.9 242.8 786 242.7C786.133 242.7 786.233 242.733 786.3 242.8C786.367 242.867 786.4 242.933 786.4 243C786.333 243.067 786.3 243.133 786.3 243.2C786.167 243.133 786.067 243.067 786 243V243Z"
          fill="#132942"
        />
        <path
          d="M780.7 266.9H780.6C780.5 266.8 780.4 266.7 780.5 266.6C780.6 266.6 780.6 266.6 780.8 266.6C780.733 266.733 780.7 266.833 780.7 266.9V266.9Z"
          fill="#132942"
        />
        <path
          d="M759.3 254.8C759.3 254.9 759.2 255.1 759 255.1V255C759 254.933 759.033 254.867 759.1 254.8C759.1 254.8 759.167 254.767 759.3 254.7V254.8V254.8Z"
          fill="#132942"
        />
        <path
          d="M789.6 277.3L789.7 277.2C789.833 277.2 789.967 277.233 790.1 277.3C790.1 277.3 790.1 277.3 790 277.4C790 277.4 789.9 277.5 789.8 277.5C789.7 277.5 789.7 277.4 789.6 277.3V277.3Z"
          fill="#132942"
        />
        <path
          d="M795.1 250.6C795.1 250.6 795.2 250.6 795.3 250.6C795.4 250.8 795.3 251 795.2 251.1C795.133 251.1 795.067 251.1 795 251.1C795.067 250.9 795.1 250.733 795.1 250.6Z"
          fill="#132942"
        />
        <path
          d="M750 262.5C750 262.5 750 262.533 750 262.6C749.8 262.7 749.7 262.5 749.6 262.5C749.533 262.433 749.5 262.367 749.5 262.3C749.6 262.3 749.7 262.3 749.7 262.3C749.8 262.3 750 262.3 750 262.5Z"
          fill="#132942"
        />
        <path
          d="M768.1 253.3C768.233 253.367 768.233 253.467 768.1 253.6H768C768 253.533 767.967 253.433 767.9 253.3C768 253.3 768.1 253.3 768.1 253.3Z"
          fill="#132942"
        />
        <path
          d="M779.5 281.7V281.8C779.5 281.9 779.4 281.9 779.4 281.8C779.333 281.8 779.3 281.8 779.3 281.8C779.233 281.733 779.2 281.667 779.2 281.6C779.2 281.6 779.2 281.6 779.2 281.5H779.3C779.367 281.567 779.433 281.633 779.5 281.7Z"
          fill="#132942"
        />
        <path
          d="M760 267.9C760.067 267.9 760.1 267.933 760.1 268C760.1 268 760.067 267.967 760 267.9Z"
          fill="#132942"
        />
        <path
          d="M760 267.9C759.933 268.033 759.833 268.133 759.7 268.2L759.6 268.1C759.5 268 759.6 267.9 759.6 267.9C759.733 267.9 759.867 267.9 760 267.9Z"
          fill="#132942"
        />
        <path
          d="M751.1 261.1C751.1 261.1 751.1 261.133 751.1 261.2C751.033 261.267 751 261.333 751 261.4C750.933 261.4 750.9 261.4 750.9 261.4C750.833 261.4 750.8 261.367 750.8 261.3C750.8 261.233 750.833 261.167 750.9 261.1C750.9 261.1 751 261.1 751.1 261.1Z"
          fill="#132942"
        />
        <path
          d="M777.5 269C777.6 269 777.6 269 777.7 269C777.7 269.067 777.7 269.1 777.7 269.1C777.633 269.167 777.6 269.2 777.6 269.2C777.6 269.2 777.5 269.2 777.4 269.2C777.4 269.2 777.4 269 777.5 269V269Z"
          fill="#132942"
        />
        <path
          d="M788.4 273.8C788.4 273.8 788.367 273.833 788.3 273.9C788.2 273.9 788.1 273.9 788.1 273.9C788 273.8 788 273.7 788.1 273.7C788.1 273.6 788.3 273.7 788.4 273.8V273.8Z"
          fill="#132942"
        />
        <path
          d="M772.5 240.3C772.433 240.3 772.367 240.333 772.3 240.4C772.3 240.333 772.3 240.267 772.3 240.2C772.3 240.1 772.4 240 772.4 240C772.4 240 772.5 240.1 772.6 240.1C772.6 240.1 772.5 240.2 772.5 240.3Z"
          fill="#132942"
        />
        <path
          d="M755.8 231.1C755.867 231.1 755.9 231.133 755.9 231.2C755.9 231.2 755.867 231.233 755.8 231.3C755.733 231.233 755.667 231.167 755.6 231.1V231C755.7 231 755.7 231 755.7 231C755.767 231 755.8 231.033 755.8 231.1Z"
          fill="#132942"
        />
        <path
          d="M767.8 239.4C767.9 239.5 768 239.6 767.9 239.8C767.9 239.8 767.867 239.833 767.8 239.9C767.8 239.9 767.8 239.8 767.7 239.8C767.633 239.667 767.667 239.533 767.8 239.4Z"
          fill="#132942"
        />
        <path
          d="M754.8 250.8C754.867 250.867 754.9 250.933 754.9 251C754.767 251 754.7 251 754.7 251C754.6 250.9 754.6 250.7 754.7 250.7C754.767 250.7 754.8 250.733 754.8 250.8V250.8Z"
          fill="#132942"
        />
        <path
          d="M758.1 255.7C758.1 255.8 758 255.7 757.9 255.8C757.9 255.667 757.9 255.567 757.9 255.5C758 255.5 758.1 255.5 758.2 255.5C758.2 255.6 758.2 255.7 758.1 255.7V255.7Z"
          fill="#132942"
        />
        <path
          d="M771.2 275.4C771.267 275.4 771.333 275.4 771.4 275.4C771.4 275.5 771.4 275.6 771.3 275.6C771.3 275.7 771.2 275.6 771.1 275.6C771.1 275.5 771.1 275.4 771.2 275.4Z"
          fill="#132942"
        />
        <path
          d="M766.9 271.4C766.833 271.333 766.767 271.267 766.7 271.2C766.7 271.2 766.7 271.167 766.7 271.1C766.767 271.1 766.8 271.133 766.8 271.2C766.867 271.267 766.967 271.333 767.1 271.4C767.1 271.467 767.133 271.533 767.2 271.6C767.133 271.533 767.1 271.5 767.1 271.5C767.033 271.433 766.967 271.4 766.9 271.4V271.4Z"
          fill="#132942"
        />
        <path
          d="M774.9 280.1C774.9 280.167 774.9 280.2 774.9 280.2C774.833 280.133 774.733 280.067 774.6 280V279.9C774.6 279.9 774.633 279.9 774.7 279.9C774.8 279.9 774.9 280.1 774.9 280.1V280.1Z"
          fill="#132942"
        />
        <path
          d="M763.7 271.2C763.767 271.333 763.833 271.433 763.9 271.5C763.9 271.5 763.9 271.533 763.9 271.6H763.8C763.733 271.467 763.667 271.367 763.6 271.3C763.6 271.233 763.633 271.2 763.7 271.2Z"
          fill="#132942"
        />
        <path
          d="M754.3 233.3C754.367 233.3 754.433 233.333 754.5 233.4C754.5 233.4 754.5 233.4 754.4 233.5C754.4 233.5 754.3 233.5 754.3 233.4V233.3Z"
          fill="#132942"
        />
        <path
          d="M757.6 229.1C757.533 229.033 757.5 228.967 757.5 228.9H757.6C757.7 228.9 757.7 229 757.7 229.1C757.633 229.1 757.6 229.1 757.6 229.1Z"
          fill="#132942"
        />
        <path
          d="M767.8 238.6C767.8 238.6 767.8 238.567 767.8 238.5C767.9 238.5 767.9 238.5 768 238.6C768 238.6 768 238.667 768 238.8C767.933 238.733 767.867 238.667 767.8 238.6Z"
          fill="#132942"
        />
        <path
          d="M782.1 268.7C782.1 268.767 782.1 268.867 782.1 269C782.033 268.933 781.967 268.867 781.9 268.8V268.7H782.1Z"
          fill="#132942"
        />
        <path
          d="M780.2 267.1C780.267 267.167 780.333 267.233 780.4 267.3C780.3 267.3 780.2 267.4 780.2 267.3C780.133 267.3 780.1 267.267 780.1 267.2L777.8 281.9L777.4 281.8L784.9 233.2H785.4L780.1 267.2C780.167 267.133 780.2 267.1 780.2 267.1V267.1Z"
          fill="#132942"
        />
        <path
          d="M776.2 233.6C776.2 233.6 776.233 233.6 776.3 233.6C776.367 233.733 776.4 233.833 776.4 233.9C776.333 233.9 776.3 233.9 776.3 233.9C776.2 233.8 776.1 233.7 776.2 233.6Z"
          fill="#132942"
        />
        <path
          d="M779.7 275.2C779.7 275.267 779.7 275.333 779.7 275.4C779.7 275.4 779.667 275.4 779.6 275.4C779.5 275.4 779.5 275.3 779.5 275.2C779.567 275.2 779.633 275.2 779.7 275.2Z"
          fill="#132942"
        />
        <path
          d="M784.4 271.8H784.3C784.3 271.733 784.3 271.667 784.3 271.6C784.3 271.6 784.333 271.633 784.4 271.7C784.4 271.7 784.4 271.733 784.4 271.8V271.8Z"
          fill="#132942"
        />
        <path
          d="M755.7 255C755.7 255 755.7 254.9 755.8 254.8C755.8 254.8 755.9 254.8 755.9 254.7C755.9 254.833 755.9 254.933 755.9 255C755.9 255 755.8 255 755.7 255V255Z"
          fill="#132942"
        />
        <path
          d="M754.9 255.8C755.033 255.8 755.133 255.8 755.2 255.8C755.2 255.867 755.2 255.933 755.2 256C755.2 256.1 755.1 256 755.1 256C755.033 255.933 754.967 255.867 754.9 255.8V255.8Z"
          fill="#132942"
        />
        <path
          d="M771.6 271.5V271.6C771.533 271.6 771.5 271.6 771.5 271.6C771.433 271.667 771.367 271.667 771.3 271.6C771.367 271.6 771.4 271.567 771.4 271.5C771.4 271.5 771.433 271.467 771.5 271.4C771.5 271.4 771.6 271.4 771.6 271.5Z"
          fill="#132942"
        />
        <path
          d="M752.3 254V254.1C752.233 254.1 752.167 254.1 752.1 254.1C752.1 254.1 752.1 254.033 752.1 253.9C752.2 253.9 752.3 253.9 752.3 254Z"
          fill="#132942"
        />
        <path
          d="M780 280.6C779.933 280.6 779.9 280.6 779.9 280.6C779.833 280.533 779.8 280.5 779.8 280.5C779.733 280.433 779.7 280.4 779.7 280.4C779.7 280.333 779.7 280.3 779.7 280.3C779.7 280.3 779.733 280.3 779.8 280.3C779.867 280.367 779.933 280.467 780 280.6V280.6Z"
          fill="#132942"
        />
        <path
          d="M786.6 242.6C786.6 242.667 786.6 242.767 786.6 242.9C786.533 242.767 786.5 242.667 786.5 242.6C786.5 242.5 786.5 242.5 786.5 242.5C786.6 242.5 786.6 242.6 786.6 242.6Z"
          fill="#132942"
        />
        <path
          d="M774.2 278.1C774.133 278.1 774.1 278.067 774.1 278C774.033 278 774 277.967 774 277.9C774 277.833 774 277.8 774 277.8C774 277.8 774.033 277.8 774.1 277.8C774.1 277.867 774.133 277.933 774.2 278C774.2 278 774.2 278.033 774.2 278.1V278.1Z"
          fill="#132942"
        />
        <path
          d="M782 271.8C782 271.9 781.9 271.9 781.8 271.8C781.733 271.733 781.7 271.7 781.7 271.7C781.8 271.7 781.9 271.6 781.9 271.7C782 271.7 782 271.8 782 271.8Z"
          fill="#132942"
        />
        <path
          d="M773.6 232.7C773.533 232.633 773.5 232.567 773.5 232.5C773.567 232.5 773.633 232.5 773.7 232.5V232.6C773.633 232.667 773.6 232.7 773.6 232.7Z"
          fill="#132942"
        />
        <path
          d="M784.9 242.5C784.9 242.5 784.9 242.4 784.9 242.3C784.967 242.367 785 242.4 785 242.4C785.067 242.467 785.133 242.567 785.2 242.7C785.133 242.633 785.033 242.567 784.9 242.5V242.5Z"
          fill="#132942"
        />
        <path
          d="M756.8 234.1C756.8 234.033 756.8 233.967 756.8 233.9H756.9C756.9 233.967 756.9 234 756.9 234C756.833 234.067 756.8 234.1 756.8 234.1Z"
          fill="#132942"
        />
        <path
          d="M766.5 240.9C766.5 240.9 766.467 240.867 766.4 240.8C766.467 240.8 766.533 240.8 766.6 240.8C766.6 240.867 766.6 240.9 766.6 240.9C766.6 240.9 766.567 240.9 766.5 240.9Z"
          fill="#132942"
        />
        <path
          d="M757.2 230C757.133 229.933 757.1 229.867 757.1 229.8C757.167 229.8 757.2 229.833 757.2 229.9C757.267 229.9 757.3 229.933 757.3 230C757.2 230 757.2 230 757.2 230Z"
          fill="#132942"
        />
        <path
          d="M767.6 239.2V239.1C767.7 239.1 767.7 239.1 767.8 239.2C767.8 239.267 767.8 239.333 767.8 239.4C767.733 239.333 767.667 239.267 767.6 239.2Z"
          fill="#132942"
        />
        <path
          d="M781.4 248.6C781.4 248.6 781.4 248.633 781.4 248.7C781.4 248.7 781.3 248.7 781.3 248.6C781.233 248.533 781.2 248.467 781.2 248.4C781.267 248.4 781.3 248.4 781.3 248.4C781.367 248.467 781.4 248.533 781.4 248.6Z"
          fill="#132942"
        />
        <path
          d="M775.6 242.1C775.667 242.1 775.733 242.1 775.8 242.1C775.8 242.1 775.8 242.2 775.7 242.2C775.7 242.2 775.667 242.2 775.6 242.2C775.6 242.133 775.6 242.1 775.6 242.1Z"
          fill="#132942"
        />
        <path
          d="M780.9 247C780.833 246.933 780.8 246.867 780.8 246.8C780.8 246.8 780.9 246.8 781 246.8C781 246.867 781 246.9 781 246.9C780.933 246.967 780.9 247 780.9 247Z"
          fill="#132942"
        />
        <path
          d="M776.5 268.4C776.5 268.4 776.5 268.367 776.5 268.3C776.567 268.3 776.633 268.3 776.7 268.3C776.7 268.367 776.667 268.4 776.6 268.4C776.6 268.4 776.567 268.4 776.5 268.4Z"
          fill="#132942"
        />
        <path
          d="M754.9 251.7C754.967 251.7 755.033 251.7 755.1 251.7V251.8C755.033 251.8 755 251.8 755 251.8C754.933 251.733 754.9 251.7 754.9 251.7Z"
          fill="#132942"
        />
        <path
          d="M758.1 254.9C758.033 254.833 758 254.8 758 254.8C758 254.7 758 254.7 758 254.6C758.067 254.667 758.133 254.7 758.2 254.7C758.2 254.8 758.1 254.8 758.1 254.9Z"
          fill="#132942"
        />
        <path
          d="M755.7 252.8C755.7 252.8 755.7 252.7 755.8 252.7C755.8 252.767 755.833 252.833 755.9 252.9C755.833 252.9 755.8 252.9 755.8 252.9C755.733 252.9 755.7 252.867 755.7 252.8Z"
          fill="#132942"
        />
        <path
          d="M786.4 271.1C786.4 271.1 786.4 271.133 786.4 271.2C786.333 271.2 786.3 271.167 786.3 271.1C786.233 271.1 786.2 271.067 786.2 271C786.267 271 786.333 271.033 786.4 271.1Z"
          fill="#132942"
        />
        <path
          d="M764.6 267.4C764.533 267.333 764.5 267.3 764.5 267.3C764.433 267.3 764.4 267.267 764.4 267.2C764.467 267.2 764.533 267.2 764.6 267.2C764.6 267.267 764.6 267.333 764.6 267.4V267.4Z"
          fill="#132942"
        />
        <path
          d="M749.7 260.4C749.7 260.4 749.7 260.367 749.7 260.3C749.7 260.3 749.733 260.333 749.8 260.4C749.867 260.467 749.9 260.533 749.9 260.6C749.833 260.533 749.8 260.5 749.8 260.5C749.733 260.433 749.7 260.4 749.7 260.4V260.4Z"
          fill="#132942"
        />
        <path
          d="M750.5 262.7C750.567 262.833 750.6 262.933 750.6 263C750.6 263 750.6 263 750.5 263.1C750.5 263 750.4 263 750.4 263C750.467 262.933 750.5 262.833 750.5 262.7Z"
          fill="#132942"
        />
        <path
          d="M785.6 242.1C785.6 242.1 785.6 242.067 785.6 242C785.6 242 785.7 242 785.7 242.1V242.2C785.633 242.2 785.6 242.167 785.6 242.1Z"
          fill="#132942"
        />
        <path
          d="M770.7 227.9V227.8C770.767 227.8 770.8 227.8 770.8 227.8C770.8 227.867 770.8 227.9 770.8 227.9C770.8 227.9 770.767 227.9 770.7 227.9Z"
          fill="#132942"
        />
        <path
          d="M769.2 228.1C769.133 228.033 769.1 227.967 769.1 227.9C769.167 227.9 769.2 227.933 769.2 228C769.2 228 769.2 228.033 769.2 228.1Z"
          fill="#132942"
        />
        <path
          d="M756.5 236.9C756.5 236.9 756.5 236.933 756.5 237C756.5 237 756.467 237.033 756.4 237.1C756.4 237.1 756.4 237.1 756.3 237.1C756.367 237.033 756.433 236.967 756.5 236.9Z"
          fill="#132942"
        />
        <path
          d="M762.1 230.9C762.1 230.833 762.1 230.8 762.1 230.8C762.167 230.8 762.2 230.833 762.2 230.9C762.133 230.9 762.1 230.9 762.1 230.9Z"
          fill="#132942"
        />
        <path
          d="M768.7 233.9C768.767 233.9 768.833 233.9 768.9 233.9C768.9 233.967 768.9 234 768.9 234C768.833 234 768.767 233.967 768.7 233.9Z"
          fill="#132942"
        />
        <path
          d="M785.7 269.8C785.767 269.8 785.833 269.833 785.9 269.9C785.833 269.9 785.767 269.867 785.7 269.8Z"
          fill="#132942"
        />
        <path
          d="M781 268.9C780.933 268.833 780.9 268.8 780.9 268.8C780.833 268.8 780.767 268.767 780.7 268.7C780.767 268.7 780.833 268.733 780.9 268.8C780.967 268.8 781 268.833 781 268.9Z"
          fill="#132942"
        />
        <path
          d="M780.6 268.6C780.6 268.6 780.633 268.633 780.7 268.7C780.6 268.7 780.6 268.7 780.6 268.7C780.533 268.7 780.467 268.667 780.4 268.6C780.4 268.6 780.4 268.567 780.4 268.5C780.467 268.567 780.533 268.6 780.6 268.6Z"
          fill="#132942"
        />
        <path
          d="M784.7 273.8C784.7 273.8 784.7 273.833 784.7 273.9C784.7 273.9 784.667 273.867 784.6 273.8C784.6 273.8 784.567 273.767 784.5 273.7C784.567 273.767 784.633 273.8 784.7 273.8Z"
          fill="#132942"
        />
        <path
          d="M774.7 231.3L774.6 231.2C774.6 231.2 774.633 231.167 774.7 231.1C774.7 231.1 774.733 231.1 774.8 231.1C774.8 231.167 774.767 231.233 774.7 231.3Z"
          fill="#132942"
        />
        <path
          d="M775.6 267.2C775.6 267.133 775.567 267.1 775.5 267.1C775.567 267.1 775.6 267.1 775.6 267.1C775.667 267.167 775.7 267.2 775.7 267.2C775.7 267.2 775.667 267.2 775.6 267.2Z"
          fill="#132942"
        />
        <path
          d="M754.4 248.5C754.4 248.5 754.4 248.533 754.4 248.6C754.4 248.6 754.367 248.6 754.3 248.6C754.3 248.6 754.3 248.567 754.3 248.5H754.4Z"
          fill="#132942"
        />
        <path
          d="M756 250.8C755.933 250.733 755.867 250.7 755.8 250.7C755.8 250.7 755.8 250.667 755.8 250.6C755.867 250.6 755.9 250.633 755.9 250.7C755.9 250.7 755.933 250.733 756 250.8Z"
          fill="#132942"
        />
        <path
          d="M780.3 274.5C780.3 274.433 780.3 274.4 780.3 274.4C780.367 274.4 780.4 274.4 780.4 274.4C780.4 274.4 780.4 274.433 780.4 274.5C780.4 274.5 780.367 274.5 780.3 274.5Z"
          fill="#132942"
        />
        <path
          d="M756 252.2C756 252.2 755.967 252.167 755.9 252.1C755.9 252.1 755.867 252.067 755.8 252C755.867 252 755.933 252.033 756 252.1C756 252.1 756 252.133 756 252.2Z"
          fill="#132942"
        />
        <path
          d="M753.3 252.8C753.3 252.8 753.3 252.833 753.3 252.9C753.233 252.9 753.167 252.9 753.1 252.9C753.1 252.9 753.133 252.867 753.2 252.8C753.2 252.8 753.233 252.8 753.3 252.8Z"
          fill="#132942"
        />
        <path
          d="M771.9 230.3C771.9 230.233 771.9 230.167 771.9 230.1H772C772 230.1 772 230.133 772 230.2C772 230.2 771.967 230.233 771.9 230.3Z"
          fill="#132942"
        />
        <path
          d="M758.2 258.8C758.2 258.8 758.233 258.8 758.3 258.8C758.3 258.867 758.3 258.9 758.3 258.9C758.233 258.9 758.2 258.9 758.2 258.9C758.2 258.9 758.2 258.867 758.2 258.8Z"
          fill="#132942"
        />
        <path
          d="M780.4 282.2C780.333 282.133 780.267 282.1 780.2 282.1V282C780.2 282 780.233 282.033 780.3 282.1C780.3 282.1 780.333 282.133 780.4 282.2Z"
          fill="#132942"
        />
        <path
          d="M770.9 273.8C770.833 273.8 770.767 273.767 770.7 273.7C770.767 273.7 770.833 273.7 770.9 273.7C770.9 273.767 770.9 273.8 770.9 273.8Z"
          fill="#132942"
        />
        <path
          d="M782.1 285.1C782.1 285.1 782.133 285.133 782.2 285.2C782.133 285.2 782.067 285.167 782 285.1C782 285.1 782 285.067 782 285C782.067 285.067 782.1 285.1 782.1 285.1Z"
          fill="#132942"
        />
        <path
          d="M775.3 233.5C775.3 233.5 775.3 233.467 775.3 233.4C775.367 233.4 775.433 233.4 775.5 233.4C775.5 233.4 775.5 233.433 775.5 233.5C775.433 233.5 775.367 233.5 775.3 233.5Z"
          fill="#132942"
        />
        <path
          d="M762.4 269.6C762.4 269.667 762.433 269.7 762.5 269.7C762.433 269.7 762.367 269.7 762.3 269.7C762.3 269.7 762.3 269.667 762.3 269.6C762.367 269.6 762.4 269.6 762.4 269.6Z"
          fill="#132942"
        />
        <path
          d="M762.8 271.1C762.8 271.167 762.8 271.233 762.8 271.3C762.733 271.233 762.7 271.167 762.7 271.1V271C762.8 271.1 762.8 271.1 762.8 271.1Z"
          fill="#132942"
        />
        <path
          d="M773.9 281.9V282C773.8 282 773.8 282 773.8 282C773.7 282 773.8 281.9 773.8 281.9C773.8 281.9 773.833 281.9 773.9 281.9Z"
          fill="#132942"
        />
        <path
          d="M759.3 269.5C759.3 269.567 759.333 269.633 759.4 269.7C759.333 269.7 759.3 269.7 759.3 269.7C759.3 269.633 759.267 269.6 759.2 269.6C759.267 269.533 759.3 269.5 759.3 269.5V269.5Z"
          fill="#132942"
        />
        <path
          d="M772.3 283C772.3 283.067 772.333 283.1 772.4 283.1C772.4 283.1 772.4 283.133 772.4 283.2C772.333 283.133 772.267 283.067 772.2 283C772.267 283 772.3 283 772.3 283V283Z"
          fill="#132942"
        />
        <path
          d="M764 275.4C763.933 275.4 763.9 275.4 763.9 275.4C763.833 275.333 763.8 275.3 763.8 275.3C763.8 275.3 763.833 275.3 763.9 275.3C763.9 275.367 763.933 275.4 764 275.4Z"
          fill="#132942"
        />
        <path
          d="M791.3 274.1C791.367 274.1 791.4 274.1 791.4 274.1C791.4 274.1 791.4 274.133 791.4 274.2C791.333 274.133 791.3 274.1 791.3 274.1Z"
          fill="#132942"
        />
        <path
          d="M796.3 252.1C796.3 252.1 796.333 252.133 796.4 252.2C796.333 252.2 796.3 252.167 796.3 252.1Z"
          fill="#132942"
        />
        <path
          d="M785.8 272.6C785.867 272.6 785.9 272.633 785.9 272.7C785.9 272.7 785.867 272.7 785.8 272.7C785.8 272.633 785.8 272.6 785.8 272.6Z"
          fill="#132942"
        />
        <path
          d="M758 238.9C757.933 238.833 757.9 238.8 757.9 238.8C757.967 238.8 758 238.8 758 238.8C758 238.8 758 238.833 758 238.9Z"
          fill="#132942"
        />
        <path
          d="M774.9 267.5C774.833 267.5 774.8 267.5 774.8 267.5C774.8 267.433 774.833 267.4 774.9 267.4C774.9 267.4 774.9 267.433 774.9 267.5Z"
          fill="#132942"
        />
        <path
          d="M778.2 270.4C778.2 270.467 778.2 270.5 778.2 270.5C778.2 270.5 778.167 270.5 778.1 270.5C778.167 270.5 778.2 270.467 778.2 270.4Z"
          fill="#132942"
        />
        <path
          d="M771.2 269C771.2 269.067 771.2 269.1 771.2 269.1C771.2 269.1 771.167 269.1 771.1 269.1C771.167 269.1 771.2 269.067 771.2 269Z"
          fill="#132942"
        />
        <path
          d="M755.9 238.8C755.833 238.733 755.8 238.7 755.8 238.7C755.8 238.7 755.833 238.7 755.9 238.7C755.9 238.7 755.9 238.733 755.9 238.8Z"
          fill="#132942"
        />
        <path
          d="M752.4 252.3C752.467 252.3 752.5 252.333 752.5 252.4C752.433 252.4 752.4 252.367 752.4 252.3Z"
          fill="#132942"
        />
        <path
          d="M778 235.7C777.933 235.7 777.9 235.667 777.9 235.6C777.967 235.6 778 235.633 778 235.7Z"
          fill="#132942"
        />
        <path
          d="M754.5 232.2C754.433 232.2 754.4 232.2 754.4 232.2C754.467 232.2 754.5 232.2 754.5 232.2C754.5 232.2 754.5 232.233 754.5 232.3C754.5 232.3 754.5 232.267 754.5 232.2Z"
          fill="#132942"
        />
        <path
          d="M780.7 280.5C780.767 280.567 780.8 280.6 780.8 280.6C780.8 280.6 780.767 280.6 780.7 280.6C780.7 280.533 780.7 280.5 780.7 280.5Z"
          fill="#132942"
        />
        <path
          d="M755 233.2C755 233.2 755.033 233.2 755.1 233.2C755.1 233.2 755.1 233.233 755.1 233.3C755.033 233.3 755 233.267 755 233.2Z"
          fill="#132942"
        />
        <path
          d="M782.6 284C782.533 284 782.5 284 782.5 284C782.5 284 782.5 283.967 782.5 283.9C782.5 283.9 782.533 283.933 782.6 284Z"
          fill="#132942"
        />
        <path
          d="M770.3 237.1C770.3 237.033 770.3 237 770.3 237C770.367 237 770.4 237 770.4 237C770.4 237 770.4 237.033 770.4 237.1C770.4 237.1 770.367 237.1 770.3 237.1Z"
          fill="#132942"
        />
        <path
          d="M768.9 273C768.9 273 768.9 272.967 768.9 272.9C768.9 272.967 768.9 273 768.9 273C768.967 273 769 273 769 273C768.933 273 768.9 273 768.9 273Z"
          fill="#132942"
        />
        <path
          d="M757 231.8C757 231.8 757.033 231.8 757.1 231.8C757.033 231.867 757 231.9 757 231.9C757 231.9 757 231.867 757 231.8Z"
          fill="#132942"
        />
        <path
          d="M771.4 278.1C771.4 278.1 771.433 278.1 771.5 278.1C771.5 278.167 771.5 278.2 771.5 278.2C771.433 278.2 771.4 278.2 771.4 278.2C771.4 278.2 771.4 278.167 771.4 278.1Z"
          fill="#132942"
        />
        <path
          d="M759.5 267.3C759.433 267.3 759.4 267.3 759.4 267.3C759.4 267.3 759.4 267.267 759.4 267.2C759.467 267.267 759.5 267.3 759.5 267.3Z"
          fill="#132942"
        />
        <path
          d="M760.2 268.1C760.133 268.033 760.1 268 760.1 268C760.167 268 760.2 268 760.2 268C760.267 268 760.3 268 760.3 268C760.233 268.067 760.2 268.1 760.2 268.1Z"
          fill="#132942"
        />
        <path
          d="M750.6 260.6C750.6 260.6 750.633 260.633 750.7 260.7C750.633 260.7 750.6 260.7 750.6 260.7C750.6 260.633 750.6 260.6 750.6 260.6Z"
          fill="#132942"
        />
        <path
          d="M758.9 268.5C758.9 268.5 758.867 268.5 758.8 268.5C758.8 268.5 758.833 268.467 758.9 268.4C758.9 268.467 758.9 268.5 758.9 268.5Z"
          fill="#132942"
        />
        <path
          d="M770 280.8C770 280.8 770 280.833 770 280.9C769.933 280.833 769.9 280.8 769.9 280.8C769.967 280.8 770 280.8 770 280.8Z"
          fill="#132942"
        />
        <path
          d="M749.3 262.4C749.367 262.4 749.433 262.4 749.5 262.4C749.433 262.4 749.4 262.433 749.4 262.5C749.4 262.5 749.367 262.5 749.3 262.5C749.3 262.433 749.3 262.4 749.3 262.4Z"
          fill="#132942"
        />
        <path
          d="M768.8 234.5C768.867 234.5 768.9 234.5 768.9 234.5C768.9 234.5 768.933 234.533 769 234.6C768.933 234.6 768.9 234.6 768.9 234.6C768.9 234.533 768.867 234.5 768.8 234.5Z"
          fill="#132942"
        />
        <path d="M775.1 232.5H775V232.4L775.1 232.5Z" fill="#132942" />
        <path d="M763.3 221.8H763.2L763.3 221.7V221.8Z" fill="#132942" />
        <path d="M796.8 253.4L796.7 253.5V253.4H796.8Z" fill="#132942" />
        <path d="M755.4 232.4L755.3 232.3H755.4V232.4Z" fill="#132942" />
        <path d="M788.1 270.2L788.2 270.1L788.1 270.2Z" fill="#132942" />
        <path
          d="M782.2 269.2C782.133 269.133 782.1 269.1 782.1 269.1C782.1 269.1 782.1 269.067 782.1 269C782.1 269.067 782.133 269.133 782.2 269.2V269.2Z"
          fill="#132942"
        />
        <path d="M784.3 274.9V275H784.2L784.3 274.9Z" fill="#132942" />
        <path d="M754 250.5H754.1V250.6L754 250.5Z" fill="#132942" />
        <path d="M778.1 273.1H778.2L778.1 273.2V273.1Z" fill="#132942" />
        <path d="M773.1 268.5L773.2 268.6H773.1V268.5Z" fill="#132942" />
        <path d="M774.1 274.2V274.1L774.2 274.2H774.1Z" fill="#132942" />
        <path d="M772.7 275.4L772.6 275.5L772.7 275.4Z" fill="#132942" />
        <path d="M776.6 282.7L776.7 282.8L776.6 282.7Z" fill="#132942" />
        <path d="M766.2 273.1L766.1 273.2V273.1H766.2Z" fill="#132942" />
        <path d="M757.7 266.6L757.6 266.7L757.7 266.6Z" fill="#132942" />
        <path d="M767.6 276.1L767.7 276.2L767.6 276.1Z" fill="#132942" />
        <path
          d="M750.5 262.6C750.5 262.6 750.5 262.633 750.5 262.7C750.5 262.633 750.467 262.6 750.4 262.6C750.467 262.6 750.5 262.6 750.5 262.6Z"
          fill="#132942"
        />
        <path
          d="M756.2 233.4C756.267 233.333 756.3 233.3 756.3 233.3C756.3 233.367 756.267 233.4 756.2 233.4Z"
          fill="#132942"
        />
        <path
          d="M821.4 287.8C821.333 287.733 821.3 287.7 821.3 287.7C821.367 287.633 821.4 287.6 821.4 287.6C821.533 287.6 821.7 287.6 821.9 287.6L822 287.7C822 287.8 821.9 287.8 821.9 287.8C821.767 287.8 821.667 287.8 821.6 287.8C821.533 287.8 821.467 287.8 821.4 287.8Z"
          fill="#132942"
        />
        <path
          d="M829.1 287.2C829.1 287.267 829.1 287.333 829.1 287.4C829.1 287.467 829.067 287.5 829 287.5C829 287.5 829 287.467 829 287.4C829 287.2 828.9 287 829 286.8C829.1 286.8 829.1 286.8 829.1 286.8C829.1 286.8 829.2 286.8 829.2 286.9C829.2 286.967 829.167 287.067 829.1 287.2Z"
          fill="#132942"
        />
        <path
          d="M823.5 279.6C823.6 279.4 823.7 279.5 823.8 279.5C823.867 279.567 823.9 279.633 823.9 279.7C823.767 279.767 823.667 279.8 823.6 279.8C823.5 279.8 823.5 279.6 823.5 279.6Z"
          fill="#132942"
        />
        <path
          d="M826.7 277.6C826.7 277.7 826.6 277.7 826.5 277.8C826.433 277.667 826.4 277.567 826.4 277.5C826.4 277.5 826.5 277.4 826.6 277.4C826.7 277.4 826.8 277.5 826.7 277.6V277.6Z"
          fill="#132942"
        />
        <path
          d="M834.9 269.2C834.833 269.133 834.8 269.067 834.8 269C834.8 268.9 834.8 268.9 834.9 268.9C834.9 268.967 834.933 269.033 835 269.1C834.933 269.167 834.9 269.2 834.9 269.2Z"
          fill="#132942"
        />
        <path
          d="M825 279.6C825.067 279.6 825.133 279.6 825.2 279.6C825.2 279.7 825.2 279.8 825.1 279.8C825.033 279.733 824.967 279.7 824.9 279.7C825 279.7 825 279.6 825 279.6V279.6Z"
          fill="#132942"
        />
        <path
          d="M827.8 284.5C827.8 284.567 827.833 284.6 827.9 284.6C827.833 284.667 827.767 284.7 827.7 284.7C827.633 284.633 827.6 284.6 827.6 284.6C827.533 284.533 827.5 284.5 827.5 284.5C827.567 284.5 827.6 284.5 827.6 284.5C827.667 284.5 827.733 284.5 827.8 284.5Z"
          fill="#132942"
        />
        <path
          d="M825.3 291.8C825.233 291.933 825.133 292.067 825 292.2C824.933 292.133 824.9 292.1 824.9 292.1C824.9 291.9 825.2 291.8 825.3 291.8V291.8Z"
          fill="#132942"
        />
        <path
          d="M821.6 285.9C821.533 285.9 821.467 285.933 821.4 286C821.333 285.933 821.3 285.9 821.3 285.9C821.367 285.833 821.433 285.8 821.5 285.8C821.6 285.8 821.6 285.8 821.6 285.9Z"
          fill="#132942"
        />
        <path
          d="M832.6 273.7C832.667 273.767 832.7 273.833 832.7 273.9C832.7 274 832.6 274 832.6 274C832.533 273.933 832.467 273.833 832.4 273.7C832.5 273.7 832.6 273.7 832.6 273.7Z"
          fill="#132942"
        />
        <path
          d="M825 285.5C825 285.567 824.967 285.667 824.9 285.8C824.9 285.667 824.867 285.567 824.8 285.5L824.9 285.4C825 285.4 825 285.5 825 285.5Z"
          fill="#132942"
        />
        <path
          d="M827.3 276.8C827.3 276.8 827.3 276.8 827.4 276.7C827.4 276.767 827.433 276.833 827.5 276.9C827.5 276.9 827.467 276.933 827.4 277C827.333 276.933 827.3 276.867 827.3 276.8Z"
          fill="#132942"
        />
        <path
          d="M827.7 280.7C827.767 280.767 827.833 280.8 827.9 280.8C827.9 280.9 827.8 280.9 827.8 280.9C827.733 280.9 827.7 280.867 827.7 280.8C827.6 280.8 827.7 280.7 827.7 280.7Z"
          fill="#132942"
        />
        <path
          d="M828.6 281C828.6 281.067 828.6 281.133 828.6 281.2H828.5C828.433 281.133 828.4 281.067 828.4 281C828.5 281 828.6 281 828.6 281Z"
          fill="#132942"
        />
        <path
          d="M825.4 286.6C825.333 286.667 825.267 286.7 825.2 286.7C825.133 286.7 825.067 286.7 825 286.7V286.6C825.133 286.6 825.233 286.567 825.3 286.5C825.367 286.5 825.4 286.533 825.4 286.6V286.6Z"
          fill="#132942"
        />
        <path
          d="M826.9 274.5H827C827 274.5 827.033 274.533 827.1 274.6C826.967 274.667 826.9 274.667 826.9 274.6V274.5Z"
          fill="#132942"
        />
        <path
          d="M826.6 274.9C826.533 274.9 826.467 274.867 826.4 274.8C826.4 274.8 826.433 274.8 826.5 274.8C826.5 274.8 826.533 274.833 826.6 274.9Z"
          fill="#132942"
        />
        <path
          d="M827.3 283C827.3 283.067 827.3 283.1 827.3 283.1C827.233 283.1 827.2 283.1 827.2 283.1C827.2 283.1 827.2 283.067 827.2 283H827.3Z"
          fill="#132942"
        />
        <path
          d="M833.4 278.6C833.4 278.667 833.433 278.7 833.5 278.7C833.433 278.7 833.4 278.733 833.4 278.8C833.333 278.733 833.3 278.667 833.3 278.6H833.4V278.6Z"
          fill="#132942"
        />
        <path
          d="M827 278.1C827.067 278.033 827.133 278 827.2 278V278.1C827.133 278.1 827.1 278.133 827.1 278.2C827.033 278.133 827 278.1 827 278.1Z"
          fill="#132942"
        />
        <path
          d="M829.4 285.4C829.333 285.4 829.267 285.4 829.2 285.4C829.2 285.4 829.167 285.4 829.1 285.4C829.167 285.333 829.233 285.3 829.3 285.3C829.3 285.3 829.333 285.333 829.4 285.4Z"
          fill="#132942"
        />
        <path
          d="M830 287C830 287 830.033 287.033 830.1 287.1C830.033 287.1 830 287.1 830 287.1C830 287.1 829.967 287.067 829.9 287C830 287 830 287 830 287Z"
          fill="#132942"
        />
        <path
          d="M828.5 284.5C828.433 284.5 828.4 284.5 828.4 284.5C828.4 284.433 828.4 284.4 828.4 284.4C828.467 284.4 828.5 284.433 828.5 284.5Z"
          fill="#132942"
        />
        <path
          d="M823.1 283.7C823.033 283.7 823 283.7 823 283.7C823 283.7 822.967 283.667 822.9 283.6C822.967 283.6 823.033 283.6 823.1 283.6C823.1 283.6 823.1 283.633 823.1 283.7Z"
          fill="#132942"
        />
        <path
          d="M831 286.2C831 286.2 831 286.167 831 286.1C831.067 286.1 831.1 286.133 831.1 286.2C831.033 286.2 831 286.2 831 286.2Z"
          fill="#132942"
        />
        <path
          d="M834 265.8C834 265.8 834 265.767 834 265.7C834 265.7 834.033 265.733 834.1 265.8C834.033 265.8 834 265.833 834 265.9C834 265.9 834 265.867 834 265.8Z"
          fill="#132942"
        />
        <path
          d="M827.9 288.2C827.9 288.133 827.933 288.067 828 288C828 288 828 288.033 828 288.1C828 288.1 828 288.133 828 288.2C827.933 288.2 827.9 288.2 827.9 288.2V288.2Z"
          fill="#132942"
        />
        <path
          d="M831.1 289C831.1 289 831.133 288.967 831.2 288.9C831.2 288.9 831.2 288.933 831.2 289C831.2 289 831.167 289 831.1 289Z"
          fill="#132942"
        />
        <path
          d="M827.3 288.6C827.367 288.6 827.4 288.6 827.4 288.6C827.4 288.667 827.433 288.7 827.5 288.7C827.5 288.7 827.467 288.7 827.4 288.7C827.4 288.7 827.367 288.667 827.3 288.6Z"
          fill="#132942"
        />
        <path
          d="M822.1 291C822.1 291 822.133 291 822.2 291C822.2 291 822.2 291.033 822.2 291.1C822.133 291.1 822.1 291.1 822.1 291.1C822.1 291.033 822.1 291 822.1 291Z"
          fill="#132942"
        />
        <path
          d="M827.5 272.9C827.567 272.9 827.6 272.933 827.6 273C827.533 273 827.5 273 827.5 273C827.5 272.933 827.5 272.9 827.5 272.9Z"
          fill="#132942"
        />
        <path d="M825 278.3V278.4H824.9L825 278.3Z" fill="#132942" />
        <path d="M829.3 282.3V282.4H829.2L829.3 282.3Z" fill="#132942" />
        <path
          d="M830.7 283.8C830.633 283.733 830.6 283.7 830.6 283.7C830.6 283.7 830.633 283.733 830.7 283.8Z"
          fill="#132942"
        />
        <path d="M830 289.3H830.1L830 289.4V289.3Z" fill="#132942" />
        <path d="M824.5 284.8L824.6 284.7L824.5 284.8Z" fill="#132942" />
        <path
          d="M798.1 270C798.1 270.2 797.9 270.3 797.7 270.2C797.433 270.067 797.133 269.9 796.8 269.7C796.8 269.7 796.767 269.7 796.7 269.7C796.767 269.7 796.8 269.7 796.8 269.7C797.3 269.6 797.5 269.1 798 269.1C798.067 269.1 798.1 269.1 798.1 269.1L798.2 269.2C798.133 269.467 798.1 269.733 798.1 270V270Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.3 244.4C788.3 244.7 787.8 245.1 787.4 245C787.3 245 787.2 245 787.1 244.9C787.1 244.8 787.2 244.5 787.3 244.5C787.6 244.4 787.8 244.2 788 244H788.2C788.3 244.1 788.3 244.2 788.4 244.2C788.4 244.3 788.4 244.3 788.3 244.4V244.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M761 237.7C761.4 237.8 761.6 237.8 761.8 237.8C762.2 237.9 762.2 237.9 762.2 238.2C762.2 238.333 762.167 238.467 762.1 238.6C762.1 238.667 762.1 238.7 762.1 238.7C762.1 238.7 762 238.7 762 238.6C761.9 238.3 761.7 238.2 761.4 238.2C761.267 238.133 761.133 238.1 761 238.1C760.8 238 760.7 237.9 760.8 237.8C760.867 237.733 760.933 237.7 761 237.7C761.1 237.7 761.1 237.7 761 237.7V237.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M816.5 239.4C816.5 239.467 816.5 239.567 816.5 239.7C816.4 239.8 816.3 239.8 816.2 239.8C815.8 239.8 815.7 239.6 815.6 239.3V239.2C815.8 239.2 815.9 239.1 816.1 239.1C816.5 238.9 816.5 238.9 816.5 239.4V239.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.2 250C754.2 250.1 754.1 250.2 754 250.2C753.9 250.2 753.8 250.2 753.8 250.2C753.8 249.9 753.6 249.7 753.4 249.6C753.3 249.6 753.3 249.4 753.3 249.4C753.4 249.3 753.5 249.2 753.6 249.2C753.8 249.2 754.2 249.7 754.2 250V250Z"
          fill="#F7F5E8"
        />
        <path
          d="M816.4 237.5C816.333 237.633 816.3 237.767 816.3 237.9C816.2 237.9 816.1 238 816.1 237.9C815.9 237.7 815.6 237.5 815.4 237.3C815.3 237.2 815.3 237.1 815.3 237.1C815.4 237.1 815.4 237 815.5 237C815.767 237.133 816.033 237.233 816.3 237.3C816.4 237.4 816.4 237.4 816.4 237.5V237.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M813.9 237.7C814.2 237.6 814.4 237.8 814.5 238C814.6 238.1 814.5 238.2 814.4 238.2C814.3 238.2 814.1 238.2 814 238.4C814 238.5 814 238.7 813.9 238.6C813.8 238.6 813.8 238.4 813.8 238.4C813.9 238.1 813.8 238 813.6 237.9C813.6 237.8 813.6 237.8 813.5 237.7C813.567 237.7 813.633 237.7 813.7 237.7C813.767 237.7 813.833 237.7 813.9 237.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M749.9 278.8C749.6 278.8 749.5 278.8 749.4 278.7C749.333 278.7 749.267 278.7 749.2 278.7C749.267 278.633 749.333 278.6 749.4 278.6C749.467 278.6 749.533 278.6 749.6 278.6C749.9 278.5 750.1 278.5 750.4 278.5C750.6 278.5 750.8 278.7 751.1 278.7V278.8C751 278.8 751 278.9 751 278.9C750.5 278.8 750.1 278.8 749.9 278.8V278.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M790.1 280.5C790.1 280.5 789.9 280.4 789.6 280.4V280.3L789.7 280.2C790.1 280.3 790.6 280.1 791.1 280.4C791.1 280.467 791.133 280.533 791.2 280.6C791.133 280.6 791.067 280.6 791 280.6C790.7 280.6 790.5 280.5 790.1 280.5V280.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M753.9 245.1C753.5 245.3 753.1 245.2 752.8 244.9C752.7 244.9 752.7 244.8 752.7 244.7H752.8C753.1 244.9 753.4 244.8 753.6 244.8C753.8 244.7 753.9 245 753.9 245.1V245.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M783.9 268.4C783.9 268.2 783.9 268 783.6 267.8C783.467 267.8 783.333 267.767 783.2 267.7C783.2 267.7 783.167 267.7 783.1 267.7C783.1 267.6 783.2 267.6 783.2 267.6C783.6 267.6 783.9 267.7 784.2 267.9C784.4 268.1 784.3 268.3 784.1 268.4C784 268.4 783.9 268.4 783.8 268.4H783.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.8 280.9C788.8 280.967 788.8 281 788.8 281C788.6 281.2 788.5 281.5 788.1 281.5C788 281.5 787.9 281.4 787.8 281.3C787.8 281.2 787.9 281.2 788 281.1C788.2 281.033 788.4 280.967 788.6 280.9C788.6 280.8 788.7 280.9 788.8 280.9V280.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M780.5 251.6C780.4 251.6 780.3 251.6 780.2 251.5C780.2 251.5 780.1 251.4 780.1 251.3C780.233 251.1 780.4 251 780.6 251C780.7 251 781 251.5 780.9 251.6C780.9 251.6 780.9 251.6 780.8 251.6C780.733 251.6 780.633 251.6 780.5 251.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M782.6 260.2C782.6 260.2 782.5 260.2 782.4 260.2L782.3 260.1C782.3 260 782.3 259.9 782.4 259.8C782.4 259.8 782.5 259.8 782.6 259.8C782.7 259.8 782.7 259.9 782.8 259.9C782.9 260.1 783 260.1 783.2 260C783.3 260 783.3 260.1 783.4 260.1C783.3 260.2 783.3 260.3 783.2 260.3C783 260.3 782.9 260.3 782.6 260.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.2 245.9C788.2 245.9 788.3 245.9 788.4 246C788.5 246 788.4 246.1 788.4 246.1C788.2 246.2 788 246.2 787.8 246.4C787.733 246.333 787.667 246.267 787.6 246.2L787.5 246C787.6 245.8 787.7 245.8 787.9 245.8C787.9 245.8 788 245.9 788.2 245.9V245.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M839.3 245.4C839.3 245.267 839.333 245.2 839.4 245.2C839.467 245.2 839.533 245.233 839.6 245.3C839.667 245.367 839.767 245.433 839.9 245.5C839.9 245.6 839.9 245.8 839.8 245.8C839.6 245.8 839.4 245.8 839.2 245.8C839.2 245.8 839.1 245.8 839 245.7C839.1 245.7 839.2 245.7 839.2 245.6C839.3 245.6 839.3 245.5 839.4 245.4C839.333 245.4 839.3 245.4 839.3 245.4V245.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.4 246C752.3 245.9 752 245.8 751.8 245.7C751.4 245.6 751.5 245.3 751.7 245C751.767 245 751.8 245 751.8 245C751.867 245 751.9 245.033 751.9 245.1C751.833 245.167 751.8 245.233 751.8 245.3C751.8 245.433 751.867 245.533 752 245.6C752.2 245.667 752.4 245.767 752.6 245.9C752.667 245.9 752.733 245.933 752.8 246C752.733 246 752.667 246 752.6 246C752.6 246 752.6 246 752.4 246Z"
          fill="#F7F5E8"
        />
        <path
          d="M785.6 245.7C785.533 245.633 785.5 245.567 785.5 245.5C785.5 245.4 785.6 245.4 785.7 245.5C785.8 245.6 786 245.6 786 245.9C786 246.033 786 246.167 786 246.3C786 246.4 785.9 246.4 785.9 246.4C785.7 246.2 785.4 246 785.6 245.7V245.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M811 246.3C811.1 246.4 811.2 246.5 811.2 246.6C811.2 246.733 811.167 246.867 811.1 247C811.1 247.1 811.1 247.1 811 247.1H810.9C810.833 246.967 810.767 246.833 810.7 246.7C810.7 246.6 810.5 246.6 810.7 246.5C810.7 246.4 810.9 246.4 811 246.3V246.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M782 261.2C781.733 261.133 781.533 261.067 781.4 261L781.3 260.9L781.4 260.8C781.6 260.867 781.767 260.9 781.9 260.9C782.3 261 782.5 261.1 782.4 261.1C782.3 261.2 782.1 261.2 782 261.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.5 256.2C801.5 256.3 801.3 256.4 801.3 256.3C801.167 256.167 801.033 256.067 800.9 256C800.9 255.9 800.7 255.8 800.9 255.7C801 255.7 801.1 255.7 801.2 255.7C801.4 255.8 801.6 256 801.5 256.2V256.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M813.1 248.9C813.1 249 813.3 249 813.3 249C813.4 249.1 813.4 249.2 813.4 249.2C813.3 249.3 813.3 249.4 813.2 249.4C813.1 249.4 812.9 249.3 812.8 249.3C812.7 249.3 812.6 249.2 812.6 249.1C812.7 249 812.8 249 812.9 248.9C812.9 248.9 813 248.9 813.1 248.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M768.1 240.3C768 240.4 767.9 240.5 767.9 240.5C767.5 240.5 767.133 240.533 766.8 240.6C766.8 240.6 766.7 240.5 766.7 240.4C766.7 240.4 766.733 240.367 766.8 240.3H766.9C767.3 240.5 767.6 240.3 767.9 240.2C767.9 240.2 768 240.3 768.1 240.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M747.3 269.3C747.433 269.3 747.567 269.333 747.7 269.4C747.767 269.4 747.8 269.4 747.8 269.4C747.8 269.467 747.767 269.5 747.7 269.5C747.567 269.7 747.4 269.733 747.2 269.6C747.067 269.533 746.933 269.433 746.8 269.3C746.733 269.3 746.7 269.267 746.7 269.2C746.7 269.2 746.733 269.2 746.8 269.2C747 269.2 747.167 269.233 747.3 269.3V269.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M826.6 253.4C826.4 253.333 826.233 253.267 826.1 253.2C826 253.2 826 253.1 826 253.1L826.1 253C826.367 253.067 826.6 253.133 826.8 253.2C826.9 253.2 827 253.4 827 253.5C826.933 253.433 826.833 253.4 826.7 253.4C826.7 253.4 826.667 253.4 826.6 253.4V253.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M784.9 244.7C784.9 244.6 784.8 244.5 784.9 244.4C784.9 244.3 784.9 244.2 785 244.2C785.2 244.1 785.4 244.1 785.5 244.3C785.5 244.4 785.5 244.5 785.5 244.5C785.3 244.567 785.1 244.633 784.9 244.7V244.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M753.1 232.6C753.1 232.6 753 232.6 753 232.5C752.9 232.5 752.9 232.4 752.9 232.4C752.9 232.3 752.9 232.2 753 232.2C753.1 232.1 753.2 232.1 753.3 232.2C753.5 232.2 753.5 232.3 753.7 232.4C753.7 232.467 753.7 232.5 753.7 232.5C753.633 232.5 753.6 232.533 753.6 232.6C753.467 232.6 753.3 232.6 753.1 232.6V232.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M814.1 247.3C814.1 247.5 814.1 247.7 814.1 247.8C814 247.8 813.9 247.8 813.8 247.8C813.7 247.8 813.7 247.8 813.7 247.7C813.9 247.5 813.8 247.2 814 247C814 246.9 814.1 246.9 814.1 246.9C814.2 246.9 814.2 247 814.2 247C814.2 247.133 814.167 247.233 814.1 247.3V247.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M813.4 250.7C813.3 250.8 813.3 250.9 813.2 250.9C813.067 250.967 812.933 251 812.8 251C812.7 251 812.7 250.9 812.7 250.9C812.7 250.7 812.9 250.4 813.1 250.4C813.2 250.5 813.3 250.6 813.4 250.7V250.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M755.6 237.1C755.7 237.2 755.8 237.3 755.9 237.4C756 237.4 755.9 237.6 755.9 237.7C755.9 237.7 755.8 237.7 755.7 237.6C755.567 237.533 755.433 237.433 755.3 237.3C755.2 237.3 755.2 237.2 755.2 237.2C755.267 237.133 755.3 237.1 755.3 237.1C755.4 237.1 755.4 237.1 755.6 237.1V237.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M808.5 245.6C808.367 245.533 808.3 245.5 808.3 245.5C808.2 245.5 808.2 245.4 808.2 245.4C808.2 245.3 808.2 245.2 808.3 245.2C808.5 245.1 808.7 245.2 808.9 245.3C808.9 245.3 808.9 245.3 808.9 245.4V245.5C808.7 245.567 808.567 245.6 808.5 245.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M823.2 245.3C823.333 245.3 823.467 245.333 823.6 245.4C823.667 245.4 823.733 245.433 823.8 245.5C823.7 245.5 823.6 245.6 823.5 245.6C823.367 245.6 823.2 245.567 823 245.5C822.9 245.5 822.8 245.3 822.7 245.3C822.833 245.3 822.967 245.3 823.1 245.3C823.1 245.3 823.133 245.3 823.2 245.3V245.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M786.3 247.2C786.3 247.2 786.3 247.3 786.2 247.3C786.133 247.3 786.067 247.3 786 247.3C785.8 247.2 785.7 247 785.9 246.9C785.9 246.8 786.1 246.7 786.1 246.7C786.2 246.8 786.3 246.9 786.3 247C786.4 247 786.3 247.1 786.3 247.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M785.1 282.8C785.3 282.933 785.533 283.067 785.8 283.2V283.3C785.5 283.5 785.3 283.5 785.2 283.2C785.2 283.1 785.1 283 785 283C785 282.9 785.1 282.9 785.1 282.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M797.4 267.9C797.6 268.033 797.833 268.167 798.1 268.3C798.1 268.3 798.1 268.333 798.1 268.4C797.767 268.333 797.467 268.267 797.2 268.2C797.2 268.2 797.2 268.1 797.1 268C797.167 268 797.2 268 797.2 268C797.3 268 797.3 268 797.4 267.9V267.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M769.4 233.5C769.4 233.5 769.5 233.5 769.5 233.6C769.5 233.6 769.5 233.7 769.5 233.8C769.367 233.867 769.233 233.933 769.1 234C769.1 234 768.9 234 768.9 233.9C768.9 233.6 769.1 233.4 769.4 233.5V233.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.1 276.7C814.9 276.6 814.7 276.6 814.6 276.5C814.533 276.5 814.5 276.5 814.5 276.5C814.5 276.433 814.533 276.4 814.6 276.4C814.8 276.5 814.9 276.4 815.1 276.3C815.1 276.2 815.4 276.4 815.4 276.5V276.6C815.3 276.6 815.1 276.7 815.1 276.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M771 270C770.9 270.2 770.8 270.4 770.5 270.4C770.367 270.4 770.3 270.367 770.3 270.3C770.2 270.1 770.3 270 770.4 270C770.6 270 770.8 270 771 270V270Z"
          fill="#F7F5E8"
        />
        <path
          d="M779.4 243.8C779.5 243.9 779.5 243.9 779.5 244C779.367 244.067 779.267 244.167 779.2 244.3C779.1 244.3 779 244.3 778.9 244.3C778.833 244.167 778.8 244.067 778.8 244C778.8 243.9 778.9 243.8 779 243.8C779.133 243.8 779.267 243.8 779.4 243.8V243.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.9 238.7C773.9 238.967 773.8 239 773.6 238.8C773.533 238.8 773.5 238.767 773.5 238.7C773.4 238.6 773.4 238.5 773.5 238.4C773.567 238.4 773.6 238.4 773.6 238.4C773.9 238.3 774 238.4 773.9 238.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.2 257.4C802.2 257.5 802.1 257.5 802.1 257.5C802 257.6 801.9 257.6 801.9 257.5C801.767 257.3 801.667 257.1 801.6 256.9C801.667 256.9 801.7 256.9 801.7 256.9C801.9 257.033 802.067 257.167 802.2 257.3C802.2 257.367 802.2 257.4 802.2 257.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.7 273.5C809.6 273.6 809.4 273.7 809.3 273.7C809.2 273.7 809.1 273.6 809 273.6C808.9 273.6 808.9 273.5 808.9 273.5C809.1 273.3 809.5 273.3 809.6 273.4C809.667 273.4 809.7 273.433 809.7 273.5V273.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M807.7 254.5C807.7 254.4 807.5 254.4 807.4 254.3C807.4 254.3 807.4 254.2 807.5 254.1C807.6 254 808 254.2 808 254.4C808 254.4 808 254.5 807.9 254.5C807.9 254.5 807.833 254.5 807.7 254.5V254.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.1 230C755.9 230.1 755.8 230.2 755.7 230.3C755.6 230.3 755.5 230.1 755.5 229.9C755.5 229.8 755.7 229.7 755.8 229.8C755.9 229.8 756 229.9 756.1 230V230Z"
          fill="#F7F5E8"
        />
        <path
          d="M759.8 232.1C759.733 232.033 759.667 231.933 759.6 231.8L759.7 231.7C759.9 231.6 760.2 231.8 760.3 232L760.2 232.1C760.133 232.1 760 232.1 759.8 232.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M774.3 234.8C774.233 234.8 774.2 234.833 774.2 234.9C774.2 234.9 774 234.9 773.9 234.8C773.8 234.7 773.8 234.4 773.9 234.4C774 234.4 774.1 234.4 774.2 234.5C774.2 234.5 774.3 234.7 774.3 234.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.5 255.1C803.4 255.1 803.3 255 803.3 255C803.2 254.9 803 254.9 803.1 254.7C803.1 254.7 803.3 254.7 803.4 254.7C803.467 254.7 803.567 254.733 803.7 254.8C803.7 254.8 803.8 255 803.7 255C803.7 255.1 803.6 255.1 803.5 255.1V255.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M800.5 268.9H800.4C800.267 268.767 800.167 268.633 800.1 268.5V268.4C800.2 268.4 800.2 268.3 800.3 268.3C800.5 268.4 800.6 268.7 800.5 268.9V268.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.4 238.1C758.2 238.1 758 238 757.9 237.8C757.8 237.8 757.9 237.7 757.9 237.6C758 237.6 758.1 237.6 758.1 237.6C758.233 237.733 758.333 237.9 758.4 238.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M785.3 251.1H785.2C785 251 784.9 250.8 785 250.6C785 250.5 785 250.5 785.1 250.5C785.3 250.5 785.4 250.8 785.3 251.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M777.2 256.9C777.3 257 777.4 257 777.4 257C777.4 257 777.6 257.1 777.6 257.2C777.6 257.3 777.4 257.4 777.2 257.3C777.1 257.3 777 257.1 777 257C777.1 257 777.2 256.9 777.2 256.9V256.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M813.8 254.1C813.6 254.1 813.4 253.9 813.5 253.7L813.6 253.6C813.667 253.667 813.767 253.7 813.9 253.7C814 253.8 814.1 253.8 814 253.9C814 254 813.9 254.1 813.8 254.1V254.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M783 268.8C783 268.8 783.1 268.9 783.2 269C783.2 269 783.2 269.1 783.1 269.2C783 269.3 782.7 269.1 782.6 268.9C782.6 268.9 782.7 268.9 782.7 268.8C782.767 268.8 782.867 268.8 783 268.8V268.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.3 275.6C771.2 275.6 771.2 275.6 771.2 275.5C771.133 275.433 771.133 275.367 771.2 275.3C771.2 275.2 771.3 275.2 771.4 275.3C771.467 275.3 771.533 275.333 771.6 275.4C771.667 275.467 771.7 275.533 771.7 275.6C771.7 275.6 771.6 275.7 771.5 275.7C771.433 275.7 771.367 275.667 771.3 275.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M773 262C772.9 262 772.8 261.9 772.6 261.8V261.7C772.6 261.7 772.633 261.7 772.7 261.7C772.9 261.767 773.067 261.833 773.2 261.9C773.3 261.9 773.3 262 773.4 262C773.333 262.067 773.267 262.1 773.2 262.1C773.2 262.1 773.1 262.1 773 262Z"
          fill="#F7F5E8"
        />
        <path
          d="M750.8 250.6C750.867 250.733 750.967 250.867 751.1 251C751.1 251 751.1 251.1 751 251.1C751 251.167 750.967 251.2 750.9 251.2C750.6 251.1 750.5 251 750.6 250.8C750.7 250.7 750.7 250.6 750.8 250.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M769.3 258.4C769.167 258.4 769.067 258.367 769 258.3H769.1C769.3 258.3 769.5 258.2 769.7 258C769.767 258 769.8 258 769.8 258C769.8 258.2 769.6 258.4 769.5 258.4C769.433 258.4 769.367 258.4 769.3 258.4V258.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M800.9 257.3C800.833 257.3 800.767 257.333 800.7 257.4C800.7 257.4 800.5 257.4 800.5 257.3C800.5 257.167 800.5 257 800.5 256.8C800.5 256.8 800.5 256.8 800.6 256.7C800.7 256.9 800.6 257.2 800.9 257.3V257.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.7 264.1C801.7 264.033 801.733 263.967 801.8 263.9C801.867 263.9 801.9 263.9 801.9 263.9C801.9 264.1 801.8 264.3 802 264.4C802 264.5 802.1 264.5 802 264.6C801.933 264.6 801.867 264.567 801.8 264.5C801.6 264.5 801.6 264.3 801.7 264.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M770.4 231.9C770.333 231.967 770.3 232 770.3 232C770.1 231.867 769.9 231.733 769.7 231.6C769.6 231.6 769.6 231.5 769.7 231.5C769.7 231.5 769.7 231.4 769.8 231.4C770.067 231.467 770.267 231.633 770.4 231.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M821.6 244.6C821.6 244.7 821.6 244.7 821.5 244.7C821.433 244.767 821.333 244.767 821.2 244.7C821.1 244.7 821.1 244.6 821.1 244.5L821.2 244.4C821.5 244.4 821.6 244.5 821.6 244.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M775.7 271.5C775.7 271.6 775.7 271.6 775.7 271.6C775.567 271.733 775.433 271.833 775.3 271.9C775.3 272 775.2 271.9 775.2 271.9C775.133 271.9 775.1 271.9 775.1 271.9C775.2 271.6 775.4 271.4 775.6 271.4C775.667 271.467 775.7 271.5 775.7 271.5V271.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M763.7 234.6C763.633 234.6 763.533 234.567 763.4 234.5C763.4 234.5 763.3 234.4 763.3 234.3C763.4 234.3 763.4 234.2 763.5 234.2C763.567 234.2 763.633 234.2 763.7 234.2C763.9 234.2 763.9 234.2 763.8 234.4C763.733 234.467 763.7 234.567 763.7 234.7V234.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.8 271.2C788.867 271.2 788.967 271.233 789.1 271.3C789.1 271.367 789.067 271.4 789 271.4C788.867 271.4 788.733 271.4 788.6 271.4C788.6 271.3 788.5 271.3 788.5 271.2C788.6 271.2 788.6 271.2 788.7 271.2C788.7 271.133 788.733 271.133 788.8 271.2V271.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M766.9 264.5C766.9 264.5 766.9 264.6 766.8 264.6C766.7 264.6 766.5 264.6 766.5 264.4C766.5 264.4 766.6 264.3 766.7 264.2C766.8 264.2 766.9 264.3 766.9 264.5V264.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M763.6 254.7C763.533 254.767 763.467 254.867 763.4 255H763.3C763.2 254.9 763.2 254.7 763.3 254.6C763.3 254.6 763.5 254.6 763.6 254.6V254.7V254.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.6 231.6C754.4 231.5 754.4 231.4 754.4 231.2C754.4 231.2 754.4 231.1 754.5 231C754.567 231.067 754.6 231.1 754.6 231.1C754.667 231.233 754.733 231.367 754.8 231.5C754.8 231.5 754.7 231.5 754.6 231.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M803 276.4C803.067 276.4 803.167 276.433 803.3 276.5C803.5 276.5 803.5 276.6 803.6 276.8C803.5 276.9 803.5 276.9 803.4 276.9C803.2 276.8 803 276.6 803 276.4V276.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M800.1 271.3C800.167 271.367 800.233 271.433 800.3 271.5C800.3 271.5 800.4 271.6 800.3 271.6C800.3 271.7 800.2 271.7 800.2 271.7C800.067 271.7 799.967 271.667 799.9 271.6C799.9 271.5 799.9 271.5 799.9 271.4C799.967 271.4 800.033 271.367 800.1 271.3V271.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.8 277.6C788.8 277.667 788.8 277.733 788.8 277.8C788.733 277.8 788.667 277.8 788.6 277.8L788.5 277.7C788.567 277.567 788.633 277.4 788.7 277.2C788.7 277.2 788.733 277.2 788.8 277.2C788.8 277.333 788.8 277.467 788.8 277.6V277.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.7 248.8C815.7 248.6 815.9 248.6 816 248.6C816.1 248.6 816.1 248.7 816.2 248.7C816.2 248.8 816 249 815.9 248.9C815.8 248.9 815.7 248.9 815.7 248.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.5 230.2C758.5 230.2 758.533 230.2 758.6 230.2C758.6 230.267 758.6 230.3 758.6 230.3C758.6 230.367 758.6 230.4 758.6 230.4C758.533 230.4 758.467 230.4 758.4 230.4C758.3 230.4 758.1 230.4 758 230.4C757.9 230.3 758.2 230.2 758.5 230.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M750.5 251.9C750.5 252 750.4 252 750.3 252C750.2 252 750.1 251.9 750.2 251.8L750.3 251.7C750.4 251.7 750.5 251.7 750.5 251.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M775.4 232.3C775.3 232.3 775.3 232.4 775.2 232.4C775.2 232.4 775.1 232.4 775.1 232.3C775.033 232.233 775.033 232.167 775.1 232.1C775.1 232 775.1 232 775.2 232H775.3C775.367 232.067 775.4 232.167 775.4 232.3V232.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.4 244.4C756.4 244.4 756.367 244.433 756.3 244.5C756.3 244.5 755.9 244.4 755.9 244.3C755.9 244.233 755.9 244.2 755.9 244.2C756.1 244.1 756.3 244.2 756.4 244.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M835.2 253.4C835 253.4 835 253.4 834.9 253.4C834.9 253.333 834.867 253.3 834.8 253.3C834.867 253.3 834.9 253.3 834.9 253.3C835.167 253.233 835.433 253.2 835.7 253.2C835.7 253.2 835.7 253.233 835.7 253.3C835.7 253.3 835.667 253.3 835.6 253.3C835.4 253.4 835.3 253.4 835.2 253.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M763.7 236.7C763.7 236.7 763.667 236.667 763.6 236.6C763.5 236.4 763.5 236.2 763.8 236.2C763.867 236.2 763.9 236.2 763.9 236.2C764 236.2 763.9 236.3 763.9 236.3C763.833 236.433 763.767 236.6 763.7 236.8V236.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.1 251.5C802 251.6 801.9 251.6 801.9 251.6C801.833 251.533 801.767 251.467 801.7 251.4C801.7 251.3 801.7 251.2 801.7 251.2C801.8 251.2 801.9 251.2 801.9 251.2C802 251.3 802 251.4 802.1 251.5V251.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M753.7 248.2C753.767 248.267 753.8 248.3 753.8 248.3C753.9 248.3 754.1 248.3 754 248.5C754 248.6 753.9 248.6 753.9 248.6C753.767 248.6 753.667 248.567 753.6 248.5C753.6 248.4 753.6 248.3 753.6 248.3C753.6 248.3 753.7 248.3 753.7 248.2V248.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.6 254.8C754.733 254.867 754.867 254.933 755 255C754.867 255 754.733 255 754.6 255C754.533 255 754.467 254.967 754.4 254.9C754.333 254.9 754.3 254.867 754.3 254.8C754.3 254.8 754.3 254.8 754.4 254.8C754.467 254.8 754.533 254.833 754.6 254.9C754.6 254.833 754.6 254.8 754.6 254.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M755.9 234C755.833 234 755.8 234.033 755.8 234.1C755.6 233.9 755.433 233.733 755.3 233.6C755.3 233.6 755.3 233.567 755.3 233.5C755.5 233.633 755.7 233.767 755.9 233.9C755.9 233.9 755.9 233.933 755.9 234Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.2 233.2C771 233.1 770.9 233 771 232.8L771.1 232.7C771.167 232.833 771.233 232.967 771.3 233.1C771.4 233.1 771.3 233.2 771.3 233.2C771.3 233.2 771.267 233.2 771.2 233.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M816.2 278.1C816.267 278.167 816.333 278.233 816.4 278.3C816.4 278.4 816.4 278.5 816.4 278.5C816.4 278.5 816.3 278.5 816.2 278.5C816.133 278.433 816.067 278.367 816 278.3C816 278.3 816.1 278.2 816.2 278.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M771 272.3C771.067 272.167 771.133 272.067 771.2 272C771.3 271.8 771.3 271.8 771.5 272C771.5 272.067 771.5 272.133 771.5 272.2L771.4 272.3C771.267 272.3 771.133 272.267 771 272.2V272.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M757.1 231C757.1 231.1 757 231.1 757 231.1C756.867 231.033 756.767 231 756.7 231C756.7 230.9 756.7 230.8 756.7 230.8C756.7 230.7 756.8 230.7 756.8 230.7C756.933 230.767 757.033 230.833 757.1 230.9V231Z"
          fill="#F7F5E8"
        />
        <path
          d="M807.2 278.9C807.1 279.1 807 279.1 806.8 279V278.9C806.867 278.833 806.933 278.767 807 278.7C807.1 278.7 807.1 278.7 807.2 278.8C807.2 278.8 807.2 278.833 807.2 278.9V278.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M763.6 263.4C763.6 263.4 763.5 263.5 763.5 263.6C763.4 263.6 763.3 263.5 763.2 263.5C763.2 263.5 763.1 263.4 763.2 263.4C763.333 263.333 763.467 263.267 763.6 263.2C763.6 263.2 763.6 263.3 763.6 263.4V263.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.2 279.5C789.067 279.5 788.967 279.533 788.9 279.6C788.8 279.6 788.7 279.5 788.7 279.4C788.7 279.4 788.7 279.3 788.8 279.2C788.8 279.2 788.9 279.2 789 279.2C789 279.3 789.1 279.4 789.2 279.5V279.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.7 268.6C810.833 268.667 810.9 268.767 810.9 268.9C810.9 268.9 810.9 269 810.8 269C810.7 269 810.6 268.9 810.6 268.7C810.6 268.7 810.6 268.667 810.6 268.6C810.6 268.6 810.633 268.6 810.7 268.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M766.6 243.8C766.5 243.9 766.4 243.9 766.4 243.9C766.3 243.9 766.2 243.8 766.2 243.7C766.2 243.7 766.3 243.7 766.4 243.7C766.5 243.7 766.5 243.8 766.6 243.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M836.5 248.4C836.433 248.4 836.4 248.4 836.4 248.4C836.4 248.3 836.4 248.3 836.5 248.3C836.567 248.3 836.667 248.3 836.8 248.3C836.8 248.3 836.8 248.3 836.9 248.4H836.8C836.733 248.4 836.633 248.4 836.5 248.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M783.9 263.1C783.967 263.1 784 263.133 784 263.2C783.8 263.2 783.6 263.2 783.4 263.2C783.333 263.2 783.3 263.2 783.3 263.2C783.3 263.1 783.3 263.1 783.3 263.1C783.5 263.1 783.7 263.1 783.9 263.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.9 252.2C815.8 252.2 815.8 252.3 815.8 252.4C815.8 252.4 815.7 252.4 815.6 252.4V252.3C815.667 252.167 815.7 252.067 815.7 252C815.8 251.9 815.8 251.9 815.9 251.9V252C815.9 252.067 815.9 252.133 815.9 252.2V252.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M777.8 246.3C777.9 246.2 778 246.2 778 246.1C778.1 246.1 778.2 246.2 778.2 246.3C778.2 246.4 778.1 246.5 778 246.5C777.9 246.5 777.9 246.4 777.8 246.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.3 258.5C754.2 258.4 754.2 258.4 754.2 258.4C754.2 258.2 754.3 258.1 754.5 258.1C754.5 258.1 754.6 258.1 754.6 258.2C754.6 258.3 754.4 258.4 754.3 258.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.6 233.5C758.533 233.5 758.467 233.467 758.4 233.4V233.3C758.5 233.2 758.8 233.3 758.8 233.4C758.8 233.4 758.8 233.4 758.8 233.5C758.733 233.5 758.667 233.5 758.6 233.5V233.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M757.6 245.8C757.6 245.8 757.567 245.767 757.5 245.7V245.6C757.6 245.5 757.8 245.6 757.9 245.7L757.8 245.8C757.733 245.8 757.667 245.8 757.6 245.8V245.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M819.7 247.8C819.633 247.733 819.567 247.7 819.5 247.7C819.567 247.633 819.633 247.6 819.7 247.6C819.767 247.6 819.833 247.6 819.9 247.6C819.967 247.6 820 247.633 820 247.7L819.9 247.8C819.8 247.8 819.7 247.8 819.7 247.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M819.2 275.9C819.1 276 819 276 819 276C818.933 275.933 818.867 275.867 818.8 275.8C818.9 275.8 818.9 275.7 819 275.7C819 275.7 819.1 275.8 819.2 275.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M778.1 274C778.167 274.067 778.233 274.1 778.3 274.1V274.2C778.3 274.2 778.3 274.3 778.2 274.3C778.133 274.233 778.067 274.2 778 274.2C777.933 274.133 777.9 274.1 777.9 274.1C777.9 274.033 777.933 274 778 274C778.067 274 778.1 274 778.1 274Z"
          fill="#F7F5E8"
        />
        <path
          d="M779.9 266.4C779.833 266.4 779.8 266.4 779.8 266.4C779.667 266.467 779.567 266.467 779.5 266.4C779.4 266.3 779.5 266.2 779.5 266.3C779.633 266.3 779.733 266.3 779.8 266.3C779.8 266.3 779.833 266.333 779.9 266.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M797.4 278.1C797.4 278.2 797.3 278.2 797.2 278.3C797.1 278.3 797.1 278.3 797.1 278.3C797 278.3 797 278.3 797 278.3C797.1 278.1 797.1 278 797.3 278C797.3 278 797.333 278.033 797.4 278.1V278.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M826.7 250.9C826.6 250.9 826.5 250.9 826.4 250.9C826.333 250.833 826.3 250.767 826.3 250.7C826.2 250.6 826.5 250.5 826.5 250.6C826.6 250.6 826.6 250.7 826.7 250.9V250.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.6 233.2C754.6 233.267 754.6 233.3 754.6 233.3C754.5 233.4 754.3 233.3 754.2 233.2C754.2 233.2 754.2 233.167 754.2 233.1C754.3 233 754.6 233.1 754.6 233.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M759 240.3C759 240.3 759 240.3 759.1 240.3C759.1 240.3 759.1 240.333 759.1 240.4V240.5C758.967 240.433 758.833 240.4 758.7 240.4V240.3C758.7 240.3 758.7 240.2 758.8 240.2C758.8 240.2 758.867 240.233 759 240.3V240.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.4 275.7C773.4 275.7 773.3 275.8 773.3 275.7C773.167 275.7 773.067 275.667 773 275.6C773 275.5 773 275.5 773.1 275.4C773.3 275.4 773.4 275.6 773.4 275.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.4 274.2C756.333 274.133 756.3 274.1 756.3 274.1C756.2 274.1 756.2 274 756.2 274L756.3 273.9C756.367 273.9 756.467 273.933 756.6 274L756.7 274.1L756.6 274.2C756.533 274.2 756.467 274.2 756.4 274.2V274.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M785.6 278.8C785.6 278.8 785.5 278.8 785.4 278.8C785.3 278.7 785.3 278.6 785.2 278.6C785.2 278.6 785.233 278.567 785.3 278.5C785.3 278.5 785.6 278.6 785.7 278.6C785.7 278.667 785.667 278.733 785.6 278.8V278.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M761 234.5C761 234.5 760.967 234.5 760.9 234.5C760.9 234.433 760.867 234.4 760.8 234.4C760.9 234.3 760.9 234.3 760.9 234.3C761.033 234.3 761.133 234.333 761.2 234.4C761.267 234.467 761.3 234.5 761.3 234.5C761.3 234.5 761.267 234.5 761.2 234.5C761.133 234.5 761.067 234.5 761 234.5V234.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M822.2 243.7C822.267 243.7 822.333 243.733 822.4 243.8H822.5C822.4 244 822.1 244 822 243.9C822 243.8 822 243.8 822 243.8C822.133 243.733 822.2 243.7 822.2 243.7V243.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M820.3 251C820.3 251.1 820 251.1 819.9 251C819.9 250.933 819.9 250.9 819.9 250.9C820 250.8 820.3 250.8 820.3 250.9C820.3 250.967 820.3 251 820.3 251Z"
          fill="#F7F5E8"
        />
        <path
          d="M779.6 245.1C779.4 245 779.3 245 779.2 245C779.2 245 779.1 244.8 779.2 244.8C779.2 244.8 779.3 244.7 779.4 244.8C779.4 244.8 779.5 244.9 779.6 245.1V245.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.3 269.3C789.233 269.3 789.167 269.3 789.1 269.3C788.967 269.3 788.933 269.233 789 269.1L789.1 269C789.167 269.067 789.233 269.167 789.3 269.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M824.3 250.8C824.167 250.8 824 250.8 823.8 250.8C823.8 250.8 823.7 250.8 823.7 250.7C823.7 250.7 823.8 250.6 823.9 250.6C824 250.6 824.2 250.6 824.3 250.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.7 248C809.6 247.9 809.6 247.8 809.6 247.8C809.5 247.7 809.7 247.6 809.8 247.6C809.8 247.7 809.9 247.8 809.9 247.8C809.9 247.9 809.8 247.9 809.7 248Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.7 265.3C772.833 265.3 772.967 265.333 773.1 265.4L773.2 265.5V265.6C773.1 265.6 773 265.6 773 265.5C772.867 265.433 772.767 265.367 772.7 265.3V265.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M770.6 236C770.5 236 770.4 236.1 770.3 236.1C770.3 236.1 770.2 236 770.1 236C770.1 235.9 770.1 235.9 770.2 235.9C770.333 235.9 770.467 235.9 770.6 235.9C770.6 235.9 770.6 235.933 770.6 236Z"
          fill="#F7F5E8"
        />
        <path
          d="M790 245.1C789.933 245.1 789.9 245.1 789.9 245.1C789.833 245.033 789.8 244.967 789.8 244.9C789.8 244.8 789.9 244.8 789.9 244.8C789.9 244.8 790 244.8 790 244.9C790 244.967 790 245.033 790 245.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M823.2 268C823.267 268.067 823.3 268.1 823.3 268.1C823.4 268.2 823.3 268.3 823.2 268.3C823.1 268.3 823 268.2 823 268.2C823 268.1 823.1 268 823.2 268Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.4 246.7C809.333 246.633 809.3 246.567 809.3 246.5C809.367 246.5 809.467 246.467 809.6 246.4C809.6 246.4 809.6 246.5 809.7 246.5C809.633 246.567 809.533 246.633 809.4 246.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M776.7 268.8C776.5 268.8 776.5 268.8 776.4 268.8C776.3 268.8 776.2 268.7 776.2 268.6C776.267 268.6 776.367 268.6 776.5 268.6C776.5 268.6 776.6 268.7 776.7 268.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M798.8 270.2C798.8 270.067 798.8 269.967 798.8 269.9C798.8 269.9 798.9 269.9 798.9 270C798.9 270.133 798.867 270.267 798.8 270.4V270.5C798.7 270.4 798.7 270.4 798.7 270.4C798.7 270.333 798.733 270.267 798.8 270.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M817.9 273.4C817.8 273.4 817.7 273.4 817.6 273.4L817.5 273.3C817.5 273.3 817.5 273.2 817.6 273.2C817.667 273.2 817.733 273.2 817.8 273.2C817.8 273.3 817.8 273.3 817.9 273.4V273.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M813.3 245.9C813.2 246 813.2 246 813.1 246.1C813 246.1 812.9 246 813 245.9C813 245.8 813.1 245.8 813.1 245.8C813.2 245.8 813.2 245.8 813.3 245.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M784.1 260.1C784.033 260.1 783.967 260.1 783.9 260.1L783.8 260C783.933 259.933 784.033 259.9 784.1 259.9C784.1 259.9 784.1 259.967 784.1 260.1V260.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.4 251.2C772.333 251.333 772.267 251.4 772.2 251.4C772.1 251.5 772.1 251.5 772 251.4V251.3C772.067 251.233 772.133 251.167 772.2 251.1C772.2 251.1 772.3 251.2 772.4 251.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.3 242.7C758.233 242.767 758.133 242.8 758 242.8C757.933 242.8 757.9 242.8 757.9 242.8C757.9 242.7 757.9 242.6 758 242.6C758.067 242.6 758.167 242.6 758.3 242.6C758.3 242.6 758.3 242.633 758.3 242.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M812.6 254.2C812.5 254.2 812.4 254.2 812.4 254.2C812.3 254.2 812.1 254.1 812.2 254C812.267 254 812.333 254 812.4 254C812.5 254 812.5 254.1 812.6 254.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.6 271.2C772.467 271.133 772.333 271.067 772.2 271V270.9C772.3 270.8 772.3 270.8 772.4 270.8C772.533 270.933 772.6 271.067 772.6 271.2V271.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M778.3 245.6C778.3 245.533 778.267 245.467 778.2 245.4V245.3C778.2 245.3 778.3 245.2 778.3 245.3C778.367 245.3 778.433 245.333 778.5 245.4C778.5 245.5 778.5 245.5 778.5 245.6C778.5 245.6 778.4 245.6 778.3 245.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.8 257.5C802.867 257.433 802.9 257.4 802.9 257.4C802.9 257.4 802.933 257.433 803 257.5C803 257.567 803 257.667 803 257.8C803 257.8 803 257.9 803 257.8C802.9 257.8 802.8 257.8 802.8 257.8C802.8 257.667 802.8 257.567 802.8 257.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M797.4 280.1C797.5 280.1 797.6 280.2 797.6 280.2C797.533 280.267 797.467 280.333 797.4 280.4C797.3 280.4 797.2 280.3 797.2 280.3C797.267 280.233 797.333 280.167 797.4 280.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M751.5 275.5C751.3 275.5 751.133 275.5 751 275.5L750.9 275.4C750.9 275.333 750.933 275.3 751 275.3C751.1 275.3 751.3 275.3 751.4 275.4C751.4 275.4 751.433 275.433 751.5 275.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.2 279.2C773.067 279.2 772.933 279.2 772.8 279.2C772.8 279.1 772.9 279 772.9 279C773 279 773.1 279 773.1 279C773.2 279 773.2 279.1 773.2 279.2V279.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M790.6 285C790.5 285.1 790.4 285.2 790.2 285.2C790.2 285.1 790.1 285.1 790.1 285.1C790.1 285 790.2 285 790.2 285C790.333 285 790.5 285 790.7 285H790.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M812.3 288.6C812.167 288.6 812.067 288.6 812 288.6C812 288.533 812 288.5 812 288.5C812.2 288.5 812.4 288.5 812.6 288.5C812.6 288.6 812.6 288.6 812.6 288.6C812.467 288.6 812.367 288.6 812.3 288.6V288.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M832.1 276.4C832.167 276.4 832.233 276.433 832.3 276.5C832.367 276.5 832.4 276.5 832.4 276.5L832.3 276.6C832.167 276.533 832.033 276.467 831.9 276.4C831.9 276.4 831.933 276.4 832 276.4C832 276.4 832.033 276.4 832.1 276.4V276.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M822.4 275.1C822.4 275.1 822.433 275.1 822.5 275.1C822.5 275.167 822.533 275.2 822.6 275.2C822.533 275.267 822.467 275.3 822.4 275.3C822.4 275.233 822.367 275.2 822.3 275.2C822.3 275.133 822.267 275.1 822.2 275.1C822.267 275.1 822.333 275.1 822.4 275.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M799.2 271.9L799.1 272C799.033 272 798.967 271.967 798.9 271.9L799 271.8C799.067 271.8 799.133 271.833 799.2 271.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.8 240.6C771.8 240.7 771.9 240.8 771.9 240.8C771.9 240.9 771.8 240.9 771.7 240.9C771.7 240.833 771.667 240.767 771.6 240.7C771.667 240.633 771.733 240.6 771.8 240.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.9 245.6C815.9 245.5 815.9 245.4 815.9 245.3H816C816.1 245.3 816.1 245.4 816.1 245.4C816.033 245.467 815.967 245.533 815.9 245.6V245.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.9 235.7C758.967 235.7 759.033 235.733 759.1 235.8C759.1 235.8 759.133 235.8 759.2 235.8C759.133 235.8 759.1 235.8 759.1 235.8C758.967 235.867 758.867 235.9 758.8 235.9C758.7 235.9 758.7 235.8 758.7 235.8V235.7C758.833 235.7 758.9 235.7 758.9 235.7V235.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.1 253.2C810.167 253.267 810.2 253.333 810.2 253.4L810.1 253.5C810 253.5 810 253.4 809.9 253.4C809.9 253.3 810 253.3 810.1 253.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M812.9 268.8C812.767 268.867 812.667 268.9 812.6 268.9C812.5 268.9 812.5 268.9 812.5 268.8C812.4 268.8 812.5 268.8 812.5 268.8C812.567 268.733 812.667 268.733 812.8 268.8C812.8 268.8 812.833 268.8 812.9 268.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M774 231.9C773.9 231.8 773.7 231.7 773.8 231.5C773.8 231.5 773.8 231.467 773.8 231.4L773.9 231.5C773.967 231.633 774 231.767 774 231.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M832 247.8C832.133 247.867 832.2 247.9 832.2 247.9C832.133 247.967 832.033 248 831.9 248C831.9 248 831.9 248 831.8 247.9C831.867 247.9 831.933 247.867 832 247.8V247.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.9 237.7C754.967 237.767 755.033 237.8 755.1 237.8C755.033 237.867 754.967 237.9 754.9 237.9L754.8 237.8C754.8 237.8 754.833 237.767 754.9 237.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M806.8 264C806.8 263.933 806.833 263.867 806.9 263.8C806.967 263.8 807.033 263.8 807.1 263.8V263.9C807.033 263.967 806.967 264 806.9 264H806.8V264Z"
          fill="#F7F5E8"
        />
        <path
          d="M822 268.6C821.933 268.6 821.867 268.6 821.8 268.6C821.7 268.5 821.7 268.5 821.7 268.4C821.767 268.4 821.833 268.4 821.9 268.4C822 268.4 822 268.5 822 268.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M751.1 253.6C751.033 253.6 750.967 253.6 750.9 253.6C750.833 253.6 750.833 253.567 750.9 253.5C751.033 253.5 751.167 253.5 751.3 253.5C751.3 253.5 751.3 253.533 751.3 253.6C751.167 253.667 751.1 253.667 751.1 253.6V253.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M781.9 253.3C781.8 253.3 781.8 253.4 781.7 253.3C781.7 253.3 781.7 253.2 781.6 253.2C781.733 253.2 781.833 253.2 781.9 253.2C781.9 253.2 781.9 253.2 781.9 253.3V253.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M814.7 245.5C814.6 245.5 814.6 245.5 814.6 245.4L814.7 245.3C814.767 245.367 814.867 245.4 815 245.4C815 245.4 814.967 245.4 814.9 245.4C814.833 245.467 814.767 245.5 814.7 245.5V245.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M835.5 254.7C835.6 254.8 835.6 254.9 835.6 254.9C835.6 254.9 835.5 254.9 835.4 255C835.4 254.9 835.4 254.9 835.4 254.8C835.4 254.8 835.433 254.767 835.5 254.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M798.1 267.2C798.033 267.267 797.967 267.333 797.9 267.4C797.833 267.4 797.8 267.4 797.8 267.4C797.867 267.267 797.933 267.2 798 267.2C798 267.1 798.1 267.2 798.1 267.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.6 241.5C758.533 241.567 758.467 241.6 758.4 241.6C758.4 241.6 758.4 241.567 758.4 241.5C758.4 241.4 758.4 241.4 758.5 241.4C758.5 241.4 758.533 241.433 758.6 241.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.6 231.6C772.533 231.6 772.467 231.6 772.4 231.6C772.333 231.6 772.3 231.567 772.3 231.5C772.367 231.5 772.4 231.5 772.4 231.5C772.533 231.5 772.633 231.533 772.7 231.6C772.767 231.6 772.833 231.6 772.9 231.6C772.833 231.6 772.767 231.6 772.7 231.6C772.633 231.6 772.6 231.6 772.6 231.6V231.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M751 260.6C750.867 260.6 750.767 260.6 750.7 260.6C750.7 260.6 750.6 260.5 750.6 260.4C750.7 260.4 750.8 260.3 750.8 260.3C750.867 260.433 750.933 260.533 751 260.6V260.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M777.2 269.1C777.133 269.1 777.067 269.1 777 269.1C776.9 269.1 776.9 269 776.9 268.9C776.967 268.9 777.033 268.9 777.1 268.9C777.2 268.9 777.2 269 777.2 269.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M805.4 273.3C805.467 273.3 805.567 273.333 805.7 273.4C805.7 273.5 805.6 273.5 805.6 273.5C805.533 273.433 805.433 273.367 805.3 273.3C805.3 273.3 805.267 273.3 805.2 273.3C805.267 273.3 805.333 273.3 805.4 273.3V273.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M781.5 270.2C781.433 270.2 781.4 270.2 781.4 270.2C781.3 270.2 781.2 270.2 781.1 270L781.2 269.9C781.4 269.833 781.5 269.9 781.5 270.1C781.5 270.1 781.5 270.133 781.5 270.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M779.9 265.4C779.833 265.333 779.8 265.267 779.8 265.2C779.8 265.2 779.833 265.167 779.9 265.1C780 265.1 780 265.2 780 265.2C780 265.267 779.967 265.333 779.9 265.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.7 233.9C771.633 233.9 771.6 233.867 771.6 233.8C771.667 233.733 771.733 233.7 771.8 233.7C771.9 233.7 771.9 233.7 772 233.8C771.867 233.867 771.767 233.9 771.7 233.9V233.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M782.5 244.6C782.5 244.733 782.5 244.867 782.5 245C782.367 244.933 782.267 244.867 782.2 244.8C782.1 244.8 782.1 244.8 782.1 244.7H782.2C782.333 244.7 782.433 244.7 782.5 244.7V244.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M784.3 244.5C784.367 244.567 784.433 244.6 784.5 244.6C784.433 244.667 784.333 244.7 784.2 244.7C784.2 244.7 784.2 244.7 784.1 244.6C784.167 244.533 784.233 244.5 784.3 244.5V244.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.8 261.6C754.867 261.667 754.9 261.7 754.9 261.7C754.9 261.8 754.8 261.8 754.8 261.8C754.733 261.733 754.7 261.667 754.7 261.6C754.7 261.6 754.733 261.6 754.8 261.6V261.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M797.2 276C797.133 275.933 797.1 275.9 797.1 275.9C797.033 275.9 797 275.867 797 275.8C797.067 275.8 797.1 275.8 797.1 275.8C797.167 275.8 797.267 275.833 797.4 275.9C797.4 275.9 797.433 275.933 797.5 276C797.433 276 797.4 276 797.4 276C797.333 276 797.267 276 797.2 276V276Z"
          fill="#F7F5E8"
        />
        <path
          d="M810 270.5C809.867 270.433 809.7 270.367 809.5 270.3C809.5 270.2 809.6 270.2 809.6 270.2C809.733 270.333 809.867 270.433 810 270.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M760.6 240.7C760.467 240.833 760.367 240.833 760.3 240.7C760.233 240.7 760.2 240.7 760.2 240.7C760.333 240.633 760.433 240.6 760.5 240.6C760.567 240.6 760.6 240.6 760.6 240.6C760.6 240.7 760.6 240.7 760.6 240.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M768.3 243.9V244C768.167 244 768.067 243.967 768 243.9C768.1 243.9 768.1 243.8 768.1 243.8C768.167 243.8 768.233 243.833 768.3 243.9V243.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.1 272.7C756.033 272.633 756 272.6 756 272.6C755.933 272.6 755.9 272.567 755.9 272.5C755.9 272.5 755.933 272.5 756 272.5C756.067 272.5 756.167 272.533 756.3 272.6C756.3 272.6 756.333 272.633 756.4 272.7C756.333 272.7 756.3 272.7 756.3 272.7C756.233 272.7 756.167 272.7 756.1 272.7V272.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M804.3 263.8C804.2 263.9 804.2 263.9 804.2 263.9C804.133 263.9 804.067 263.9 804 263.9C803.9 263.9 803.9 263.8 803.9 263.8C804 263.7 804.2 263.7 804.3 263.8V263.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M804.1 280C804.167 280.067 804.2 280.1 804.2 280.1C804.133 280.167 804.1 280.2 804.1 280.2C804 280.2 804 280.1 803.9 280.1C803.967 280.1 804.033 280.067 804.1 280Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.3 239.7C809.233 239.7 809.167 239.733 809.1 239.8C809.033 239.733 809 239.667 809 239.6L809.1 239.5C809.167 239.567 809.233 239.633 809.3 239.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.8 278.8C789.7 278.7 789.6 278.6 789.6 278.6C789.6 278.5 789.7 278.5 789.8 278.4L789.9 278.5C789.9 278.567 789.867 278.667 789.8 278.8V278.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M796.6 279.9C796.7 280 796.8 280 796.8 280.1C796.7 280.2 796.6 280.2 796.5 280.2C796.5 280.2 796.467 280.167 796.4 280.1C796.467 280.033 796.533 279.967 796.6 279.9V279.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M770.8 276.3C770.867 276.3 770.9 276.3 770.9 276.3C771 276.3 771 276.4 771 276.4C771 276.5 770.9 276.5 770.9 276.5C770.833 276.433 770.767 276.4 770.7 276.4C770.633 276.333 770.6 276.3 770.6 276.3C770.667 276.3 770.733 276.3 770.8 276.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.2 253.9C758.2 254 758.2 254.1 758.1 254C758.033 254 757.967 254 757.9 254C758 253.9 758 253.9 758 253.9C758.067 253.9 758.133 253.9 758.2 253.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M749.1 273.8C749.167 273.8 749.233 273.833 749.3 273.9C749.367 273.9 749.4 273.933 749.4 274C749.333 274 749.3 274 749.3 274C749.233 274 749.167 273.967 749.1 273.9C749 273.9 749 273.9 749.1 273.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M776.3 266.4C776.3 266.333 776.267 266.3 776.2 266.3C776.267 266.233 776.333 266.2 776.4 266.2L776.5 266.3C776.433 266.367 776.367 266.4 776.3 266.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.5 263.4C752.433 263.333 752.367 263.3 752.3 263.3C752.4 263.3 752.5 263.2 752.5 263.2C752.6 263.2 752.7 263.2 752.7 263.3C752.7 263.4 752.6 263.4 752.5 263.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.7 283C789.7 282.933 789.7 282.9 789.7 282.9C789.833 282.833 789.933 282.8 790 282.8C790 282.7 790.1 282.8 790.1 282.8V282.9C789.967 282.967 789.833 283 789.7 283Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.9 271.1C801.833 271.1 801.767 271.1 801.7 271.1C801.633 271.1 801.567 271.1 801.5 271.1C801.567 271.033 801.6 271 801.6 271C801.733 271 801.833 271 801.9 271C801.9 271.067 801.9 271.1 801.9 271.1V271.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.4 286.9C803.4 287 803.4 287 803.4 287C803.333 287 803.233 287 803.1 287V286.9C803.2 286.8 803.4 286.8 803.4 286.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.7 262C803.767 262.067 803.833 262.133 803.9 262.2C803.833 262.2 803.8 262.2 803.8 262.2C803.733 262.2 803.667 262.2 803.6 262.2C803.667 262.133 803.7 262.067 803.7 262Z"
          fill="#F7F5E8"
        />
        <path
          d="M824.9 264.7C824.833 264.767 824.8 264.8 824.8 264.8C824.733 264.733 824.667 264.667 824.6 264.6L824.7 264.5C824.767 264.567 824.833 264.633 824.9 264.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.9 254C756.9 254 756.867 253.967 756.8 253.9L756.9 253.8C756.967 253.867 757 253.933 757 254C757 254 756.967 254 756.9 254Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.3 252.9C752.3 252.967 752.267 253.033 752.2 253.1C752.2 253.033 752.167 252.967 752.1 252.9L752.2 252.8C752.267 252.867 752.3 252.9 752.3 252.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M761.5 252.3C761.567 252.3 761.6 252.3 761.6 252.3C761.667 252.3 761.733 252.3 761.8 252.3C761.8 252.367 761.833 252.4 761.9 252.4C761.833 252.4 761.767 252.4 761.7 252.4C761.633 252.4 761.567 252.367 761.5 252.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.4 249.6C752.4 249.667 752.4 249.7 752.4 249.7C752.267 249.7 752.167 249.667 752.1 249.6C752.1 249.6 752.1 249.5 752.2 249.5C752.267 249.567 752.333 249.6 752.4 249.6V249.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.3 238.6C772.367 238.667 772.433 238.733 772.5 238.8C772.433 238.8 772.367 238.8 772.3 238.8C772.3 238.8 772.267 238.8 772.2 238.8C772.267 238.733 772.3 238.667 772.3 238.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M840 249C839.867 249 839.767 249 839.7 249C839.633 249 839.6 248.967 839.6 248.9C839.733 248.9 839.833 248.9 839.9 248.9C839.9 248.9 839.933 248.933 840 249Z"
          fill="#F7F5E8"
        />
        <path
          d="M770.4 235.2C770.333 235.2 770.267 235.2 770.2 235.2V235.1C770.267 235.1 770.333 235.067 770.4 235C770.4 235.067 770.4 235.133 770.4 235.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M805 257C805.067 256.933 805.167 256.867 805.3 256.8L805.4 256.9C805.4 256.9 805.4 257 805.3 257C805.233 257 805.133 257 805 257V257Z"
          fill="#F7F5E8"
        />
        <path
          d="M835 261.2C834.933 261.2 834.867 261.2 834.8 261.2V261.1C834.867 261.033 834.9 261 834.9 261C834.967 261.067 835 261.133 835 261.2V261.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M766 250.5C765.933 250.567 765.9 250.6 765.9 250.6C765.833 250.6 765.8 250.567 765.8 250.5C765.7 250.5 765.8 250.4 765.8 250.4C765.867 250.4 765.933 250.433 766 250.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M768.3 250.9L768.2 250.8C768.267 250.733 768.333 250.7 768.4 250.7C768.4 250.7 768.5 250.8 768.4 250.8C768.4 250.867 768.367 250.9 768.3 250.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.8 248.5L752.7 248.6C752.6 248.6 752.6 248.5 752.6 248.5C752.6 248.4 752.6 248.3 752.7 248.3C752.7 248.367 752.733 248.433 752.8 248.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M828.3 242.7C828.3 242.8 828.2 242.9 828.1 242.9C828 242.9 828 242.8 828 242.8V242.7C828.133 242.7 828.233 242.7 828.3 242.7V242.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M814.4 256C814.4 256.1 814.3 256.1 814.3 256.1C814.233 256.1 814.2 256.067 814.2 256C814.2 256 814.233 255.967 814.3 255.9L814.4 256Z"
          fill="#F7F5E8"
        />
        <path
          d="M786.3 251C786.167 251.067 786.067 251.1 786 251.1C786 251.1 785.967 251.1 785.9 251.1C785.9 251.033 785.9 251 785.9 251C786.033 251 786.133 251 786.2 251C786.2 251 786.233 251 786.3 251Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.9 235.2C756.833 235.2 756.767 235.167 756.7 235.1C756.767 235.1 756.867 235.1 757 235.1C757.067 235.1 757.133 235.133 757.2 235.2C757.133 235.2 757.033 235.2 756.9 235.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.5 245.5C756.433 245.567 756.4 245.6 756.4 245.6C756.333 245.533 756.267 245.467 756.2 245.4C756.3 245.4 756.3 245.4 756.3 245.4C756.367 245.4 756.433 245.433 756.5 245.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M804.4 251.8C804.267 251.8 804.167 251.8 804.1 251.8C804.1 251.8 804.1 251.7 804.2 251.6C804.2 251.6 804.233 251.633 804.3 251.7C804.3 251.7 804.333 251.733 804.4 251.8V251.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.5 243.8C754.433 243.8 754.4 243.767 754.4 243.7C754.467 243.7 754.533 243.7 754.6 243.7C754.6 243.767 754.567 243.8 754.5 243.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M812.4 243.3C812.4 243.367 812.367 243.4 812.3 243.4C812.3 243.333 812.3 243.267 812.3 243.2C812.3 243.2 812.3 243.167 812.3 243.1C812.367 243.1 812.4 243.1 812.4 243.1C812.467 243.1 812.5 243.133 812.5 243.2C812.5 243.2 812.467 243.233 812.4 243.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M832.2 246.1C832.267 246.1 832.3 246.067 832.3 246C832.367 246.067 832.4 246.133 832.4 246.2L832.3 246.3C832.3 246.233 832.267 246.167 832.2 246.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M759.1 234.8C759.033 234.733 758.967 234.7 758.9 234.7C758.833 234.7 758.8 234.667 758.8 234.6C758.867 234.6 758.967 234.633 759.1 234.7C759.1 234.7 759.1 234.733 759.1 234.8V234.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.4 229C758.4 229 758.367 229 758.3 229L758.2 228.9C758.267 228.9 758.333 228.867 758.4 228.8C758.4 228.867 758.4 228.933 758.4 229Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.6 243.1C815.6 243.1 815.633 243.133 815.7 243.2C815.6 243.2 815.6 243.3 815.6 243.3C815.533 243.233 815.5 243.167 815.5 243.1C815.5 243.1 815.533 243.1 815.6 243.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M833.7 245.6C833.633 245.6 833.567 245.6 833.5 245.6C833.5 245.533 833.467 245.5 833.4 245.5C833.467 245.5 833.533 245.5 833.6 245.5C833.667 245.5 833.733 245.533 833.8 245.6C833.733 245.6 833.7 245.6 833.7 245.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M827.6 244.5C827.7 244.7 827.9 244.9 827.9 244.7C827.9 244.5 827.7 244.6 827.6 244.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M774 231.9C774 231.9 774.1 231.9 774.1 232C774.167 232 774.2 232.033 774.2 232.1C774.2 232.1 774.1 232.2 774 232.2C774 232.133 773.967 232.067 773.9 232L774 231.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.6 250C815.5 249.9 815.5 249.9 815.5 249.9C815.567 249.833 815.633 249.8 815.7 249.8V249.9C815.7 249.967 815.667 250 815.6 250Z"
          fill="#F7F5E8"
        />
        <path
          d="M818.8 249.2C818.733 249.267 818.633 249.3 818.5 249.3C818.5 249.3 818.5 249.3 818.4 249.2C818.533 249.2 818.633 249.2 818.7 249.2C818.7 249.2 818.733 249.2 818.8 249.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.9 272C809.9 271.933 809.867 271.9 809.8 271.9C809.867 271.833 809.9 271.8 809.9 271.8C809.9 271.7 810 271.8 810 271.8C810 271.867 809.967 271.933 809.9 272V272Z"
          fill="#F7F5E8"
        />
        <path
          d="M766 265.7C766.067 265.767 766.133 265.833 766.2 265.9C766.1 265.9 766.1 266 766.1 265.9C766.033 265.9 765.967 265.9 765.9 265.9C765.9 265.8 766 265.8 766 265.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M785.9 269.6C785.833 269.6 785.767 269.6 785.7 269.6L785.6 269.5C785.667 269.5 785.7 269.467 785.7 269.4C785.767 269.467 785.833 269.533 785.9 269.6V269.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M787.3 271C787.233 271 787.2 270.967 787.2 270.9C787.267 270.9 787.333 270.867 787.4 270.8V270.9C787.333 270.967 787.3 271 787.3 271Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.5 269.9C803.5 269.9 803.467 269.9 803.4 269.9C803.467 269.833 803.533 269.767 803.6 269.7C803.6 269.7 803.6 269.8 803.7 269.8C803.633 269.867 803.567 269.9 803.5 269.9V269.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M765.9 240.8C765.833 240.867 765.767 240.9 765.7 240.9C765.633 240.833 765.567 240.8 765.5 240.8C765.5 240.733 765.533 240.7 765.6 240.7C765.667 240.7 765.767 240.733 765.9 240.8V240.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M812.9 270.3C812.967 270.367 813.033 270.433 813.1 270.5C813 270.5 813 270.5 812.9 270.5C812.833 270.5 812.767 270.5 812.7 270.5C812.767 270.433 812.833 270.367 812.9 270.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M823.1 240C823.1 240.067 823.133 240.1 823.2 240.1C823.1 240.2 823 240.2 823 240.2C823 240.133 822.967 240.067 822.9 240C822.967 240 823.033 240 823.1 240Z"
          fill="#F7F5E8"
        />
        <path
          d="M781.3 271C781.3 271 781.333 271.033 781.4 271.1L781.3 271.2C781.233 271.2 781.2 271.167 781.2 271.1C781.2 271.1 781.2 271 781.3 271Z"
          fill="#F7F5E8"
        />
        <path
          d="M840.5 246.4C840.367 246.4 840.267 246.4 840.2 246.4V246.3C840.267 246.233 840.3 246.2 840.3 246.2C840.367 246.267 840.433 246.333 840.5 246.4V246.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M827.1 244.3C827.033 244.367 827 244.433 827 244.5C826.933 244.433 826.9 244.367 826.9 244.3C826.9 244.3 826.9 244.2 827 244.2C827 244.267 827.033 244.3 827.1 244.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M787.7 273.7C787.767 273.7 787.833 273.7 787.9 273.7C787.9 273.7 787.9 273.7 787.9 273.8C787.9 273.8 787.867 273.8 787.8 273.8C787.8 273.8 787.767 273.767 787.7 273.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M790.1 275.5C790.1 275.567 790.133 275.633 790.2 275.7C790.1 275.7 790.1 275.8 790.1 275.8C790.033 275.733 790 275.667 790 275.6C790 275.6 790 275.5 790.1 275.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.2 259.8C756.267 259.867 756.333 259.9 756.4 259.9C756.333 259.9 756.267 259.9 756.2 259.9C756.133 259.9 756.067 259.9 756 259.9C756 259.9 756 259.867 756 259.8C756 259.8 756.033 259.8 756.1 259.8C756.1 259.8 756.133 259.8 756.2 259.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.4 267.4C810.333 267.4 810.267 267.4 810.2 267.4C810.2 267.4 810.1 267.3 810.2 267.3C810.2 267.3 810.233 267.3 810.3 267.3C810.3 267.3 810.333 267.333 810.4 267.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M778.4 276.4C778.333 276.333 778.3 276.3 778.3 276.3C778.367 276.3 778.433 276.267 778.5 276.2V276.3C778.433 276.367 778.4 276.4 778.4 276.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M797.6 279.3C797.667 279.3 797.733 279.267 797.8 279.2C797.8 279.2 797.833 279.233 797.9 279.3C797.833 279.3 797.767 279.333 797.7 279.4C797.7 279.4 797.7 279.3 797.6 279.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M792 279.5C792.067 279.567 792.133 279.6 792.2 279.6C792.2 279.667 792.2 279.7 792.2 279.7H792.1C792.033 279.7 791.967 279.667 791.9 279.6V279.5C791.967 279.5 792 279.5 792 279.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M761.6 239C761.667 239.133 761.733 239.233 761.8 239.3C761.8 239.367 761.8 239.433 761.8 239.5C761.8 239.4 761.6 239.4 761.6 239.4C761.6 239.267 761.6 239.133 761.6 239Z"
          fill="#F7F5E8"
        />
        <path
          d="M830.6 249.6C830.6 249.6 830.567 249.6 830.5 249.6C830.567 249.533 830.633 249.5 830.7 249.5C830.767 249.5 830.8 249.533 830.8 249.6C830.867 249.6 830.933 249.6 831 249.6C830.933 249.6 830.867 249.633 830.8 249.7C830.733 249.633 830.667 249.6 830.6 249.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M799.3 281.8C799.233 281.867 799.167 281.9 799.1 281.9C799.033 281.9 799 281.867 799 281.8C799 281.8 799 281.7 799.1 281.7C799.167 281.7 799.233 281.733 799.3 281.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.1 282.2C801.167 282.133 801.2 282.1 801.2 282.1C801.267 282.1 801.3 282.133 801.3 282.2V282.3C801.233 282.3 801.167 282.267 801.1 282.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M760.7 230.9C760.633 230.9 760.6 230.9 760.6 230.9C760.533 230.9 760.5 230.867 760.5 230.8C760.5 230.8 760.533 230.8 760.6 230.8C760.667 230.8 760.7 230.8 760.7 230.8C760.767 230.867 760.833 230.9 760.9 230.9C760.833 230.9 760.767 230.9 760.7 230.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M784.1 260.8C784.033 260.8 783.967 260.8 783.9 260.8C783.9 260.7 783.9 260.7 783.9 260.6C783.967 260.6 784.033 260.6 784.1 260.6C784.1 260.6 784.1 260.7 784.1 260.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.4 285.3C802.333 285.3 802.267 285.3 802.2 285.3C802.1 285.2 802 285.2 802.1 285.1C802.2 285.1 802.2 285.1 802.3 285.1C802.3 285.167 802.333 285.233 802.4 285.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M811.7 287.1C811.633 287.167 811.6 287.2 811.6 287.2C811.533 287.2 811.467 287.167 811.4 287.1C811.4 287.1 811.4 287 811.5 287C811.567 287 811.633 287.033 811.7 287.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M769.4 232.7C769.333 232.633 769.267 232.567 769.2 232.5C769.267 232.5 769.333 232.467 769.4 232.4C769.5 232.4 769.5 232.5 769.5 232.5C769.5 232.567 769.467 232.633 769.4 232.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M780.4 284.7C780.4 284.7 780.367 284.733 780.3 284.8C780.3 284.8 780.267 284.8 780.2 284.8C780.133 284.8 780.1 284.767 780.1 284.7C780.167 284.7 780.267 284.7 780.4 284.7V284.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.8 288.6C801.667 288.533 801.6 288.5 801.6 288.5C801.5 288.5 801.5 288.4 801.5 288.4C801.567 288.4 801.633 288.4 801.7 288.4C801.7 288.4 801.7 288.5 801.8 288.6V288.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.8 284.3C773.8 284.233 773.767 284.2 773.7 284.2C773.767 284.2 773.8 284.2 773.8 284.2C773.867 284.2 773.933 284.2 774 284.2C774 284.2 774.033 284.233 774.1 284.3C774.033 284.3 774 284.3 774 284.3C773.933 284.3 773.867 284.3 773.8 284.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.6 286.5C788.6 286.5 788.567 286.5 788.5 286.5C788.567 286.5 788.6 286.5 788.6 286.5C788.667 286.5 788.733 286.5 788.8 286.5C788.867 286.5 788.9 286.533 788.9 286.6C788.833 286.6 788.8 286.6 788.8 286.6C788.733 286.6 788.667 286.567 788.6 286.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M834.4 268.6C834.4 268.667 834.367 268.7 834.3 268.7V268.6C834.3 268.6 834.333 268.6 834.4 268.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.6 257.4C810.467 257.467 810.367 257.533 810.3 257.6C810.233 257.6 810.2 257.567 810.2 257.5C810.333 257.433 810.467 257.4 810.6 257.4V257.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M768.6 239.5C768.533 239.567 768.5 239.6 768.5 239.6C768.5 239.533 768.467 239.5 768.4 239.5C768.4 239.433 768.433 239.4 768.5 239.4C768.5 239.4 768.533 239.433 768.6 239.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.4 250.7C809.333 250.633 809.3 250.567 809.3 250.5H809.4C809.4 250.567 809.4 250.6 809.4 250.6C809.4 250.6 809.4 250.633 809.4 250.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M835.9 247.4C835.833 247.4 835.767 247.433 835.7 247.5L835.6 247.4C835.667 247.4 835.733 247.367 835.8 247.3C835.867 247.3 835.9 247.333 835.9 247.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M834.1 266.6C834.167 266.6 834.233 266.6 834.3 266.6C834.367 266.6 834.4 266.633 834.4 266.7H834.3C834.3 266.7 834.233 266.667 834.1 266.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M812 246.9C811.933 246.9 811.9 246.933 811.9 247C811.833 247 811.8 246.967 811.8 246.9C811.867 246.9 811.933 246.867 812 246.8C812 246.8 812 246.833 812 246.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M775 245.2C775 245.3 775 245.3 775 245.3C775 245.367 774.967 245.4 774.9 245.4C774.9 245.4 774.9 245.367 774.9 245.3C774.9 245.3 774.933 245.267 775 245.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M768.5 244.8C768.433 244.8 768.367 244.8 768.3 244.8C768.367 244.8 768.433 244.767 768.5 244.7C768.5 244.767 768.5 244.8 768.5 244.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.5 257.8C771.5 257.867 771.5 257.9 771.5 257.9C771.433 257.9 771.367 257.9 771.3 257.9C771.3 257.833 771.3 257.8 771.3 257.8C771.367 257.8 771.433 257.8 771.5 257.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.2 256C758.2 256 758.2 256.033 758.2 256.1C758.2 256.1 758.167 256.1 758.1 256.1C758.1 256.033 758.133 256 758.2 256Z"
          fill="#F7F5E8"
        />
        <path
          d="M783.9 246.1C783.9 246.1 783.933 246.133 784 246.2C783.933 246.2 783.867 246.2 783.8 246.2C783.867 246.133 783.9 246.1 783.9 246.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M787.2 234.9C787.133 234.9 787.1 234.9 787.1 234.9C787.1 234.9 787.067 234.867 787 234.8H787.1C787.1 234.8 787.133 234.833 787.2 234.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M774.9 232.9C774.967 232.9 775.033 232.9 775.1 232.9C775.1 232.9 775.1 232.933 775.1 233C775.033 233 774.967 233 774.9 233C774.9 233 774.9 232.967 774.9 232.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.4 251.9C801.533 251.9 801.633 251.9 801.7 251.9C801.7 251.967 801.733 252 801.8 252C801.7 252 801.7 252.1 801.7 252.1C801.567 252.033 801.467 251.967 801.4 251.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.5 238.7C802.367 238.7 802.233 238.7 802.1 238.7V238.6C802.1 238.6 802.133 238.6 802.2 238.6C802.267 238.6 802.367 238.633 802.5 238.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M755.1 259C755.1 259.067 755.1 259.1 755.1 259.1C754.967 259.1 754.867 259.067 754.8 259C754.8 259 754.833 259 754.9 259C754.967 259 755.033 259 755.1 259V259Z"
          fill="#F7F5E8"
        />
        <path
          d="M760.1 257.2C760.1 257.133 760.133 257.067 760.2 257H760.3V257.1C760.233 257.1 760.167 257.133 760.1 257.2V257.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M782.5 263.9C782.433 263.9 782.4 263.9 782.4 263.9C782.4 263.8 782.4 263.8 782.4 263.8C782.467 263.8 782.5 263.8 782.5 263.8C782.5 263.867 782.5 263.9 782.5 263.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M761.5 229.5C761.5 229.5 761.467 229.467 761.4 229.4C761.467 229.4 761.533 229.4 761.6 229.4C761.6 229.4 761.6 229.4 761.6 229.5C761.6 229.5 761.567 229.5 761.5 229.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M821.5 243.4C821.5 243.4 821.467 243.433 821.4 243.5C821.4 243.433 821.4 243.4 821.4 243.4V243.3C821.467 243.367 821.5 243.4 821.5 243.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M784 264.7C784 264.7 784.033 264.733 784.1 264.8C784 264.8 784 264.8 784 264.8C783.933 264.8 783.9 264.8 783.9 264.8C783.9 264.733 783.933 264.7 784 264.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M762.1 240C762.167 240.067 762.2 240.1 762.2 240.1C762.133 240.167 762.067 240.2 762 240.2C762 240.133 762.033 240.067 762.1 240Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.9 269.7C810.967 269.767 811 269.8 811 269.8C811 269.8 810.967 269.8 810.9 269.8C810.833 269.8 810.8 269.8 810.8 269.8C810.867 269.733 810.9 269.7 810.9 269.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M783.7 245.1C783.767 245.1 783.8 245.133 783.8 245.2C783.733 245.2 783.7 245.2 783.7 245.2H783.6C783.667 245.133 783.7 245.1 783.7 245.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M786.4 245.1C786.267 245.1 786.2 245.1 786.2 245.1V245C786.267 244.933 786.3 244.933 786.3 245C786.3 245 786.333 245.033 786.4 245.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M811.6 247.8C811.6 247.8 811.6 247.833 811.6 247.9C811.6 247.9 811.567 247.9 811.5 247.9C811.5 247.833 811.533 247.8 811.6 247.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M811.3 248.6C811.367 248.667 811.4 248.7 811.4 248.7C811.4 248.767 811.367 248.8 811.3 248.8C811.3 248.8 811.267 248.767 811.2 248.7C811.2 248.7 811.3 248.7 811.3 248.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M808.2 269.8C808.2 269.867 808.2 269.9 808.2 269.9C808.2 269.967 808.167 270 808.1 270V269.9C808.1 269.9 808.133 269.867 808.2 269.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M817.7 249.6C817.633 249.6 817.6 249.633 817.6 249.7C817.533 249.633 817.5 249.567 817.5 249.5H817.6C817.6 249.5 817.633 249.533 817.7 249.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M749.5 261.2C749.567 261.133 749.633 261.1 749.7 261.1C749.767 261.1 749.833 261.133 749.9 261.2C749.833 261.2 749.8 261.2 749.8 261.2C749.667 261.2 749.567 261.2 749.5 261.2V261.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M749.5 261.2C749.4 261.2 749.4 261.3 749.4 261.3C749.333 261.3 749.267 261.3 749.2 261.3C749.2 261.3 749.167 261.267 749.1 261.2C749.167 261.2 749.233 261.2 749.3 261.2C749.367 261.2 749.433 261.2 749.5 261.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M824.9 240.2C824.9 240.2 824.867 240.233 824.8 240.3V240.2C824.8 240.2 824.833 240.2 824.9 240.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M796.1 268.7C796.033 268.767 796 268.8 796 268.8C795.9 268.8 795.9 268.7 795.9 268.7L796 268.6L796.1 268.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.4 263.5C756.333 263.5 756.267 263.467 756.2 263.4C756.267 263.4 756.333 263.4 756.4 263.4C756.467 263.4 756.5 263.433 756.5 263.5C756.433 263.5 756.4 263.5 756.4 263.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M782 266.8C782 266.733 781.967 266.7 781.9 266.7C781.967 266.7 782 266.667 782 266.6C782.1 266.6 782.1 266.7 782.1 266.7C782.1 266.7 782.067 266.733 782 266.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M809.4 272.6C809.4 272.667 809.4 272.7 809.4 272.7C809.333 272.7 809.267 272.667 809.2 272.6C809.267 272.6 809.333 272.6 809.4 272.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M774.5 267.7C774.567 267.7 774.633 267.733 774.7 267.8C774.6 267.8 774.6 267.8 774.6 267.8C774.533 267.8 774.467 267.767 774.4 267.7C774.467 267.7 774.5 267.7 774.5 267.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M815.6 274.5C815.533 274.5 815.5 274.467 815.5 274.4C815.567 274.4 815.6 274.4 815.6 274.4C815.7 274.4 815.7 274.4 815.7 274.5C815.633 274.5 815.6 274.5 815.6 274.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M763.2 266.6C763.2 266.667 763.2 266.7 763.2 266.7H763.1C763.1 266.7 763.1 266.667 763.1 266.6C763.1 266.6 763.1 266.6 763.2 266.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M786.5 270.3C786.5 270.367 786.467 270.4 786.4 270.4C786.4 270.333 786.367 270.267 786.3 270.2C786.367 270.2 786.433 270.233 786.5 270.3V270.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.8 268.8C771.733 268.8 771.7 268.8 771.7 268.8C771.767 268.733 771.8 268.667 771.8 268.6H771.9C771.833 268.667 771.8 268.733 771.8 268.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M774.5 269.3C774.5 269.3 774.533 269.267 774.6 269.2C774.6 269.267 774.6 269.333 774.6 269.4H774.5C774.5 269.4 774.5 269.367 774.5 269.3V269.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M776.7 269.5C776.633 269.567 776.567 269.6 776.5 269.6C776.5 269.6 776.5 269.567 776.5 269.5C776.567 269.5 776.633 269.5 776.7 269.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M771 270C771.133 269.933 771.233 269.9 771.3 269.9L771.4 270L771.3 270.1C771.233 270.033 771.133 270 771 270Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.5 274.8C801.5 274.867 801.467 274.9 801.4 274.9C801.4 274.9 801.4 274.867 801.4 274.8C801.467 274.8 801.5 274.8 801.5 274.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M769 270C768.933 270 768.867 269.967 768.8 269.9C768.867 269.9 768.933 269.933 769 270Z"
          fill="#F7F5E8"
        />
        <path
          d="M777.3 239C777.3 238.933 777.333 238.867 777.4 238.8C777.4 238.8 777.5 238.8 777.5 238.9C777.433 238.967 777.333 239 777.2 239H777.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M769.4 271.2C769.333 271.133 769.3 271.033 769.3 270.9L769.4 270.8C769.4 270.8 769.5 270.9 769.4 270.9C769.4 271.033 769.4 271.133 769.4 271.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M794.1 275.2C794.1 275.133 794.1 275.1 794.1 275.1C794.167 274.967 794.2 274.833 794.2 274.7C794.267 274.767 794.3 274.8 794.3 274.8C794.3 274.933 794.233 275.067 794.1 275.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.7 277.2C810.767 277.2 810.8 277.233 810.8 277.3C810.733 277.3 810.7 277.3 810.7 277.3C810.7 277.3 810.6 277.3 810.7 277.3C810.7 277.233 810.7 277.2 810.7 277.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M798.3 276.1C798.367 276.1 798.4 276.133 798.4 276.2C798.333 276.2 798.3 276.2 798.3 276.2H798.2C798.267 276.133 798.3 276.1 798.3 276.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.8 273.2C772.867 273.133 772.933 273.067 773 273C773 272.9 773.1 273 773.1 273C772.967 273.067 772.867 273.133 772.8 273.2V273.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.4 247C752.467 247.067 752.5 247.1 752.5 247.1C752.433 247.167 752.4 247.2 752.4 247.2V247.1C752.4 247.1 752.4 247.067 752.4 247Z"
          fill="#F7F5E8"
        />
        <path
          d="M786.4 275.7C786.4 275.7 786.367 275.7 786.3 275.7C786.367 275.633 786.4 275.6 786.4 275.6C786.467 275.667 786.533 275.7 786.6 275.7C786.533 275.7 786.467 275.7 786.4 275.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M791.2 276.7C791.133 276.7 791.1 276.7 791.1 276.7C791.167 276.633 791.2 276.567 791.2 276.5C791.2 276.5 791.233 276.5 791.3 276.5C791.233 276.567 791.2 276.633 791.2 276.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M823.5 257.7C823.567 257.7 823.6 257.733 823.6 257.8C823.6 257.8 823.567 257.8 823.5 257.8H823.4C823.467 257.733 823.5 257.7 823.5 257.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M759.5 253C759.433 253 759.4 253.033 759.4 253.1C759.4 253.033 759.367 252.967 759.3 252.9C759.3 252.9 759.4 252.8 759.5 252.9C759.5 252.9 759.5 252.9 759.5 253Z"
          fill="#F7F5E8"
        />
        <path
          d="M787.7 277.2C787.767 277.267 787.8 277.3 787.8 277.3C787.8 277.3 787.767 277.333 787.7 277.4C787.7 277.333 787.667 277.3 787.6 277.3C787.667 277.233 787.7 277.2 787.7 277.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.7 277.9C789.633 277.9 789.567 277.9 789.5 277.9C789.5 277.9 789.5 277.867 789.5 277.8C789.567 277.8 789.633 277.8 789.7 277.8C789.7 277.8 789.7 277.833 789.7 277.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M834 264.5C834 264.5 834.033 264.5 834.1 264.5C834.033 264.567 834 264.6 834 264.6C834 264.6 833.967 264.6 833.9 264.6C833.967 264.533 834 264.5 834 264.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M783.3 277.2C783.4 277.2 783.4 277.3 783.4 277.3C783.4 277.367 783.367 277.4 783.3 277.4C783.3 277.333 783.267 277.3 783.2 277.3C783.267 277.233 783.3 277.2 783.3 277.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M757.7 273.9C757.633 273.9 757.567 273.9 757.5 273.9H757.4C757.467 273.833 757.533 273.8 757.6 273.8C757.6 273.8 757.633 273.833 757.7 273.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M775.2 276.6C775.133 276.6 775.067 276.6 775 276.6C775 276.6 775 276.6 774.9 276.5C774.967 276.5 775 276.5 775 276.5C775.067 276.5 775.1 276.5 775.1 276.5C775.167 276.5 775.2 276.533 775.2 276.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M760.2 253.7C760.133 253.7 760.1 253.7 760.1 253.7C760.1 253.633 760.1 253.567 760.1 253.5C760.167 253.567 760.2 253.633 760.2 253.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.5 282.5C803.5 282.433 803.5 282.4 803.5 282.4C803.5 282.333 803.533 282.3 803.6 282.3C803.6 282.3 803.6 282.4 803.7 282.4C803.633 282.467 803.567 282.5 803.5 282.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.5 281.1C789.5 281.1 789.467 281.1 789.4 281.1L789.5 281C789.567 281 789.6 281 789.6 281V281.1C789.6 281.1 789.567 281.1 789.5 281.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M778.1 279.8C778.1 279.8 778.067 279.833 778 279.9C778 279.833 778 279.8 778 279.8V279.7C778.067 279.767 778.1 279.8 778.1 279.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M751.6 277.8H751.5C751.4 277.8 751.4 277.8 751.4 277.7C751.467 277.7 751.5 277.7 751.5 277.7C751.6 277.7 751.6 277.8 751.6 277.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M755.9 235.4C755.833 235.467 755.8 235.5 755.8 235.5C755.733 235.433 755.7 235.4 755.7 235.4C755.7 235.4 755.7 235.3 755.8 235.3L755.9 235.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.3 281C771.3 281 771.267 281.033 771.2 281.1C771.2 281.033 771.2 281 771.2 281V280.9C771.267 280.967 771.3 281 771.3 281Z"
          fill="#F7F5E8"
        />
        <path
          d="M770.5 281.9C770.5 281.9 770.533 281.9 770.6 281.9C770.6 281.967 770.633 282 770.7 282C770.6 282 770.6 282.1 770.6 282C770.533 282 770.5 281.967 770.5 281.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M799.6 286.4C799.533 286.467 799.467 286.5 799.4 286.5C799.4 286.433 799.367 286.4 799.3 286.4C799.367 286.4 799.433 286.4 799.5 286.4C799.5 286.4 799.533 286.4 799.6 286.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.2 287C802.133 287 802.1 287 802.1 287C802.1 286.933 802.1 286.867 802.1 286.8H802.2C802.2 286.867 802.2 286.933 802.2 287Z"
          fill="#F7F5E8"
        />
        <path
          d="M750.9 279.8C750.833 279.8 750.767 279.8 750.7 279.8C750.7 279.733 750.7 279.7 750.7 279.7C750.767 279.7 750.833 279.7 750.9 279.7C750.9 279.7 750.9 279.733 750.9 279.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M776.1 283.8C776.033 283.867 776 283.9 776 283.9C775.933 283.9 775.9 283.867 775.9 283.8H776C776 283.8 776.033 283.8 776.1 283.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M758.9 281.8C758.9 281.733 758.867 281.7 758.8 281.7C758.867 281.633 758.9 281.6 758.9 281.6C758.9 281.6 759 281.6 759 281.7C758.933 281.7 758.9 281.733 758.9 281.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.4 250.2C803.4 250.267 803.4 250.3 803.4 250.3C803.333 250.233 803.3 250.2 803.3 250.2C803.3 250.2 803.333 250.2 803.4 250.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M823 248.7C823 248.7 823.033 248.733 823.1 248.8C823.033 248.8 823 248.8 823 248.8C823 248.733 823 248.7 823 248.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M776 237.3C776 237.3 775.967 237.3 775.9 237.3C775.9 237.233 775.933 237.2 776 237.2C776 237.267 776.033 237.3 776.1 237.3C776.033 237.3 776 237.3 776 237.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M766.8 252.6C766.733 252.6 766.667 252.6 766.6 252.6C766.533 252.6 766.5 252.6 766.5 252.6C766.5 252.6 766.5 252.567 766.5 252.5C766.633 252.5 766.733 252.533 766.8 252.6V252.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M821 269.2C821 269.267 821 269.3 821 269.3C821 269.3 820.967 269.333 820.9 269.4C820.9 269.333 820.9 269.3 820.9 269.3C820.967 269.3 821 269.267 821 269.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M829.4 253.3C829.4 253.3 829.367 253.3 829.3 253.3C829.3 253.233 829.3 253.2 829.3 253.2C829.367 253.2 829.4 253.233 829.4 253.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M750.3 258.8C750.3 258.8 750.267 258.767 750.2 258.7C750.267 258.7 750.3 258.7 750.3 258.7C750.3 258.7 750.3 258.733 750.3 258.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M753.6 236C753.6 236.067 753.633 236.1 753.7 236.1C753.633 236.1 753.6 236.1 753.6 236.1C753.6 236.1 753.567 236.067 753.5 236C753.567 236 753.6 236 753.6 236Z"
          fill="#F7F5E8"
        />
        <path
          d="M825.5 270.3C825.5 270.3 825.533 270.267 825.6 270.2C825.6 270.267 825.633 270.3 825.7 270.3C825.633 270.3 825.567 270.3 825.5 270.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M812 268.6C811.933 268.6 811.9 268.567 811.9 268.5C811.967 268.5 812 268.533 812 268.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M822 247.5C821.933 247.5 821.9 247.5 821.9 247.5C821.9 247.5 821.933 247.467 822 247.4C822 247.467 822 247.5 822 247.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M765.6 242.7C765.6 242.7 765.567 242.7 765.5 242.7C765.5 242.633 765.5 242.6 765.5 242.6C765.567 242.6 765.6 242.633 765.6 242.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M821.6 270.8C821.6 270.8 821.567 270.8 821.5 270.8C821.433 270.8 821.4 270.767 821.4 270.7C821.467 270.767 821.533 270.8 821.6 270.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M810 249.2C810 249.267 810 249.3 810 249.3C809.933 249.3 809.9 249.3 809.9 249.3C809.9 249.3 809.933 249.267 810 249.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M831.1 250.7C831.1 250.7 831.1 250.667 831.1 250.6C831.167 250.6 831.2 250.633 831.2 250.7C831.2 250.7 831.167 250.7 831.1 250.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M807.1 259C807.033 259.067 807 259.1 807 259.1C806.933 259.033 806.9 259 806.9 259C806.967 259 807.033 259 807.1 259Z"
          fill="#F7F5E8"
        />
        <path
          d="M828.9 245.1C828.967 245.033 829.033 244.967 829.1 244.9C829.1 244.9 829.133 244.9 829.2 244.9V245C829.067 245 828.967 245 828.9 245V245.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M823.9 251.3C823.833 251.367 823.8 251.4 823.8 251.4C823.8 251.333 823.8 251.3 823.8 251.3C823.8 251.3 823.833 251.3 823.9 251.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.8 261.6C756.733 261.6 756.7 261.6 756.7 261.6C756.7 261.533 756.7 261.5 756.7 261.5C756.767 261.567 756.8 261.6 756.8 261.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M822.7 247.6C822.7 247.6 822.667 247.6 822.6 247.6C822.6 247.533 822.6 247.5 822.6 247.5C822.667 247.5 822.7 247.5 822.7 247.5C822.7 247.5 822.7 247.533 822.7 247.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M814.4 257.3C814.333 257.3 814.3 257.267 814.3 257.2C814.3 257.2 814.333 257.2 814.4 257.2C814.4 257.2 814.433 257.233 814.5 257.3C814.433 257.3 814.4 257.3 814.4 257.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.1 242.8C773.1 242.8 773.133 242.833 773.2 242.9C773.133 242.9 773.067 242.9 773 242.9C773.067 242.833 773.1 242.8 773.1 242.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M820.4 243.5C820.4 243.5 820.4 243.533 820.4 243.6C820.4 243.533 820.367 243.5 820.3 243.5C820.367 243.433 820.4 243.4 820.4 243.4C820.4 243.467 820.4 243.5 820.4 243.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M824.9 249.9C824.833 249.9 824.8 249.933 824.8 250C824.8 249.933 824.8 249.9 824.8 249.9C824.8 249.9 824.833 249.9 824.9 249.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M766.2 235.1C766.133 235.1 766.1 235.1 766.1 235.1C766.1 235.1 766.1 235.067 766.1 235C766.1 235 766.133 235 766.2 235C766.2 235 766.2 235.033 766.2 235.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M834.5 249.5C834.5 249.567 834.5 249.6 834.5 249.6C834.433 249.533 834.4 249.5 834.4 249.5C834.4 249.5 834.433 249.5 834.5 249.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M804.5 269.8C804.5 269.867 804.5 269.9 804.5 269.9C804.433 269.9 804.4 269.9 804.4 269.9C804.467 269.833 804.5 269.8 804.5 269.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M831.2 274.2C831.2 274.2 831.167 274.167 831.1 274.1C831.167 274.1 831.2 274.1 831.2 274.1C831.2 274.1 831.233 274.133 831.3 274.2C831.233 274.2 831.2 274.2 831.2 274.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M791.6 268.5C791.6 268.567 791.567 268.6 791.5 268.6C791.5 268.533 791.5 268.5 791.5 268.5C791.5 268.5 791.533 268.5 791.6 268.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M811 272.1C811.067 272.1 811.1 272.1 811.1 272.1C811.1 272.167 811.1 272.2 811.1 272.2C811.1 272.2 811.067 272.2 811 272.2C811 272.2 811 272.167 811 272.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M832.3 275.3C832.3 275.367 832.333 275.4 832.4 275.4C832.333 275.4 832.3 275.4 832.3 275.4C832.3 275.4 832.267 275.4 832.2 275.4C832.267 275.4 832.3 275.367 832.3 275.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M766.9 265.5C766.833 265.5 766.8 265.5 766.8 265.5C766.8 265.433 766.8 265.4 766.8 265.4C766.867 265.4 766.9 265.4 766.9 265.4C766.9 265.467 766.9 265.5 766.9 265.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M790.9 269.3C790.833 269.3 790.8 269.267 790.8 269.2C790.8 269.2 790.833 269.2 790.9 269.2C790.9 269.2 790.9 269.233 790.9 269.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M831.1 266.7C831.1 266.7 831.067 266.7 831 266.7C831.067 266.633 831.1 266.6 831.1 266.6C831.1 266.6 831.1 266.633 831.1 266.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M827.4 273.8C827.333 273.8 827.3 273.8 827.3 273.8C827.3 273.733 827.3 273.7 827.3 273.7C827.3 273.7 827.333 273.733 827.4 273.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M771.1 234.6C771.1 234.533 771.1 234.5 771.1 234.5C771.167 234.5 771.2 234.533 771.2 234.6C771.2 234.6 771.167 234.6 771.1 234.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M796.3 269.1C796.367 269.167 796.4 269.2 796.4 269.2C796.4 269.2 796.367 269.2 796.3 269.2C796.3 269.2 796.3 269.167 796.3 269.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M778.6 268.7C778.6 268.7 778.633 268.7 778.7 268.7C778.633 268.767 778.6 268.8 778.6 268.8C778.6 268.733 778.6 268.7 778.6 268.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M826.3 245.4C826.233 245.467 826.167 245.533 826.1 245.6V245.5C826.167 245.5 826.233 245.5 826.3 245.5V245.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M748.3 264.5C748.3 264.433 748.3 264.4 748.3 264.4C748.367 264.4 748.4 264.4 748.4 264.4C748.4 264.467 748.4 264.5 748.4 264.5C748.333 264.5 748.3 264.5 748.3 264.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M763.9 252.6C763.967 252.667 764 252.7 764 252.7C763.933 252.7 763.9 252.667 763.9 252.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M821.3 266.1C821.3 266.1 821.267 266.1 821.2 266.1C821.2 266.1 821.2 266.067 821.2 266C821.2 266 821.233 266 821.3 266C821.3 266 821.3 266.033 821.3 266.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M794.7 272.5C794.767 272.5 794.8 272.5 794.8 272.5C794.733 272.567 794.7 272.6 794.7 272.6C794.633 272.6 794.6 272.6 794.6 272.6C794.667 272.533 794.7 272.5 794.7 272.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M801.9 273.7C801.9 273.633 801.9 273.6 801.9 273.6C801.967 273.6 802 273.6 802 273.6C802 273.6 802 273.633 802 273.7C802 273.7 801.967 273.7 801.9 273.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M780.2 270.7C780.2 270.7 780.2 270.667 780.2 270.6C780.2 270.6 780.233 270.6 780.3 270.6C780.3 270.6 780.3 270.633 780.3 270.7C780.3 270.7 780.267 270.7 780.2 270.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M781.7 252C781.7 252 781.667 251.967 781.6 251.9C781.667 251.9 781.7 251.9 781.7 251.9C781.7 251.967 781.7 252 781.7 252Z"
          fill="#F7F5E8"
        />
        <path
          d="M769.8 250C769.8 250.067 769.8 250.1 769.8 250.1C769.8 250.1 769.767 250.1 769.7 250.1C769.7 250.1 769.7 250.067 769.7 250C769.767 250 769.8 250 769.8 250Z"
          fill="#F7F5E8"
        />
        <path
          d="M754.3 247.7C754.233 247.7 754.2 247.667 754.2 247.6C754.2 247.6 754.233 247.6 754.3 247.6C754.3 247.6 754.3 247.633 754.3 247.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M774.7 270.6C774.7 270.6 774.667 270.6 774.6 270.6C774.667 270.6 774.7 270.567 774.7 270.5C774.7 270.5 774.7 270.533 774.7 270.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M783.8 272C783.867 271.933 783.933 271.9 784 271.9C784 271.9 784.033 271.9 784.1 271.9C784.033 271.9 784 271.933 784 272C783.933 272 783.867 272 783.8 272Z"
          fill="#F7F5E8"
        />
        <path
          d="M824.2 248.5C824.2 248.5 824.167 248.5 824.1 248.5C824.167 248.433 824.233 248.433 824.3 248.5C824.3 248.5 824.267 248.5 824.2 248.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M788.9 272.8C788.9 272.8 788.933 272.833 789 272.9C788.933 272.9 788.9 272.9 788.9 272.9C788.9 272.9 788.867 272.867 788.8 272.8C788.8 272.8 788.833 272.8 788.9 272.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M767.8 270.4C767.8 270.4 767.767 270.367 767.7 270.3C767.767 270.3 767.8 270.3 767.8 270.3C767.8 270.3 767.8 270.333 767.8 270.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M789.6 274.2C789.6 274.267 789.6 274.3 789.6 274.3C789.6 274.3 789.567 274.267 789.5 274.2C789.567 274.2 789.6 274.2 789.6 274.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M768.4 246.4C768.333 246.4 768.3 246.4 768.3 246.4C768.3 246.467 768.3 246.467 768.3 246.4C768.233 246.4 768.2 246.4 768.2 246.4C768.267 246.4 768.333 246.4 768.4 246.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M776.6 272.5C776.6 272.5 776.6 272.467 776.6 272.4C776.667 272.4 776.7 272.433 776.7 272.5C776.7 272.5 776.667 272.5 776.6 272.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M758 257C757.933 257 757.9 257 757.9 257C757.9 256.933 757.9 256.9 757.9 256.9C757.967 256.9 758 256.9 758 256.9C758 256.9 758 256.933 758 257Z"
          fill="#F7F5E8"
        />
        <path
          d="M770.7 271.7C770.7 271.767 770.667 271.8 770.6 271.8C770.6 271.733 770.6 271.7 770.6 271.7C770.667 271.7 770.7 271.7 770.7 271.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M777.7 237.9C777.767 237.9 777.8 237.9 777.8 237.9C777.733 237.9 777.7 237.933 777.7 238C777.7 238 777.7 237.967 777.7 237.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M792.9 275.1C792.833 275.1 792.8 275.133 792.8 275.2C792.733 275.133 792.7 275.1 792.7 275.1C792.767 275.1 792.8 275.1 792.8 275.1C792.867 275.1 792.9 275.1 792.9 275.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M806.9 277.6C806.833 277.6 806.8 277.567 806.8 277.5C806.867 277.5 806.9 277.5 806.9 277.5C806.9 277.5 806.933 277.533 807 277.6C806.933 277.6 806.9 277.6 806.9 277.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M782.5 274.2C782.567 274.2 782.6 274.2 782.6 274.2C782.6 274.2 782.633 274.233 782.7 274.3C782.633 274.3 782.6 274.3 782.6 274.3C782.6 274.3 782.567 274.267 782.5 274.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M776.2 273.5C776.2 273.567 776.167 273.6 776.1 273.6C776.1 273.533 776.133 273.5 776.2 273.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M753.5 256.3C753.5 256.367 753.467 256.4 753.4 256.4C753.4 256.4 753.4 256.367 753.4 256.3C753.4 256.3 753.433 256.3 753.5 256.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M811.2 279C811.2 279 811.233 279.033 811.3 279.1C811.233 279.1 811.2 279.1 811.2 279.1C811.2 279.033 811.167 279 811.1 279C811.1 279 811.133 279 811.2 279Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.1 277.9C802.1 277.9 802.1 277.867 802.1 277.8C802.167 277.867 802.2 277.9 802.2 277.9C802.2 277.9 802.167 277.9 802.1 277.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.5 278C803.433 278 803.4 278 803.4 278C803.467 277.933 803.5 277.933 803.5 278Z"
          fill="#F7F5E8"
        />
        <path
          d="M807.8 260.1C807.8 260.167 807.8 260.2 807.8 260.2C807.8 260.2 807.767 260.2 807.7 260.2C807.767 260.133 807.8 260.1 807.8 260.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M805 257C804.933 257.067 804.9 257.133 804.9 257.2H804.8C804.8 257.133 804.8 257.1 804.8 257.1C804.867 257.1 804.933 257.067 805 257V257Z"
          fill="#F7F5E8"
        />
        <path
          d="M761.1 231.7C761.167 231.767 761.2 231.833 761.2 231.9C761.133 231.9 761.1 231.9 761.1 231.9C761.1 231.833 761.1 231.8 761.1 231.8C761.1 231.8 761.1 231.767 761.1 231.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M831.5 268.5C831.5 268.5 831.5 268.467 831.5 268.4C831.5 268.4 831.533 268.4 831.6 268.4C831.6 268.4 831.6 268.433 831.6 268.5C831.6 268.5 831.567 268.5 831.5 268.5Z"
          fill="#F7F5E8"
        />
        <path
          d="M804.9 279.4C804.833 279.4 804.8 279.367 804.8 279.3C804.8 279.3 804.833 279.3 804.9 279.3C804.9 279.3 804.9 279.333 804.9 279.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M757.1 272.1C757.1 272.1 757.1 272.133 757.1 272.2C757.1 272.2 757.067 272.167 757 272.1C757 272.1 757.033 272.1 757.1 272.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.1 274.7C773.1 274.7 773.1 274.733 773.1 274.8C773.033 274.733 773 274.7 773 274.7C773.067 274.633 773.1 274.6 773.1 274.6C773.1 274.667 773.1 274.7 773.1 274.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M806.3 256.4C806.3 256.467 806.333 256.5 806.4 256.5C806.333 256.5 806.3 256.5 806.3 256.5C806.3 256.5 806.267 256.467 806.2 256.4C806.267 256.4 806.3 256.4 806.3 256.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M752.5 246.8C752.5 246.733 752.5 246.7 752.5 246.7C752.5 246.7 752.533 246.7 752.6 246.7C752.6 246.7 752.6 246.733 752.6 246.8C752.6 246.8 752.567 246.8 752.5 246.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M756.7 231.9C756.633 231.9 756.6 231.9 756.6 231.9C756.6 231.833 756.6 231.8 756.6 231.8C756.667 231.8 756.7 231.8 756.7 231.8C756.7 231.867 756.7 231.9 756.7 231.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M837.3 243.3C837.233 243.3 837.2 243.267 837.2 243.2C837.2 243.2 837.233 243.2 837.3 243.2C837.3 243.267 837.3 243.3 837.3 243.3Z"
          fill="#F7F5E8"
        />
        <path
          d="M760.8 274.1C760.8 274.167 760.8 274.2 760.8 274.2C760.8 274.2 760.767 274.2 760.7 274.2C760.767 274.133 760.8 274.1 760.8 274.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.9 282C810.9 282.067 810.9 282.1 810.9 282.1C810.833 282.1 810.8 282.1 810.8 282.1C810.8 282.1 810.8 282.067 810.8 282C810.8 282 810.833 282 810.9 282Z"
          fill="#F7F5E8"
        />
        <path
          d="M796.5 250C796.5 249.933 796.5 249.9 796.5 249.9C796.567 249.9 796.6 249.933 796.6 250C796.6 250 796.567 250 796.5 250Z"
          fill="#F7F5E8"
        />
        <path
          d="M767.6 250.7C767.6 250.633 767.567 250.6 767.5 250.6C767.567 250.6 767.633 250.6 767.7 250.6C767.633 250.6 767.6 250.633 767.6 250.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M773.1 277.9C773.167 277.9 773.233 277.9 773.3 277.9C773.3 277.9 773.3 277.933 773.3 278C773.233 278 773.2 278 773.2 278C773.2 278 773.167 277.967 773.1 277.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M803.2 283.1C803.267 283.1 803.3 283.133 803.3 283.2C803.233 283.2 803.2 283.2 803.2 283.2C803.2 283.2 803.2 283.167 803.2 283.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M813.7 285C813.7 285.067 813.667 285.1 813.6 285.1C813.6 285.033 813.633 285 813.7 285Z"
          fill="#F7F5E8"
        />
        <path
          d="M755 246.7C755.067 246.633 755.1 246.6 755.1 246.6C755.1 246.667 755.1 246.7 755.1 246.7C755.033 246.7 755 246.7 755 246.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M746.8 275.7C746.867 275.7 746.9 275.7 746.9 275.7C746.9 275.7 746.933 275.733 747 275.8C747 275.8 746.967 275.8 746.9 275.8C746.9 275.8 746.867 275.767 746.8 275.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M780.8 261.6C780.8 261.667 780.8 261.7 780.8 261.7C780.8 261.7 780.767 261.7 780.7 261.7C780.7 261.7 780.7 261.667 780.7 261.6C780.7 261.6 780.733 261.6 780.8 261.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M779.1 281.9C779.033 281.9 779 281.9 779 281.9C779 281.9 779 281.867 779 281.8C779.067 281.8 779.1 281.833 779.1 281.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M817.7 287.9C817.7 287.9 817.667 287.9 817.6 287.9C817.667 287.9 817.7 287.867 817.7 287.8C817.7 287.867 817.7 287.9 817.7 287.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M817 256.2C817 256.2 817 256.167 817 256.1C817.067 256.1 817.1 256.133 817.1 256.2C817.1 256.2 817.067 256.2 817 256.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M818.5 288.2C818.433 288.2 818.4 288.2 818.4 288.2C818.4 288.2 818.4 288.167 818.4 288.1C818.467 288.1 818.5 288.1 818.5 288.1C818.5 288.167 818.5 288.2 818.5 288.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M810.6 257.4C810.6 257.333 810.6 257.267 810.6 257.2C810.6 257.1 810.7 257.1 810.7 257.1C810.7 257.167 810.7 257.2 810.7 257.2C810.633 257.267 810.6 257.333 810.6 257.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M772.2 281.2C772.133 281.267 772.1 281.3 772.1 281.3C772.1 281.3 772.1 281.267 772.1 281.2C772.1 281.2 772.133 281.2 772.2 281.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M747.1 277.9C747.1 277.9 747.1 277.933 747.1 278C747.1 277.933 747.067 277.9 747 277.9C747 277.9 747.033 277.867 747.1 277.8C747.1 277.867 747.1 277.9 747.1 277.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M766.5 280.9C766.5 280.9 766.5 280.933 766.5 281C766.433 281 766.4 280.967 766.4 280.9C766.4 280.9 766.433 280.9 766.5 280.9Z"
          fill="#F7F5E8"
        />
        <path
          d="M795.5 285.2C795.367 285.267 795.267 285.3 795.2 285.3C795.2 285.233 795.2 285.2 795.2 285.2C795.267 285.2 795.367 285.2 795.5 285.2Z"
          fill="#F7F5E8"
        />
        <path
          d="M792.3 285.1C792.233 285.1 792.2 285.1 792.2 285.1C792.2 285.1 792.2 285.067 792.2 285C792.267 285.067 792.3 285.1 792.3 285.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M816.2 289C816.133 289 816.1 289 816.1 289C816.1 289 816.1 288.967 816.1 288.9C816.1 288.9 816.1 288.933 816.1 289C816.167 289 816.2 289 816.2 289Z"
          fill="#F7F5E8"
        />
        <path
          d="M820.3 289.7C820.367 289.7 820.367 289.733 820.3 289.8C820.3 289.733 820.3 289.7 820.3 289.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M831.8 258.1C831.867 258.167 831.9 258.2 831.9 258.2C831.9 258.2 831.867 258.2 831.8 258.2C831.8 258.133 831.8 258.1 831.8 258.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M747.3 279.1C747.3 279.167 747.267 279.2 747.2 279.2C747.2 279.2 747.2 279.167 747.2 279.1C747.2 279.1 747.233 279.1 747.3 279.1Z"
          fill="#F7F5E8"
        />
        <path
          d="M802.6 287.8C802.533 287.8 802.467 287.833 802.4 287.9C802.4 287.833 802.4 287.8 802.4 287.8C802.467 287.8 802.533 287.8 802.6 287.8Z"
          fill="#F7F5E8"
        />
        <path d="M820.1 238.3V238.4H820L820.1 238.3Z" fill="#F7F5E8" />
        <path d="M768.8 230.8L768.7 230.7H768.8V230.8Z" fill="#F7F5E8" />
        <path
          d="M763.8 231.9C763.867 231.967 763.933 232 764 232C763.933 232 763.867 231.967 763.8 231.9Z"
          fill="#F7F5E8"
        />
        <path d="M832.5 243.7L832.6 243.8H832.5V243.7Z" fill="#F7F5E8" />
        <path d="M761.2 233H761.3L761.2 233.1V233Z" fill="#F7F5E8" />
        <path d="M835.6 244.6V244.5L835.7 244.6H835.6Z" fill="#F7F5E8" />
        <path
          d="M827.6 244.5C827.533 244.5 827.5 244.467 827.5 244.4C827.5 244.4 827.5 244.367 827.5 244.3C827.5 244.367 827.533 244.433 827.6 244.5Z"
          fill="#F7F5E8"
        />
        <path d="M819.2 243.1H819.3L819.2 243.2V243.1Z" fill="#F7F5E8" />
        <path
          d="M763.7 234.7C763.767 234.7 763.833 234.7 763.9 234.7C763.833 234.767 763.8 234.767 763.8 234.7C763.8 234.7 763.767 234.667 763.7 234.6V234.7Z"
          fill="#F7F5E8"
        />
        <path d="M767.7 235.8H767.8L767.7 235.9V235.8Z" fill="#F7F5E8" />
        <path d="M813.6 243V242.9H813.7L813.6 243Z" fill="#F7F5E8" />
        <path d="M818.3 243.6H818.4V243.7L818.3 243.6Z" fill="#F7F5E8" />
        <path d="M802.9 242.3H803V242.4L802.9 242.3Z" fill="#F7F5E8" />
        <path d="M824.2 245.7L824.3 245.8H824.2V245.7Z" fill="#F7F5E8" />
        <path d="M834.3 247.7H834.4L834.3 247.8V247.7Z" fill="#F7F5E8" />
        <path d="M833.7 248H833.8L833.7 248.1V248Z" fill="#F7F5E8" />
        <path d="M819.6 246.8L819.5 246.9V246.8H819.6Z" fill="#F7F5E8" />
        <path
          d="M763.5 240.1C763.567 240.167 763.6 240.2 763.6 240.2C763.6 240.2 763.6 240.233 763.6 240.3C763.6 240.233 763.567 240.167 763.5 240.1Z"
          fill="#F7F5E8"
        />
        <path d="M821 249.5L821.1 249.4V249.5H821Z" fill="#F7F5E8" />
        <path
          d="M782.5 244.7C782.567 244.633 782.6 244.6 782.6 244.6C782.667 244.6 782.7 244.6 782.7 244.6C782.633 244.6 782.567 244.6 782.5 244.6V244.7Z"
          fill="#F7F5E8"
        />
        <path
          d="M838.7 253.8C838.767 253.8 838.8 253.767 838.8 253.7C838.8 253.767 838.767 253.8 838.7 253.8Z"
          fill="#F7F5E8"
        />
        <path
          d="M782.5 245C782.6 245.1 782.6 245.2 782.8 245C782.667 245 782.567 245 782.5 245Z"
          fill="#F7F5E8"
        />
        <path
          d="M838.4 253.8C838.333 253.733 838.3 253.7 838.3 253.7C838.3 253.7 838.333 253.733 838.4 253.8Z"
          fill="#F7F5E8"
        />
        <path d="M810.5 249.5V249.6L810.4 249.5H810.5Z" fill="#F7F5E8" />
        <path
          d="M838.7 253.8C838.633 253.8 838.533 253.8 838.4 253.8C838.467 253.933 838.567 253.933 838.7 253.8Z"
          fill="#F7F5E8"
        />
        <path d="M828.5 252.9L828.6 253H828.5V252.9Z" fill="#F7F5E8" />
        <path d="M820.9 252.9H821V253L820.9 252.9Z" fill="#F7F5E8" />
        <path d="M816.3 252.9L816.2 252.8H816.3V252.9Z" fill="#F7F5E8" />
        <path
          d="M836.6 258.2C836.667 258.133 836.7 258.067 836.7 258C836.7 258.067 836.7 258.1 836.7 258.1C836.7 258.1 836.667 258.133 836.6 258.2V258.2Z"
          fill="#F7F5E8"
        />
        <path d="M823 256.1L823.1 256.2H823V256.1Z" fill="#F7F5E8" />
        <path d="M812.1 254.9V255L812 254.9H812.1Z" fill="#F7F5E8" />
        <path d="M774.2 251.1V251.2L774.1 251.1H774.2Z" fill="#F7F5E8" />
        <path
          d="M768.9 251.4C768.833 251.467 768.8 251.5 768.8 251.5C768.733 251.5 768.7 251.5 768.7 251.5C768.767 251.5 768.833 251.467 768.9 251.4Z"
          fill="#F7F5E8"
        />
        <path
          d="M773 253C773.067 253.067 773.1 253.1 773.1 253.1C773.033 253.1 773 253.067 773 253Z"
          fill="#F7F5E8"
        />
        <path
          d="M760.1 257.2C760.033 257.2 760 257.233 760 257.3C760 257.233 760.033 257.2 760.1 257.2Z"
          fill="#F7F5E8"
        />
        <path d="M803.3 264.2H803.4V264.3L803.3 264.2Z" fill="#F7F5E8" />
        <path
          d="M751 260.6C751.067 260.667 751.133 260.7 751.2 260.7C751.133 260.7 751.1 260.7 751.1 260.7C751.033 260.7 751 260.667 751 260.6Z"
          fill="#F7F5E8"
        />
        <path
          d="M808.4 271.7C808.4 271.7 808.433 271.667 808.5 271.6C808.433 271.667 808.4 271.7 808.4 271.7Z"
          fill="#F7F5E8"
        />
        <path d="M814.6 273.3L814.5 273.2H814.6V273.3Z" fill="#F7F5E8" />
        <path d="M759.1 264.8V264.9L759 264.8H759.1Z" fill="#F7F5E8" />
        <path d="M756.7 264.8V264.7H756.8L756.7 264.8Z" fill="#F7F5E8" />
        <path
          d="M802.6 272.3C802.667 272.367 802.7 272.4 802.7 272.4C802.7 272.4 802.7 272.433 802.7 272.5C802.7 272.433 802.667 272.367 802.6 272.3V272.3Z"
          fill="#F7F5E8"
        />
        <path d="M800.2 272.2V272.1L800.3 272.2H800.2Z" fill="#F7F5E8" />
        <path d="M796.2 271.7V271.8H796.1L796.2 271.7Z" fill="#F7F5E8" />
        <path
          d="M792.5 271.2C792.433 271.267 792.4 271.333 792.4 271.4C792.333 271.333 792.333 271.3 792.4 271.3C792.4 271.3 792.433 271.267 792.5 271.2V271.2Z"
          fill="#F7F5E8"
        />
        <path d="M817.8 275.7V275.6H817.9L817.8 275.7Z" fill="#F7F5E8" />
        <path
          d="M781.5 270.2C781.567 270.2 781.6 270.233 781.6 270.3C781.533 270.233 781.5 270.2 781.5 270.2Z"
          fill="#F7F5E8"
        />
        <path d="M772.8 269.2L772.9 269.1V269.2H772.8Z" fill="#F7F5E8" />
        <path d="M807.9 274.7H808V274.8L807.9 274.7Z" fill="#F7F5E8" />
        <path d="M776.2 270.6L776.3 270.5V270.6H776.2Z" fill="#F7F5E8" />
        <path d="M813.4 277.4H813.5V277.5L813.4 277.4Z" fill="#F7F5E8" />
        <path
          d="M772.6 271.2C772.6 271.267 772.633 271.3 772.7 271.3C772.7 271.367 772.7 271.4 772.7 271.4C772.633 271.333 772.6 271.267 772.6 271.2V271.2Z"
          fill="#F7F5E8"
        />
        <path d="M829.6 280.3L829.5 280.4V280.3H829.6Z" fill="#F7F5E8" />
        <path
          d="M769.4 271.2C769.4 271.2 769.433 271.233 769.5 271.3C769.433 271.233 769.4 271.2 769.4 271.2Z"
          fill="#F7F5E8"
        />
        <path d="M778.1 272.9H778.2V273L778.1 272.9Z" fill="#F7F5E8" />
        <path d="M758 270.8L758.1 270.7V270.8H758Z" fill="#F7F5E8" />
        <path d="M793.1 278.6V278.7L793 278.6H793.1Z" fill="#F7F5E8" />
        <path
          d="M802.5 281.8C802.5 281.733 802.5 281.667 802.5 281.6C802.567 281.667 802.567 281.7 802.5 281.7C802.5 281.7 802.467 281.733 802.4 281.8H802.5Z"
          fill="#F7F5E8"
        />
        <path d="M754.7 276.8L754.6 276.7H754.7V276.8Z" fill="#F7F5E8" />
        <path d="M792.1 283.3L792 283.4V283.3H792.1Z" fill="#F7F5E8" />
        <path
          d="M802.4 285.3C802.4 285.367 802.433 285.4 802.5 285.4C802.5 285.467 802.467 285.5 802.4 285.5C802.4 285.433 802.4 285.367 802.4 285.3V285.3Z"
          fill="#F7F5E8"
        />
        <path d="M748.3 278.3V278.4L748.2 278.3H748.3Z" fill="#F7F5E8" />
        <path d="M803.7 287.5V287.6L803.6 287.5H803.7Z" fill="#F7F5E8" />
        <path
          d="M802.6 287.8C802.667 287.8 802.733 287.767 802.8 287.7C802.8 287.7 802.8 287.733 802.8 287.8C802.733 287.8 802.667 287.8 802.6 287.8Z"
          fill="#F7F5E8"
        />
        <path d="M809.4 288.8V288.9L809.3 288.8H809.4Z" fill="#F7F5E8" />
        <path d="M767.1 250.3H767.2L767.1 250.4V250.3Z" fill="#F7F5E8" />
        <path d="M835.7 262.6V262.5L835.8 262.6H835.7Z" fill="#F7F5E8" />
        <path d="M763.7 236.7L763.8 236.8H763.7V236.7Z" fill="#F7F5E8" />
        <path d="M756 251.5V251.6L755.9 251.5H756Z" fill="#F7F5E8" />
        <path
          d="M802.5 238.7C802.567 238.767 802.6 238.833 802.6 238.9C802.533 238.833 802.5 238.767 802.5 238.7Z"
          fill="#F7F5E8"
        />
        <path d="M757.9 263.1L757.8 263.2L757.9 263.1Z" fill="#F7F5E8" />
        <path d="M808.4 271.7L808.3 271.8L808.4 271.7Z" fill="#F7F5E8" />
        <path d="M783.9 268.4L783.8 268.5V268.4H783.9Z" fill="#F7F5E8" />
        <path d="M821.6 252L821.5 251.9L821.6 252Z" fill="#F7F5E8" />
        <path d="M803 276.4L802.9 276.3L803 276.4Z" fill="#F7F5E8" />
        <path
          d="M772.6 273.3C772.667 273.233 772.733 273.2 772.8 273.2C772.733 273.2 772.667 273.233 772.6 273.3Z"
          fill="#F7F5E8"
        />
        <path d="M790.6 285L790.7 284.9V285H790.6Z" fill="#F7F5E8" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M767.9 242.8C768.367 247.733 768.633 250.533 768.7 251.2C769.367 251.333 772.1 251.933 776.9 253C772.367 255 769.8 256.133 769.2 256.4C769.267 257.067 769.5 259.833 769.9 264.7C766.7 261.033 764.867 258.933 764.4 258.4C763.8 258.667 761.233 259.767 756.7 261.7C759.167 257.5 760.6 255.1 761 254.5C760.533 253.967 758.667 251.867 755.4 248.2C760.2 249.267 762.933 249.867 763.6 250C763.933 249.467 764.933 247.833 766.6 245.1L767.9 242.8ZM764.4 251.9C762.733 251.567 761.3 251.267 760.1 251C760.9 251.867 761.867 252.967 763 254.3C762.133 255.767 761.4 257.033 760.8 258.1C761.933 257.567 763.267 256.967 764.8 256.3C765.933 257.567 766.9 258.667 767.7 259.6C767.567 258.4 767.433 256.933 767.3 255.2C768.9 254.533 770.233 253.967 771.3 253.5C770.167 253.233 768.767 252.9 767.1 252.5C766.9 250.833 766.767 249.4 766.7 248.2C766.033 249.2 765.367 250.267 764.7 251.4L764.4 251.9Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M768 242.5C768.533 248.1 768.8 250.967 768.8 251.1C768.867 251.1 771.7 251.733 777.3 253C772.033 255.267 769.367 256.4 769.3 256.4C769.3 256.533 769.567 259.433 770.1 265.1C766.367 260.833 764.467 258.633 764.4 258.5C764.267 258.567 761.6 259.733 756.4 262C759.267 257.067 760.733 254.567 760.8 254.5C760.733 254.433 758.833 252.267 755.1 248C760.633 249.267 763.467 249.9 763.6 249.9C763.6 249.833 765 247.433 767.8 242.7L768 242.5ZM763.7 250.2C758.767 249.133 756.1 248.533 755.7 248.4C755.967 248.733 757.767 250.8 761.1 254.6C758.567 258.933 757.167 261.267 756.9 261.6C757.3 261.467 759.833 260.4 764.5 258.4C767.767 262.2 769.533 264.233 769.8 264.5C769.8 264.1 769.567 261.4 769.1 256.4C773.7 254.4 776.2 253.333 776.6 253.2C776.2 253.067 773.533 252.467 768.6 251.4C768.133 246.333 767.9 243.6 767.9 243.2C767.7 243.533 766.3 245.867 763.7 250.2V250.2Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M766.8 247.9C767.067 250.833 767.2 252.367 767.2 252.5C767.267 252.5 768.767 252.833 771.7 253.5C768.967 254.7 767.567 255.3 767.5 255.3C767.5 255.433 767.633 257 767.9 260C765.9 257.733 764.867 256.567 764.8 256.5C764.733 256.5 763.333 257.1 760.6 258.3C762.133 255.767 762.9 254.433 762.9 254.3C762.833 254.233 761.833 253.067 759.9 250.8C762.833 251.467 764.333 251.833 764.4 251.9C764.467 251.833 765.2 250.6 766.6 248.2L766.8 247.9ZM764.5 252.1C762.233 251.567 760.9 251.267 760.5 251.2C760.767 251.467 761.667 252.5 763.2 254.3C762 256.367 761.3 257.533 761.1 257.8C761.433 257.667 762.7 257.133 764.9 256.2C766.5 258 767.4 259.033 767.6 259.3C767.6 258.967 767.5 257.6 767.3 255.2C769.5 254.267 770.767 253.733 771.1 253.6C770.7 253.467 769.333 253.133 767 252.6C766.8 250.267 766.7 248.9 766.7 248.5C766.5 248.833 765.8 250 764.6 252L764.5 252.1Z"
          fill="#231F20"
        />
        <path
          d="M763.1 254.3C762.833 254.033 762.533 253.7 762.2 253.3L761.9 253L762.7 251.6C763.367 251.733 763.967 251.867 764.5 252L763.1 254.3Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M764.6 251.9L763.1 254.5L761.7 253L762.6 251.5L764.5 251.9H764.6ZM762.7 251.7C762.6 251.8 762 252.8 762 252.9C762 253 762.9 253.9 763 254.1C763.1 253.9 764.1 252.2 764.2 252C764 252 762.8 251.7 762.7 251.7V251.7Z"
          fill="#231F20"
        />
        <path
          d="M767.1 252.6L764.5 252L764.8 251.4C764.933 251.133 765.133 250.8 765.4 250.4L766.9 250.8L767.1 252.6Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M767 250.7L767.2 252.7L764.3 252.1L765.3 250.3L767 250.7V250.7ZM765.4 250.5C765.2 250.8 764.6 251.7 764.5 251.9C764.8 251.9 766.7 252.4 766.9 252.4C766.9 252.2 766.8 251 766.8 250.9C766.6 250.8 765.5 250.6 765.4 250.5Z"
          fill="#231F20"
        />
        <path
          d="M765.4 250.4L764.5 252C763.967 251.867 763.367 251.733 762.7 251.6L763.6 250L765.4 250.4Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M765.4 250.3L765.5 250.4L764.5 252.1L762.5 251.7L763.6 249.9L765.4 250.3ZM763.7 250.2C763.6 250.3 763 251.3 762.9 251.5C763.1 251.6 764.3 251.8 764.4 251.9C764.5 251.8 765.1 250.7 765.3 250.5C765 250.5 763.8 250.2 763.7 250.2Z"
          fill="#231F20"
        />
        <path
          d="M763.2 257.1L762.1 255.9C762.7 255 763.1 254.3 763.1 254.3L764.9 256.4L763.2 257.1Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M763.1 254.1L765 256.4L763.2 257.2L762 255.9L763 254.3L763.1 254.1ZM762.3 255.8C762.4 255.9 763.2 256.8 763.3 256.9C763.4 256.8 764.5 256.3 764.7 256.2C764.5 256 763.3 254.6 763.1 254.4C763 254.6 762.4 255.7 762.3 255.8Z"
          fill="#231F20"
        />
        <path
          d="M762.1 255.9L761 254.5L761.9 253C761.967 253.067 762.067 253.167 762.2 253.3L763.1 254.3C763.1 254.3 762.7 255 762.1 255.9V255.9Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M761.9 252.8L763.2 254.3L762.2 256L760.8 254.5L761.8 252.9L761.9 252.8ZM761.1 254.5C761.2 254.6 762 255.5 762.2 255.7C762.2 255.7 762.9 254.5 763 254.3C762.9 254.2 762 253.3 761.9 253.2C761.8 253.4 761.2 254.4 761.1 254.5Z"
          fill="#231F20"
        />
        <path
          d="M767.5 257.1L766 257.7C765.6 257.167 765.233 256.733 764.9 256.4L767.4 255.3C767.4 255.4 767.4 256.1 767.5 257.1Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M767.4 255.1L767.6 257.1L766 257.8L764.7 256.3L767.3 255.2L767.4 255.1ZM765 256.3C765.2 256.5 766 257.4 766 257.5C766.2 257.5 767.2 257 767.4 257C767.4 256.8 767.2 255.6 767.2 255.4C767 255.5 765.2 256.2 765 256.3V256.3Z"
          fill="#231F20"
        />
        <path
          d="M766 257.7L764.4 258.4L763.2 257.1C763.8 256.833 764.367 256.6 764.9 256.4C765.233 256.733 765.6 257.167 766 257.7Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M764.9 256.2L766.2 257.7L764.4 258.5L763 257L764.8 256.3L764.9 256.2ZM763.4 257C763.6 257.2 764.4 258.1 764.4 258.2C764.6 258.2 765.7 257.7 765.9 257.6C765.7 257.4 764.9 256.5 764.9 256.4C764.7 256.5 763.6 256.9 763.4 257Z"
          fill="#231F20"
        />
        <path
          d="M767.1 252.6C767.633 252.733 768.233 252.867 768.9 253L769 254.6C768.4 254.867 767.867 255.1 767.4 255.3L767.1 252.6Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M769 252.9L769.1 254.6L768.8 254.8C767.4 255.4 767.4 255.4 767.3 255.4L767 253C767 252.5 767 252.5 767 252.5H767.1L768.9 252.9H769ZM767.2 252.7C767.3 252.9 767.4 254.9 767.5 255.1C767.7 255 768.8 254.5 768.9 254.5C768.9 254.4 768.8 253.2 768.8 253C768.7 253 767.5 252.8 767.2 252.7V252.7Z"
          fill="#231F20"
        />
        <path
          d="M768.9 253C768.233 252.867 767.633 252.733 767.1 252.6C767.033 252.067 766.967 251.467 766.9 250.8L768.7 251.2L768.9 253Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M768.8 251.1L769 253.1L767 252.7L766.8 250.6L768.7 251.1H768.8ZM767.1 250.9C767.1 251.1 767.2 252.3 767.2 252.5C767.4 252.5 768.5 252.8 768.8 252.8C768.7 252.6 768.6 251.4 768.6 251.3C768.5 251.2 767.3 251 767.1 250.9Z"
          fill="#231F20"
        />
        <path
          d="M769.2 256.4L767.5 257.1L767.4 255.3C767.867 255.1 768.4 254.867 769 254.6L769.2 256.4Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M769.1 254.4L769.3 256.4L767.4 257.2L767.2 255.3V255.2L769 254.5L769.1 254.4ZM767.4 255.3C767.4 255.4 767.6 256.6 767.6 256.9C767.8 256.8 768.9 256.3 769 256.3C769 256.1 768.9 254.9 768.9 254.7C768.833 254.7 768.767 254.7 768.7 254.7C767.9 255.1 767.6 255.2 767.4 255.3Z"
          fill="#231F20"
        />
        <path
          d="M765.5 250L764 252.5L762.7 251.8L763.9 249.8L765.5 250Z"
          fill="#0DB04B"
        />
        <path
          d="M766.6 250.8L769.2 251.4V252.9L766.7 252.4L766.6 250.8Z"
          fill="#0DB04B"
        />
        <path
          d="M762.8 257.3L765.4 256.2L766.4 257.4L763.8 258.6L762.8 257.3Z"
          fill="#0DB04B"
        />
        <path
          d="M768.9 254.1L769.1 257.1L767.7 257.5L767.4 254.8L768.9 254.1Z"
          fill="#0DB04B"
        />
        <path
          d="M761.5 252.7L763.5 254.9L762.6 256.2L760.4 253.7L761.5 252.7Z"
          fill="#0DB04B"
        />
        <path
          d="M762.2 252.7L763 254.1L762 252.9L762.2 252.7Z"
          fill="#00934D"
        />
        <path d="M768.6 250.9V251L767 250.7L768.6 250.9Z" fill="#00934D" />
        <path
          d="M769.3 256.2L769.1 254.6L769.4 254.5L769.3 256.2Z"
          fill="#00934D"
        />
        <path d="M766 257.8L766.2 258L764.6 258.5L766 257.8Z" fill="#00934D" />
        <path
          d="M765.4 250.6L764.9 252L764.6 251.9L765.4 250.6Z"
          fill="#00934D"
        />
        <g opacity="0.9">
          <path
            opacity="0.9"
            d="M857.6 466.6C854.2 506.8 854.2 547.3 857.6 587.5C850.4 587.5 842 587.5 834.7 587.5C834.7 547.167 834.7 506.867 834.7 466.6C842 466.6 850.4 466.6 857.6 466.6Z"
            fill="#292627"
          />
        </g>
        <path
          d="M854.8 586.4V586.6C853.6 586.9 852.6 587.8 852.5 589H852.4C852.2 587.6 850.9 586.5 849.4 586.5C847.9 586.5 846.7 587.6 846.5 589H846.4C846.2 587.6 844.9 586.5 843.4 586.5C841.9 586.5 840.7 587.6 840.5 589H840.4C840.2 587.6 838.9 586.5 837.4 586.5C835.9 586.5 834.7 587.6 834.5 589H834.4C834.2 587.6 832.9 586.5 831.4 586.5C829.9 586.5 828.7 587.6 828.5 589H828.4C828.2 587.6 826.9 586.5 825.4 586.5C823.9 586.5 822.7 587.6 822.5 589H822.4C822.2 587.6 820.9 586.5 819.5 586.5C818 586.5 816.7 587.6 816.5 589H816.4C816.2 587.6 815 586.5 813.5 586.5C812 586.5 810.7 587.6 810.5 589H810.4C810.2 587.6 809 586.5 807.5 586.5C806 586.5 804.7 587.6 804.5 589H804.4C804.2 587.6 803 586.5 801.5 586.5C800 586.5 798.7 587.6 798.5 589H798.4C798.2 587.6 797 586.5 795.5 586.5C794 586.5 792.7 587.6 792.5 589H792.4C792.2 587.6 791 586.5 789.5 586.5C788 586.5 786.7 587.6 786.5 589H786.4C786.2 587.6 785 586.5 783.5 586.5C782 586.5 780.8 587.6 780.5 589H780.4C780.2 587.6 779 586.5 777.5 586.5C776 586.5 774.8 587.6 774.5 589C774.3 587.8 773.3 586.9 772.1 586.6V586.4C773.5 586.1 774.5 584.9 774.5 583.5C774.5 582.1 773.5 580.9 772.1 580.6V580.4C773.5 580.2 774.5 579 774.5 577.5C774.5 576.1 773.5 574.9 772.1 574.6V574.5C773.5 574.2 774.5 573 774.5 571.5C774.5 570.1 773.5 568.9 772.1 568.6V568.5C773.5 568.2 774.5 567 774.5 565.5C774.5 564.1 773.5 562.9 772.1 562.6V562.5C773.5 562.2 774.5 561 774.5 559.5C774.5 558.1 773.5 556.9 772.1 556.6V556.5C773.5 556.2 774.5 555 774.5 553.5C774.5 552.1 773.5 550.9 772.1 550.6V550.5C773.5 550.2 774.5 549 774.5 547.6C774.5 546.1 773.5 544.9 772.1 544.6V544.5C773.5 544.2 774.5 543 774.5 541.6C774.5 540.1 773.5 538.9 772.1 538.6V538.5C773.5 538.2 774.5 537 774.5 535.6C774.5 534.1 773.5 532.9 772.1 532.6V532.5C773.5 532.2 774.5 531 774.5 529.6C774.5 528.1 773.5 526.9 772.1 526.6V526.5C773.5 526.2 774.5 525 774.5 523.6C774.5 522.1 773.5 521 772.1 520.7V520.5C773.5 520.2 774.5 519 774.5 517.6C774.5 516.2 773.5 515 772.1 514.7V514.5C773.5 514.2 774.5 513 774.5 511.6C774.5 510.2 773.5 509 772.1 508.7V508.5C773.5 508.2 774.5 507 774.5 505.6C774.5 504.2 773.5 503 772.1 502.7V502.5C773.5 502.2 774.5 501 774.5 499.6C774.5 498.2 773.5 497 772.1 496.7V496.5C773.5 496.2 774.5 495 774.5 493.6C774.5 492.2 773.5 491 772.1 490.7V490.5C773.5 490.2 774.5 489 774.5 487.6C774.5 486.2 773.5 485 772.1 484.7V484.5C773.5 484.2 774.5 483 774.5 481.6C774.5 480.2 773.5 479 772.1 478.7V478.5C773.5 478.3 774.5 477.1 774.5 475.6C774.5 474.2 773.5 473 772.1 472.7V472.6C773.5 472.3 774.5 471.1 774.5 469.6C774.5 468.2 773.5 467 772.1 466.7C773.1 466.5 773.9 465.8 774.2 464.9H774.7C775.2 466 776.3 466.8 777.5 466.8C778.7 466.8 779.8 466 780.2 464.9H780.7C781.2 466 782.2 466.8 783.5 466.8C784.7 466.8 785.8 466 786.2 464.9H786.7C787.2 466 788.2 466.8 789.5 466.8C790.7 466.8 791.8 466 792.2 464.9H792.7C793.2 466 794.2 466.8 795.5 466.8C796.7 466.8 797.8 466 798.2 464.9H798.7C799.2 466 800.2 466.8 801.5 466.8C802.7 466.8 803.8 466 804.2 464.9H804.7C805.2 466 806.2 466.8 807.5 466.8C808.7 466.8 809.8 466 810.2 464.9H810.7C811.2 466 812.2 466.8 813.5 466.8C814.7 466.8 815.8 466 816.2 464.9H816.7C817.1 466 818.2 466.8 819.5 466.8C820.7 466.8 821.8 466 822.2 464.9H822.7C823.1 466 824.2 466.8 825.4 466.8C826.7 466.8 827.7 466 828.2 464.9H828.7C829.1 466 830.2 466.8 831.4 466.8C832.7 466.8 833.7 466 834.2 464.9H834.7C835.1 466 836.2 466.8 837.4 466.8C838.7 466.8 839.7 466 840.2 464.9H840.7C841.1 466 842.2 466.8 843.4 466.8C844.7 466.8 845.7 466 846.2 464.9H846.7C847.1 466 848.2 466.8 849.4 466.8C850.7 466.8 851.7 466 852.2 464.9H852.7C853 465.8 853.8 466.5 854.8 466.7C853.4 467 852.4 468.2 852.4 469.6C852.4 471.1 853.4 472.3 854.8 472.6V472.7C853.4 473 852.4 474.2 852.4 475.6C852.4 477.1 853.4 478.2 854.8 478.5V478.7C853.4 479 852.4 480.2 852.4 481.6C852.4 483 853.4 484.2 854.8 484.5V484.7C853.4 485 852.4 486.2 852.4 487.6C852.4 489 853.4 490.2 854.8 490.5V490.7C853.4 491 852.4 492.2 852.4 493.6C852.4 495 853.4 496.2 854.8 496.5V496.7C853.4 497 852.4 498.2 852.4 499.6C852.4 501 853.4 502.2 854.8 502.5V502.7C853.4 503 852.4 504.2 852.4 505.6C852.4 507 853.4 508.2 854.8 508.5V508.7C853.4 509 852.4 510.2 852.4 511.6C852.4 513 853.4 514.2 854.8 514.5V514.7C853.4 515 852.4 516.2 852.4 517.6C852.4 519 853.4 520.2 854.8 520.5V520.7C853.4 521 852.4 522.1 852.4 523.6C852.4 525 853.4 526.2 854.8 526.5V526.6C853.4 526.9 852.4 528.1 852.4 529.6C852.4 531 853.4 532.2 854.8 532.5V532.6C853.4 532.9 852.4 534.1 852.4 535.6C852.4 537 853.4 538.2 854.8 538.5V538.6C853.4 538.9 852.4 540.1 852.4 541.6C852.4 543 853.4 544.2 854.8 544.5V544.6C853.4 544.9 852.4 546.1 852.4 547.6C852.4 549 853.4 550.2 854.8 550.5V550.6C853.4 550.9 852.4 552.1 852.4 553.5C852.4 555 853.4 556.2 854.8 556.5V556.6C853.4 556.9 852.4 558.1 852.4 559.5C852.4 561 853.4 562.2 854.8 562.5V562.6C853.4 562.9 852.4 564.1 852.4 565.5C852.4 567 853.4 568.2 854.8 568.5V568.6C853.4 568.9 852.4 570.1 852.4 571.5C852.4 573 853.4 574.2 854.8 574.5V574.6C853.4 574.9 852.4 576.1 852.4 577.5C852.4 579 853.4 580.2 854.8 580.4V580.6C853.4 580.9 852.4 582.1 852.4 583.5C852.4 584.9 853.4 586.1 854.8 586.4V586.4Z"
          fill="white"
        />
        <path d="M848.8 583.4H778.1V470.6H848.8V583.4Z" fill="#3F92A1" />
        <path
          d="M822.8 516.5L820.6 514.4C812.6 507.4 807.3 502.7 807.3 497C807.3 492.3 811 488.7 815.8 488.7C818.5 488.7 821.1 489.9 822.8 491.8C824.5 489.9 827.1 488.7 829.7 488.7C834.5 488.7 838.2 492.3 838.2 497C838.2 502.7 833 507.4 824.9 514.4L822.8 516.5Z"
          fill="#CC3A43"
        />
        <path
          d="M840.2 572.8C840.2 574 839.1 575 837.7 575H790.3C788.9 575 787.8 574 787.8 572.8V544.9C787.8 543.7 788.9 542.8 790.3 542.8H837.7C839.1 542.8 840.2 543.7 840.2 544.9V572.8Z"
          fill="#DA2128"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M814 547C816 552.333 817.133 555.367 817.4 556.1C818.267 556.1 821.867 556.1 828.2 556.1C823.067 559.433 820.133 561.3 819.4 561.7C819.667 562.433 820.8 565.467 822.8 570.8C817.667 567.533 814.733 565.667 814 565.2C813.267 565.667 810.333 567.533 805.2 570.8C807.2 565.467 808.333 562.433 808.6 561.7C807.867 561.3 804.933 559.433 799.8 556.1C806.133 556.1 809.767 556.1 810.7 556.1C810.967 555.367 811.733 553.3 813 549.9L814 547ZM812.2 558C810 558 808.1 558 806.5 558C807.767 558.8 809.3 559.767 811.1 560.9C810.433 562.767 809.867 564.367 809.4 565.7C810.667 564.9 812.2 563.9 814 562.7C815.733 563.9 817.233 564.9 818.5 565.7C818.033 564.367 817.467 562.767 816.8 560.9C818.6 559.767 820.133 558.8 821.4 558C819.8 558 817.9 558 815.7 558C815.033 556.133 814.467 554.567 814 553.3C813.467 554.567 812.967 555.9 812.5 557.3L812.2 558Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M814 546.6C816.267 552.733 817.433 555.867 817.5 556C817.633 556 821.333 556 828.6 556C822.733 559.8 819.733 561.733 819.6 561.8C819.667 561.867 820.833 564.967 823.1 571.1C817.167 567.367 814.133 565.467 814 565.4C813.867 565.467 810.867 567.367 805 571.1C807.267 564.967 808.4 561.867 808.4 561.8C808.333 561.733 805.333 559.8 799.4 556C806.733 556 810.433 556 810.5 556C810.567 555.867 811.7 552.867 813.9 547L814 546.6ZM810.7 556.2C804.233 556.2 800.733 556.2 800.2 556.2C800.6 556.467 803.433 558.267 808.7 561.6C806.7 567.067 805.633 570.033 805.5 570.5C805.9 570.167 808.733 568.333 814 565C819.267 568.333 822.1 570.167 822.5 570.5C822.367 570.033 821.267 567.067 819.2 561.6C824.467 558.267 827.333 556.467 827.8 556.2C827.267 556.2 823.733 556.2 817.2 556.2C815.2 550.733 814.133 547.8 814 547.4C813.867 547.733 812.8 550.633 810.8 556.1L810.7 556.2Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M814 552.9C815.2 556.167 815.833 557.833 815.9 557.9C815.967 557.9 817.933 557.9 821.8 557.9C818.733 559.9 817.133 560.933 817 561C817.067 561.133 817.667 562.8 818.8 566C815.733 564 814.133 562.967 814 562.9C813.867 562.967 812.267 564 809.2 566C810.4 562.8 811 561.133 811 561C810.933 560.933 809.333 559.9 806.2 557.9C810.067 557.9 812.067 557.9 812.2 557.9C812.2 557.833 812.767 556.3 813.9 553.3L814 552.9ZM812.3 558.1C809.233 558.1 807.467 558.1 807 558.1C807.4 558.367 808.833 559.3 811.3 560.9C810.367 563.5 809.833 565 809.7 565.4C810.033 565.133 811.467 564.2 814 562.6C816.467 564.2 817.9 565.133 818.3 565.4C818.167 565 817.6 563.5 816.6 560.9C819.133 559.3 820.6 558.367 821 558.1C820.467 558.1 818.667 558.1 815.6 558.1C814.667 555.567 814.133 554.1 814 553.7C813.867 554.1 813.333 555.533 812.4 558L812.3 558.1Z"
          fill="#231F20"
        />
        <path
          d="M811.2 561C810.8 560.733 810.333 560.433 809.8 560.1L809.3 559.8L809.9 558.1C810.767 558.1 811.567 558.1 812.3 558.1L811.2 561Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M812.4 557.9L811.2 561.2L809.1 559.8L809.8 557.9H812.4ZM810 558.2C810 558.3 809.5 559.6 809.4 559.7C809.6 559.8 810.8 560.6 811.1 560.8C811.2 560.5 812 558.4 812.1 558.2C811.7 558.2 810.2 558.2 810 558.2Z"
          fill="#231F20"
        />
        <path
          d="M815.8 558.1H812.3L812.5 557.4C812.633 557.067 812.8 556.633 813 556.1H815L815.8 558.1Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M815.1 556L815.9 558.2H812.1L812.9 556H815.1ZM813 556.2C812.9 556.5 812.5 557.7 812.4 557.9C812.7 557.9 815.2 557.9 815.5 557.9C815.4 557.7 814.9 556.4 814.9 556.2C814.7 556.2 813.2 556.2 813 556.2Z"
          fill="#231F20"
        />
        <path
          d="M813 556.1L812.3 558.1C811.567 558.1 810.767 558.1 809.9 558.1L810.7 556.1H813Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M813.2 556L812.4 558.2H809.7L810.5 556H813.2ZM810.8 556.2C810.8 556.4 810.3 557.7 810.2 557.9C810.5 557.9 812.1 557.9 812.2 557.9C812.3 557.8 812.8 556.5 812.9 556.2C812.6 556.2 811 556.2 810.8 556.2Z"
          fill="#231F20"
        />
        <path
          d="M812.1 564L810.5 562.9C810.767 562.167 811 561.533 811.2 561L814 562.8L812.1 564Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M811.1 560.8L814.2 562.8L812.1 564.1L810.3 563L811 560.9L811.1 560.8ZM810.7 562.9C810.8 563 812 563.8 812.2 563.9C812.3 563.8 813.6 563 813.8 562.9C813.6 562.7 811.5 561.4 811.3 561.2C811.2 561.5 810.7 562.8 810.7 562.9Z"
          fill="#231F20"
        />
        <path
          d="M811.2 561C811 561.533 810.767 562.167 810.5 562.9L808.6 561.7L809.3 559.8C809.433 559.867 809.6 559.967 809.8 560.1L811.2 561V561Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M809.2 559.6L811.3 560.9L810.5 563.1L808.4 561.8L809.2 559.7V559.6ZM808.7 561.7C808.8 561.8 810.1 562.6 810.3 562.8C810.3 562.8 810.9 561.2 811 561.1C810.8 561 809.5 560.1 809.3 560C809.2 560.3 808.7 561.6 808.7 561.7Z"
          fill="#231F20"
        />
        <path
          d="M817.6 562.9L815.9 564C815.167 563.533 814.533 563.133 814 562.8L816.8 561C816.9 561.1 817.2 561.9 817.6 562.9V562.9Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M816.9 560.8L817.7 563L815.9 564.1L813.8 562.8L816.8 560.9L816.9 560.8ZM814.2 562.8C814.4 562.9 815.7 563.7 815.8 563.8C816 563.7 817.2 563 817.3 562.9C817.3 562.7 816.8 561.4 816.7 561.2C816.4 561.3 814.4 562.6 814.2 562.8Z"
          fill="#231F20"
        />
        <path
          d="M815.9 564L814 565.2L812.1 564C812.833 563.533 813.467 563.133 814 562.8C814.533 563.133 815.167 563.533 815.9 564Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M814 562.6L816.1 564L814 565.4L811.9 564L813.9 562.7L814 562.6ZM812.4 563.9C812.6 564.1 813.9 564.9 814 565C814.2 564.9 815.4 564.1 815.7 563.9C815.4 563.8 814.2 563 814 562.9C813.9 563 812.6 563.8 812.4 563.9Z"
          fill="#231F20"
        />
        <path
          d="M815.8 558.1C816.467 558.1 817.233 558.1 818.1 558.1L818.7 559.8C818.033 560.267 817.4 560.667 816.8 561L815.8 558.1Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M818.2 557.9L818.9 559.8L818.5 560.1C816.9 561.1 816.9 561.1 816.8 561.1H816.7L815.8 558.6C815.6 558 815.6 558 815.6 558L815.7 557.9H818.2ZM816 558.2C816 558.4 816.8 560.5 816.9 560.8C817.2 560.6 818.5 559.8 818.6 559.7C818.5 559.6 818 558.3 818 558.2C817.8 558.2 816.3 558.2 816 558.2Z"
          fill="#231F20"
        />
        <path
          d="M818.1 558.1C817.233 558.1 816.467 558.1 815.8 558.1C815.533 557.5 815.267 556.833 815 556.1H817.4L818.1 558.1Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M817.5 556L818.3 558.2H815.7L814.8 556H817.5ZM815.3 556.2C815.4 556.5 815.9 557.8 815.9 557.9C816.1 557.9 817.7 557.9 818 557.9C817.9 557.7 817.4 556.4 817.3 556.2C817.2 556.2 815.6 556.2 815.3 556.2Z"
          fill="#231F20"
        />
        <path
          d="M819.4 561.7L817.6 562.9L816.8 561C817.4 560.667 818.033 560.267 818.7 559.8L819.4 561.7Z"
          fill="#0DB04B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M818.8 559.6L819.6 561.8L817.5 563.1L816.7 561V560.9L818.6 559.7L818.8 559.6ZM817 561C817.1 561.1 817.6 562.5 817.7 562.7C817.9 562.6 819.2 561.8 819.3 561.7C819.3 561.5 818.8 560.2 818.7 560C818.633 560 818.567 560.033 818.5 560.1C817.6 560.7 817.2 560.9 817 561Z"
          fill="#231F20"
        />
        <path
          d="M813 555.6L811.8 558.8L810 558.3L810.9 555.8L813 555.6Z"
          fill="#0DB04B"
        />
        <path
          d="M814.6 556.2H818.1L818.5 557.9H815.2L814.6 556.2Z"
          fill="#0DB04B"
        />
        <path
          d="M811.8 564.4L814.7 562.5L816.3 563.6L813.3 565.5L811.8 564.4Z"
          fill="#0DB04B"
        />
        <path
          d="M818.4 559.3L819.6 562.5L817.9 563.4L816.8 560.4L818.4 559.3Z"
          fill="#0DB04B"
        />
        <path
          d="M808.8 559.6L811.8 561.6L811.1 563.2L807.6 561L808.8 559.6Z"
          fill="#0DB04B"
        />
        <path
          d="M809.6 559.4L811.1 560.8L809.4 559.7L809.6 559.4Z"
          fill="#00934D"
        />
        <path d="M817.1 555.8L817.2 556H815.1L817.1 555.8Z" fill="#00934D" />
        <path
          d="M819.5 561.5L818.9 559.8L819.2 559.7L819.5 561.5Z"
          fill="#00934D"
        />
        <path
          d="M815.9 564.1L816.1 564.3L814.2 565.2L815.9 564.1Z"
          fill="#00934D"
        />
        <path d="M813.1 556.2L812.8 557.9H812.4L813.1 556.2Z" fill="#00934D" />
      </g>
      <defs>
        <clipPath id="clip0_2_2">
          <rect width="1690" height="1414" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const Reviews = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 46 54"}>
      <g id="Layer">
        <g id="Layer_1">
          <path
            id="Layer"
            d="m44.58 4.3l-5.14 2.88l-5.15-2.88l5.15-2.87l5.14 2.87v0z"
          />
          <path id="Layer" d="m34.29 4.3l5.14 2.88v5.93l-5.14-2.88v-5.93v0z" />
          <path id="Layer" d="m44.58 4.3v5.93l-5.15 2.88v-5.93l5.15-2.88v0z" />
          <path
            id="Layer"
            d="m20 26.53c0.05-0.15 0.19-0.3 0.62-0.52c0.86-0.43 2.11-0.64 2.25-1.12c0.14-0.48 1.1-1.43 1.27-2.17c0.17-0.74 0.47-2 0.47-2c0.59 0.11 1.19-0.48 1.54-0.2c0.35 0.28-0.07 0.7 0.53 1.15c0.6 0.45 1.21 0.54 1.56 0.24c0.35-0.3 1 0 1.3 0.17c0.3 0.17 0.39-0.82 0.71-0.65c0.32 0.17 0.11 0.54 0.48 0.68c0.37 0.14 0.44-0.4 0.74 0c0.3 0.4 1.27 0.89 1.41 1.67c0.14 0.78 0 2.9 0.48 3.28c0.48 0.38 0.91 0.54 0.88 1c-0.03 0.46-0.15 0.34-0.1 0.7c0.05 0.36 0.37 0.52-0.19 0.59c-0.56 0.07-1.43-0.46-1.65-0.12c-0.22 0.34-0.77 0.05-1 0.12c-0.23 0.07-0.57 0-0.5 0.4c0.07 0.4-1.93 1.1-1.65 1.35c0.28 0.25 0.32 0.26 0.34 0.48c-0.03 0.11-0.07 0.21-0.12 0.31c-0.05 0.1-0.1 0.2-0.15 0.29c-0.06 0.09-0.12 0.19-0.19 0.27c-0.07 0.09-0.14 0.17-0.22 0.25c-0.2 0.17-0.44-0.11-0.75 0.17c-0.31 0.28-2.45 1.51-2.61 2.47c-0.07-0.03-0.14-0.06-0.21-0.08c-0.07-0.02-0.15-0.04-0.22-0.05c-0.08-0.01-0.15-0.02-0.23-0.01c-0.08 0-0.15 0.01-0.23 0.02c-0.38 0.1-0.66-0.41-1-0.2c-0.34 0.21-1 0-1.24 0.14c-0.24 0.14-2.73 1.72-2.73 1.72l-0.25 6h-6.43v5.12c0 0-2.52 0.45-2.73 1.5c-0.03 0.27-0.05 0.54-0.07 0.8c-0.01 0.27-0.02 0.54-0.02 0.81c0 0.27 0.01 0.54 0.02 0.81c0.01 0.27 0.04 0.54 0.07 0.8l-8.1-0.56v1c0 0-0.75 0.65-1 0c-0.25-0.65 0.53-3.24 1.55-3.48c1.02-0.24 1-2.63 1.47-3.13c0.47-0.5 2.36-1.48 2.36-2c0-0.52-0.13-1.1 0.14-1.34c0.11-0.12 0.21-0.25 0.31-0.39c0.1-0.13 0.19-0.27 0.27-0.41c0.08-0.14 0.16-0.29 0.23-0.44c0.07-0.15 0.13-0.3 0.19-0.45c0-0.38 0.24-0.27 0.91-0.62c0.21-0.19 0.42-0.4 0.61-0.61c0.19-0.21 0.38-0.43 0.55-0.66c0.17-0.23 0.34-0.47 0.49-0.71c0.15-0.24 0.29-0.49 0.42-0.75c0.32-0.59 0.07-0.59 0.83-0.54c0.29-0.02 0.57-0.06 0.85-0.11c0.28-0.05 0.56-0.12 0.83-0.21c0.27-0.08 0.54-0.18 0.81-0.3c0.26-0.11 0.52-0.24 0.77-0.38"
          />
          <path
            fill="#20AAE2"
            id="Layer"
            d="m20.65 31.23h1.7l-5.82 8l-5.82-8h1.9c-0.53-21.39 19.09-20.52 19.09-20.52c-15.76 9.11-11.05 20.52-11.05 20.52z"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export const ToursIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 120 55"}>
      <g id="Layer">
        <g id="Background">
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m86.94 8.88c1.47 0.43 2.48 1.37 2.48 2.46c0 1.49-1.9 2.7-4.25 2.7c-2.35 0-4.25-1.21-4.25-2.7c0-1.09 1-2 2.49-2.46"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m88.34 4.39c0 3.53-3.17 7-3.17 7c0 0-3.17-3.42-3.17-7c0-0.84 0.33-1.65 0.93-2.24c0.59-0.59 1.4-0.93 2.24-0.93c0.84 0 1.65 0.33 2.24 0.93c0.59 0.59 0.93 1.4 0.93 2.24v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m85.17 5.78c-0.77 0-1.39-0.62-1.39-1.39c0-0.77 0.62-1.39 1.39-1.39c0.77 0 1.39 0.62 1.39 1.39c0 0.77-0.62 1.39-1.39 1.39z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m113.91 8.53c1.38 0.4 2.33 1.28 2.33 2.3c0 1.39-1.78 2.52-4 2.52c-2.22 0-4-1.13-4-2.52c0-1 1-1.9 2.33-2.3"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m115.23 4.33c0 3.3-3 6.5-3 6.5c0 0-3-3.2-3-6.5c0.11-0.71 0.47-1.35 1.01-1.82c0.54-0.47 1.24-0.72 1.95-0.72c0.72 0 1.41 0.26 1.95 0.72c0.54 0.47 0.9 1.11 1.01 1.82h0.07z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m112.26 5.63c-0.72 0-1.3-0.58-1.3-1.3c0-0.72 0.58-1.3 1.3-1.3c0.72 0 1.3 0.58 1.3 1.3c0 0.72-0.58 1.3-1.3 1.3z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m116.22 29.21c1.42 0.41 2.41 1.32 2.41 2.38c0 1.45-1.85 2.62-4.13 2.62c-2.28 0-4.12-1.17-4.12-2.62c0-1.06 1-2 2.41-2.38"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m117.58 24.85c0 3.42-3.08 6.74-3.08 6.74c0 0-3.07-3.32-3.07-6.74c-0.05-0.85 0.25-1.67 0.84-2.29c0.58-0.62 1.39-0.97 2.24-0.97c0.85 0 1.66 0.35 2.24 0.97c0.58 0.62 0.88 1.44 0.84 2.29z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m114.5 26.2c-0.75 0-1.35-0.6-1.35-1.35c0-0.75 0.6-1.35 1.35-1.35c0.75 0 1.35 0.6 1.35 1.35c0 0.75-0.6 1.35-1.35 1.35z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m107.39 32.76h-22.52c-0.64 0-1.27-0.13-1.86-0.37c-0.59-0.24-1.13-0.6-1.58-1.06c-0.45-0.45-0.81-0.99-1.06-1.58c-0.24-0.59-0.37-1.22-0.37-1.86v0c0-0.64 0.12-1.27 0.37-1.87c0.24-0.59 0.6-1.13 1.05-1.58c0.45-0.45 0.99-0.81 1.58-1.06c0.59-0.25 1.22-0.38 1.86-0.38h16.41c0.8 0 1.6-0.16 2.34-0.46c0.74-0.31 1.41-0.76 1.98-1.32c0.57-0.57 1.02-1.24 1.32-1.98c0.31-0.74 0.47-1.53 0.47-2.34v0c0-0.8-0.16-1.6-0.46-2.34c-0.31-0.74-0.76-1.42-1.32-1.99c-0.57-0.57-1.24-1.02-1.98-1.33c-0.74-0.31-1.54-0.47-2.34-0.47h-9.91"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m27.28 34.32c-1.71 0-3.09-1.38-3.09-3.09c0-1.71 1.38-3.09 3.09-3.09c1.71 0 3.09 1.38 3.09 3.09c0 1.71-1.38 3.09-3.09 3.09z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m27.28 32.69c-0.59 0-1.12-0.36-1.35-0.9c-0.23-0.55-0.1-1.17 0.32-1.59c0.42-0.42 1.05-0.54 1.59-0.32c0.55 0.23 0.9 0.76 0.9 1.35c0 0.19-0.04 0.38-0.11 0.56c-0.07 0.18-0.18 0.34-0.32 0.47c-0.14 0.14-0.3 0.24-0.47 0.32c-0.18 0.07-0.37 0.11-0.56 0.11z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m74.42 21.82c0.29 0.15 0.56 0.34 0.79 0.56c0.24 0.22 0.44 0.48 0.61 0.76c0.17 0.28 0.3 0.58 0.38 0.89c0.09 0.31 0.13 0.64 0.13 0.97v6h-4c-0.05-1.13-0.54-2.2-1.36-2.99c-0.82-0.78-1.91-1.22-3.05-1.22c-1.14 0-2.23 0.44-3.05 1.22c-0.82 0.78-1.31 1.85-1.36 2.99h-31.82c-0.05-1.13-0.54-2.2-1.36-2.99c-0.82-0.78-1.91-1.22-3.05-1.22c-1.14 0-2.23 0.44-3.05 1.22c-0.82 0.78-1.31 1.85-1.36 2.99h-19.63v-23.81h53.48l11.34 11.37c0.25 0.25 0.53 0.49 0.81 0.71c0.28 0.22 0.58 0.42 0.89 0.61c0.31 0.18 0.63 0.35 0.96 0.49c0.33 0.14 0.67 0.26 1.02 0.36c0.23 0.07 0.46 0.14 0.69 0.22c0.23 0.08 0.46 0.16 0.68 0.26c0.22 0.09 0.45 0.19 0.67 0.29c0.22 0.1 0.44 0.21 0.65 0.33v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m67.93 34.32c-1.71 0-3.09-1.38-3.09-3.09c0-1.71 1.38-3.09 3.09-3.09c1.71 0 3.09 1.38 3.09 3.09c0 1.71-1.38 3.09-3.09 3.09z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m67.93 32.69c-0.59 0-1.12-0.36-1.35-0.9c-0.23-0.55-0.1-1.17 0.32-1.59c0.42-0.42 1.05-0.54 1.59-0.32c0.55 0.23 0.9 0.76 0.9 1.35c0 0.19-0.04 0.38-0.11 0.56c-0.07 0.18-0.18 0.34-0.32 0.47c-0.14 0.14-0.3 0.24-0.47 0.32c-0.18 0.07-0.37 0.11-0.56 0.11z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m76.3 25.28h-71.23v-14.53h55.19"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m5.07 7.19v18.09l-1.84 2.08"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m5.07 21.29l-1.84-1.43"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m28.41 20.92h13.54v1.44h-13.54v-1.44z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m69.94 19.98h-9.82c-0.37 0-0.73-0.07-1.07-0.21c-0.34-0.14-0.65-0.34-0.91-0.6c-0.26-0.26-0.47-0.57-0.61-0.91c-0.14-0.34-0.21-0.7-0.21-1.07v-3.76h5.61"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m1.75 8.24v-1.05h1.48v1.86l-1.48-0.81v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m1.75 30.97v-1.05l1.48-0.81v1.86h-1.48v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m54.11 21.48h0.92v2.07h-0.92v-2.07z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m56.86 21.48h0.92v2.07h-0.92v-2.07z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m24.98 54.31c-2.64 0-4.78-2.14-4.78-4.78c0-2.64 2.14-4.78 4.78-4.78c2.64 0 4.78 2.14 4.78 4.78c0 2.64-2.14 4.78-4.78 4.78z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m30.19 45.75l-5.49 5.49l-1.71-1.71"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m60.38 54.31c-2.64 0-4.78-2.14-4.78-4.78c0-2.64 2.14-4.78 4.78-4.78c2.64 0 4.78 2.14 4.78 4.78c0 2.64-2.14 4.78-4.78 4.78z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m65.59 45.75l-5.49 5.49l-1.71-1.71"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m95.78 54.31c-2.64 0-4.78-2.14-4.78-4.78c0-2.64 2.14-4.78 4.78-4.78c2.64 0 4.78 2.14 4.78 4.78c0 2.64-2.14 4.78-4.78 4.78z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m100.99 45.75l-5.49 5.49l-1.71-1.71"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m32.58 49.53h20.63"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m88.17 49.53h-20.63"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export const Groups = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 51 69"}>
      <g id="Layer">
        <g id="Layer_1">
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m14.8 56.96c-4.24 0-7.66-3.42-7.66-7.66c0-4.24 3.42-7.66 7.66-7.66c4.24 0 7.66 3.42 7.66 7.66c0 4.24-3.42 7.66-7.66 7.66z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m19.42 46.64l-4.62 2.58l-4.61-2.58l4.61-2.58l4.62 2.58v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m10.19 46.64l4.61 2.58v5.31l-4.61-2.58v-5.31v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m19.42 46.64v5.31l-4.62 2.58v-5.31l4.62-2.58v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m10.34 55.53l-6.34 6.78c-0.29 0.33-0.7 0.52-1.14 0.53c-0.44 0.01-0.86-0.15-1.17-0.46c-0.31-0.31-0.48-0.73-0.46-1.17c0.01-0.44 0.21-0.85 0.53-1.14l6.78-6.32"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m32 6.67c1.06 0.31 1.79 1 1.79 1.77c0 1.07-1.37 2-3.07 2c-1.7 0-3.06-0.88-3.06-2c0-0.79 0.73-1.46 1.79-1.77"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m33 3.43c0 2.54-2.29 5-2.29 5c0 0-2.28-2.47-2.28-5c-0.04-0.63 0.18-1.25 0.61-1.72c0.43-0.46 1.04-0.73 1.67-0.73c0.63 0 1.24 0.26 1.67 0.73c0.43 0.46 0.65 1.08 0.61 1.72v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m30.67 4.43c-0.55 0-1-0.45-1-1c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1c0 0.55-0.45 1-1 1z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m45.62 23.41c1.06 0.3 1.79 1 1.79 1.77c0 1.07-1.37 1.94-3.07 1.94c-1.7 0-3.06-0.87-3.06-1.94c0-0.79 0.73-1.47 1.79-1.77"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m46.63 20.16c0 2.55-2.29 5-2.29 5c0 0-2.28-2.47-2.28-5c-0.04-0.63 0.18-1.25 0.61-1.72c0.43-0.46 1.04-0.73 1.67-0.73c0.63 0 1.24 0.26 1.67 0.73c0.43 0.46 0.65 1.08 0.61 1.72v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m44.34 21.16c-0.55 0-1-0.45-1-1c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1c0 0.55-0.45 1-1 1z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m12.45 33.31c1.06 0.31 1.79 1 1.79 1.77c0 1.08-1.37 2-3.06 2c-1.69 0-3.07-0.87-3.07-2c0-0.78 0.73-1.46 1.79-1.77"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m13.46 30.07c0 2.55-2.28 5-2.28 5c0 0-2.29-2.46-2.29-5c-0.04-0.63 0.18-1.25 0.61-1.72c0.43-0.46 1.04-0.73 1.67-0.73c0.63 0 1.24 0.26 1.67 0.73c0.43 0.46 0.65 1.08 0.61 1.72v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m11.18 31.07c-0.55 0-1-0.45-1-1c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1c0 0.55-0.45 1-1 1z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m48.58 46.83c1.06 0.3 1.79 1 1.79 1.77c0 1.07-1.37 1.95-3.06 1.95c-1.69 0-3.07-0.88-3.07-1.95c0-0.79 0.73-1.47 1.79-1.77"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m49.59 43.58c0 2.55-2.28 5-2.28 5c0 0-2.31-2.45-2.31-5c0.04-0.58 0.3-1.12 0.72-1.52c0.42-0.4 0.98-0.62 1.56-0.62c0.58 0 1.14 0.22 1.56 0.62c0.42 0.4 0.68 0.94 0.72 1.52h0.02z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m47.31 44.58c-0.55 0-1-0.45-1-1c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1c0 0.55-0.45 1-1 1z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m19.54 63.84c1.06 0.31 1.8 1 1.8 1.77c0 1.08-1.38 2-3.07 2c-1.69 0-3.07-0.87-3.07-2c0-0.78 0.74-1.46 1.8-1.77"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m20.56 60.6c0 2.55-2.29 5-2.29 5c0 0-2.27-2.45-2.27-5c0-0.61 0.24-1.19 0.67-1.62c0.43-0.43 1.01-0.67 1.62-0.67c0.61 0 1.19 0.24 1.62 0.67c0.43 0.43 0.67 1.01 0.67 1.62h-0.02z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m18.27 61.6c-0.55 0-1-0.45-1-1c0-0.55 0.45-1 1-1c0.55 0 1 0.45 1 1c0 0.55-0.45 1-1 1z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m29.4 12c-1.89 6.48 11.68 8.22 10.32 13.8c-1.36 5.58-27.89 5.8-23.44 11.31c4.45 5.51 28 6.59 26.4 12.79c-1.6 6.2-21.58 14.96-21.58 14.96"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export const ToDu = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 53 52"}>
      <g id="Layer">
        <g id="Background">
          <path
            id="Layer"
            d="m15.98 38.05l-7.25 4.05l-7.26-4.05l7.26-4.05l7.25 4.05v0z"
          />
          <path id="Layer" d="m1.47 38.05l7.26 4.05v8.36l-7.26-4.05v-8.36v0z" />
          <path
            id="Layer"
            d="m15.98 38.05v8.36l-7.25 4.05v-8.36l7.25-4.05v0z"
          />
          <path
            id="Layer"
            d="m31.1 33.28c-0.08-0.06-0.15-0.14-0.21-0.22c-0.06-0.08-0.11-0.17-0.15-0.26c-0.04-0.09-0.06-0.19-0.07-0.29c-0.01-0.1-0.01-0.2 0.01-0.3c0.18-0.66 0.09-1.07 0.29-1.3c0.1-0.17 0.18-0.34 0.26-0.52c0.08-0.18 0.15-0.36 0.22-0.54c0.06-0.18 0.12-0.37 0.17-0.56c0.05-0.19 0.09-0.38 0.12-0.57c-0.08-0.31 0.95-0.68 1-1c0.05-0.32-0.67-0.63-1.45-0.63l-0.41-0.6l-0.37 0.3l-0.89-0.05c0 0-0.02-0.56-0.3-0.36c-0.28 0.2-0.35 0.57-0.53 0.11c-0.18-0.46-0.46-1.22-0.83-1.3c-0.37-0.08-0.04-0.78 0.22-1.34c0 0-1.89-1.61-0.38-2.68c0 0 0.3-0.46 0-0.59c-0.3-0.13-0.61-0.42-0.53-0.65c0.08-0.23-0.41-0.93-0.26-1.23c0.15-0.3-0.39-0.69 0-1c0.1-0.09 0.19-0.19 0.28-0.3c0.08-0.11 0.16-0.22 0.22-0.35c0.06-0.12 0.11-0.25 0.15-0.38c0.04-0.13 0.07-0.26 0.08-0.4c-0.07-0.32-1.09-1.72-0.18-1.9c0.91-0.18 1.51 0.07 1.62-0.13c0.11-0.2 0.03-0.72 0.31-0.91c0.28-0.19 0.83-0.81 0.48-1c-0.35-0.19-0.93-0.13-0.89-0.45c0.04-0.32 0.02-0.94 0.51-0.91c0.49 0.03 0.78-0.11 0.76-0.82c-0.02-0.71 0.4-1.18 0.29-1.66c-0.11-0.48-0.07-1.11-0.35-1.11c-0.28 0-0.6 0.15-0.71-0.19c-0.11-0.34-0.41-0.59 0.3-0.63c0.71-0.04 0.92-0.56 1.83-0.43c0.91 0.13 1.36-0.49 1.56 0.22c0.2 0.71 0.74 0.65 0.74 0.65c0 0 0.11-1.15 0.61-1.18c0.5-0.03 0.7-0.26 0.5-0.64c-0.2-0.38-0.32-0.52-0.29-0.67c0.03-0.15-0.66-0.19-0.62-0.45c0.04-0.26 0.58-0.56 0.17-0.82c-0.41-0.26-0.77-0.67-0.69-0.78c0.08-0.11-0.1-1.16 0.08-1.25c0.18-0.09 0.08-0.96 0.54-0.59c0.46 0.37 0.26 0.59 0.52 0.7c0.15 0.03 0.31 0.05 0.46 0.09c0.15 0.03 0.3 0.06 0.46 0.1c0.15 0.03 0.3 0.07 0.45 0.11c0.15 0.04 0.3 0.08 0.45 0.12c0.02 0.1 0.53-0.69 0.74-0.37c0.21 0.32 0.68-0.05 0.91 0.69c0.23 0.74-0.25 0.75 0.23 1.1c0.48 0.35 1.51 0.99 1.62 0.79c0.11-0.2 0.35-1 0.7-1c0.35 0 1.02 0.2 1 0.63c-0.02 0.43-0.6 0.33-0.65 0.43c-0.05 0.1-0.09 0.19-0.14 0.29c-0.05 0.09-0.1 0.19-0.15 0.28c-0.05 0.09-0.1 0.19-0.16 0.28c-0.05 0.09-0.11 0.18-0.17 0.27c-0.08 0.08 1.09 0.23 1.24 0.31c0.15 0.08 0.04-0.74 0.54-0.85c0.5-0.11 0.99 0.16 1.25-0.32c0.26-0.48 0.77-1.21 1-1.21c0.23 0 1.06 0.26 1.23 0c0.17-0.26 0.27-1.2 0.82-1c0.55 0.2 0.19-0.19 0.55 0.2c0.36 0.39 0.67 0.21 0.56 0.75c-0.11 0.54-0.63 0.68-0.59 1c0.04 0.32 0 0.34 0.52 0.32c0.52-0.02 1.34 0.32 1.34 0.6c0.01 0.07 0.01 0.14 0.02 0.21c0.01 0.07 0.02 0.14 0.03 0.2c0.01 0.07 0.03 0.13 0.04 0.2c0.02 0.07 0.03 0.13 0.05 0.2c-0.45 0.12-1.01 0.27-0.45 0.27c0.56 0 0.74-0.39 0.89 0.76c0.15 1.15 0.58 2.19 0.15 2.64c-0.43 0.45-0.5 0.8-0.11 0.95c0.39 0.15 1.17 1.31 0.93 1.76c-0.24 0.45 0.46 0.51 0.46 0.9c0 0.39-0.2 1.13 0 1.54c0.03 0.06 0.06 0.13 0.08 0.2c0.02 0.07 0.05 0.13 0.07 0.2c0.02 0.07 0.04 0.14 0.05 0.21c0.01 0.07 0.02 0.14 0.03 0.21c0.09 0.34 0.66 0.62 0.69 0.93c0.03 0.31 0.25 0.15 0.18 0.8c-0.07 0.65-0.51 2.08-0.72 2.08c-0.21 0-0.75-0.95-0.95-0.91c-0.2 0.04-0.04 0.27 0 0.37c0.04 0.1-0.26-0.14-0.58 0.24c-0.32 0.38-0.85 0.51-1 0.75c-0.15 0.24-0.66 0.1-0.84 0.45c-0.18 0.35-0.8-0.13-0.93 0.35c-0.13 0.48-0.88 0.69-1.23 0.67c-0.35-0.02-1.22 0.08-1.11 0.58c0.11 0.5 0.89 1.26 0.79 1.5c-0.03 0.12-0.04 0.24-0.05 0.37c-0.01 0.12 0 0.25 0.02 0.37c0.02 0.12 0.04 0.24 0.08 0.36c0.04 0.12 0.08 0.23 0.14 0.34c0.06 0.1 0.13 0.19 0.21 0.27c0.08 0.08 0.16 0.16 0.26 0.23c0.09 0.07 0.19 0.13 0.3 0.17c0.1 0.05 0.21 0.09 0.32 0.11c0.73 0.17 1.07 1.33 1.29 1.44c0.22 0.11 0.48-0.21 0.74 0.29c0.26 0.5 0.74 0.51 0.62 1.25c-0.01 0.11-0.05 0.22-0.11 0.32c-0.06 0.1-0.14 0.18-0.24 0.24c-0.1 0.06-0.21 0.09-0.32 0.1c-0.11 0.01-0.23-0.01-0.33-0.05c0 0-0.53 1.15-0.97 1.32c-0.44 0.17-1 0.39-1 0.63c0.05 0.11 0.1 0.22 0.15 0.34c0.05 0.11 0.09 0.23 0.13 0.35c0.04 0.12 0.07 0.24 0.11 0.35c0.03 0.12 0.06 0.24 0.08 0.36c0 0 0.58 0.47 0.4 1c-0.18 0.53-0.57 0.8-1.31-0.3c-0.03 0.02-0.07 0.05-0.11 0.07c-0.04 0.02-0.08 0.04-0.12 0.05c-0.04 0.02-0.08 0.03-0.12 0.04c-0.04 0.01-0.08 0.02-0.13 0.02c-0.33 0.04-0.55-0.57-0.9-0.15c-0.35 0.42-0.94 0.23-1.26 0.42c-0.1 0.08-0.2 0.15-0.3 0.22c-0.1 0.07-0.21 0.14-0.32 0.2c-0.11 0.06-0.22 0.12-0.34 0.17c-0.12 0.05-0.23 0.1-0.35 0.14c-0.11 0.02-0.22 0.03-0.33 0.05c-0.11 0.01-0.22 0.03-0.33 0.04c-0.11 0.01-0.22 0.02-0.34 0.03c-0.11 0.01-0.22 0.01-0.34 0.02c0 0-0.56-0.79-1-0.45c-0.44 0.34-0.61 1.1-0.93 1.1c-0.32 0-0.61-0.65-1-1"
          />
          <path
            fill="#20AAE2"
            id="Layer"
            d="m41.48 22.05c-1.09 23.09-22.89 18.09-22.89 18.09c17.13-3.05 16.7-18.64 16.7-18.64l-2.24-0.2l5.78-6.3l4.58 7.22l-1.93-0.17z"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export const SchedualIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox={"0 0 66 27"}>
      <g id="Layer">
        <g id="Layer_1">
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m24.95 26.38c-1.39 0-2.51-1.12-2.51-2.51c0-1.39 1.12-2.51 2.51-2.51c1.39 0 2.51 1.12 2.51 2.51c0 1.39-1.12 2.51-2.51 2.51z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m25 25.06c-0.48 0-0.92-0.29-1.1-0.73c-0.18-0.44-0.08-0.96 0.26-1.3c0.34-0.34 0.85-0.44 1.3-0.26c0.44 0.18 0.73 0.62 0.73 1.1c0 0.16-0.03 0.31-0.09 0.46c-0.06 0.14-0.15 0.28-0.26 0.39c-0.11 0.11-0.24 0.2-0.39 0.26c-0.14 0.06-0.3 0.09-0.46 0.09v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m14.85 4.34h34l9.21 9.24c0.21 0.21 0.43 0.4 0.66 0.58c0.23 0.18 0.48 0.34 0.73 0.49c0.25 0.15 0.51 0.28 0.78 0.4c0.27 0.12 0.54 0.22 0.83 0.3c0.19 0.05 0.38 0.11 0.56 0.18c0.19 0.06 0.37 0.13 0.55 0.21c0.18 0.07 0.36 0.15 0.54 0.23c0.18 0.08 0.36 0.17 0.53 0.26c0.23 0.12 0.44 0.28 0.63 0.46c0.19 0.18 0.35 0.39 0.49 0.61c0.13 0.22 0.24 0.47 0.31 0.72c0.07 0.25 0.11 0.51 0.11 0.77v4.88h-3.21c-0.07-0.91-0.48-1.75-1.14-2.37c-0.67-0.62-1.54-0.96-2.45-0.96c-0.91 0-1.78 0.34-2.45 0.96c-0.67 0.62-1.07 1.46-1.14 2.37h-25.81c-0.05-0.92-0.45-1.78-1.11-2.42c-0.67-0.63-1.55-0.99-2.47-0.99c-0.92 0-1.8 0.35-2.47 0.99c-0.67 0.63-1.07 1.5-1.11 2.42h-16v-10.9"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m57.98 26.38c-1.39 0-2.51-1.12-2.51-2.51c0-1.39 1.12-2.51 2.51-2.51c1.39 0 2.51 1.12 2.51 2.51c0 1.39-1.12 2.51-2.51 2.51z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m58 25.06c-0.48 0-0.92-0.29-1.1-0.73c-0.18-0.44-0.08-0.96 0.26-1.3c0.34-0.34 0.85-0.44 1.3-0.26c0.44 0.18 0.73 0.62 0.73 1.1c0 0.16-0.03 0.31-0.09 0.46c-0.06 0.14-0.15 0.28-0.26 0.39c-0.11 0.11-0.24 0.2-0.39 0.26c-0.14 0.06-0.3 0.09-0.46 0.09z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m64.78 19.04h-57.87v-6.28"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m51.75 7.23h-36.89"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m6.91 13.27v5.77l-1.5 1.68"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m6.9 15.79l-1.49-1.16"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m25.87 15.49h11v1.17h-11v-1.17z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m59.63 14.73h-8c-0.3 0-0.59-0.06-0.87-0.17c-0.28-0.11-0.53-0.28-0.74-0.49c-0.21-0.21-0.38-0.46-0.49-0.74c-0.11-0.28-0.17-0.57-0.17-0.87v-3.05h4.56"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m4.21 23.66v-0.86l1.2-0.65v1.51h-1.2v0z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m46.75 15.95h0.75v1.69h-0.75v-1.69z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m48.98 15.95h0.75v1.69h-0.75v-1.69z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m4.73 1.74h6.28"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m11 12.76h-9c-0.15 0-0.29-0.03-0.42-0.08c-0.13-0.06-0.26-0.14-0.36-0.24c-0.1-0.1-0.18-0.23-0.24-0.36c-0.06-0.13-0.08-0.28-0.08-0.42v-8.81c0-0.14 0.03-0.29 0.09-0.42c0.06-0.13 0.14-0.25 0.24-0.36c0.1-0.1 0.22-0.18 0.36-0.24c0.13-0.06 0.28-0.08 0.42-0.08h0.84"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m12.91 1.74h0.85c0.14 0 0.29 0.03 0.42 0.08c0.13 0.06 0.25 0.14 0.36 0.24c0.1 0.1 0.18 0.22 0.24 0.36c0.06 0.13 0.08 0.28 0.08 0.42v6"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m11.01 1.2c0-0.36 0.29-0.65 0.65-0.65h0.6c0.36 0 0.65 0.29 0.65 0.65v1.07c0 0.36-0.29 0.65-0.65 0.65h-0.6c-0.36 0-0.65-0.29-0.65-0.65v-1.07z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m2.83 1.2c0-0.36 0.29-0.65 0.65-0.65h0.6c0.36 0 0.65 0.29 0.65 0.65v1.07c0 0.36-0.29 0.65-0.65 0.65h-0.6c-0.36 0-0.65-0.29-0.65-0.65v-1.07z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m14.21 15.44c-1.84 0-3.33-1.49-3.33-3.33c0-1.84 1.49-3.33 3.33-3.33c1.84 0 3.33 1.49 3.33 3.33c0 1.84-1.49 3.33-3.33 3.33z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m0.88 4.34h13.98"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m2.19 5.96h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m5.45 5.96h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m8.7 5.96h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m11.96 5.96h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m2.19 9.55h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m5.45 9.55h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m8.7 9.55h1.59v1.59h-1.59v-1.59z"
          />
          <path
            id="Layer"
            className={props.active ? "s1" : "s0"}
            d="m15.42 13.32l-1.21-1.21v-1.92"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
